/* dc-crib-builder.js GENERATED by crib-builder/build.py - do not edit, edit src/ and rebuild | builder 1.1.0 | parts.json baked 2026-09-29 | sources f4fbc1a8a97c */
/* parts.json 565341135cfe */
window.DCCribData = {"schema":"dc-crib-parts/1","version":"1.1.0","bakedAt":"2026-09-29","currency":"USD","about":["Single source of data for the Hollis CRIB builder on divecatalog.com. Read by src/crib-core.js (DCCrib.DATA).","State values are Hollis builder names: wing \"ST 35\", harness \"ELITE MD LG\", tankBands/backplate \"STAINLESS STEEL\", colours \"blue|red|black|lime|camo|pink|aqua\".","Add-ons are stored in state by the short id used as the key in options.addons (the Hollis data-item name in hollisKey is accepted as an alias).","baked.products uses the same shape as /products/\u003chandle\u003e.js (subset), prices in cents. It is a first-paint fallback only. Live values replace it at runtime.","hollis.* is an exact copy of the tables in tools/hollis_link.py (ids, names and HOLLIS prices as strings). Never show Hollis prices to shoppers.","Parts are resolved by SKU, never by variant title."],"rigOrder":["single","double","sidemount"],"rigs":{"single":{"key":"single","label":"Single Tank","hollisName":"Single Tank","hollisSlug":"single-tank","steps":["wing","harness","tankBands","backplate","colors","addons","summary"],"wings":["ST 22","ST 35"],"harnesses":["SOLO","ELITE XS SM","ELITE MD LG","ELITE XL XXL"],"tankBands":["DELRIN","STAINLESS STEEL"],"backplates":["ALUMINUM","STAINLESS STEEL"],"colorZones":["wing","backpad","shoulder"],"weightPockets":true,"addons":["trim_pockets","sta_v2","mask_pocket"]},"double":{"key":"double","label":"Double Tank","hollisName":"Double Tank","hollisSlug":"double-tank","steps":["wing","harness","backplate","colors","addons","summary"],"wings":["DT 45 DUAL","DT 50"],"harnesses":["SOLO","ELITE XS SM","ELITE MD LG","ELITE XL XXL"],"tankBands":[],"backplates":["ALUMINUM","STAINLESS STEEL"],"colorZones":["wing","backpad","shoulder"],"weightPockets":false,"addons":["mask_pocket"]},"sidemount":{"key":"sidemount","label":"Sidemount","hollisName":"Sidemount","hollisSlug":"sidemount","steps":["wing","colors","addons","summary"],"wings":["Katana 2 Single","Katana 2 Dual"],"harnesses":[],"tankBands":[],"backplates":[],"colorZones":["wing"],"weightPockets":false,"addons":["katana_butt_plate","storage_pocket","sms_mains_rigging_kit","rubber_tank_wrap_kit"]}},"steps":{"wing":{"label":"Wing","hollisLabel":"Wings"},"harness":{"label":"Harness","hollisLabel":"Harness"},"tankBands":{"label":"Tank bands","hollisLabel":"Tank Bands","note":"Sold in pairs"},"backplate":{"label":"Backplate","hollisLabel":"Backplate"},"colors":{"label":"Colors","hollisLabel":"Colors"},"addons":{"label":"Add-ons","hollisLabel":"Add-ons"},"summary":{"label":"Summary","hollisLabel":"Summary"}},"roles":{"wing":{"label":"Wing"},"harness":{"label":"Harness"},"tankBands":{"label":"Tank bands"},"backplate":{"label":"Backplate"},"backpad":{"label":"Backpad"},"shoulderPads":{"label":"Shoulder pads"},"weightPockets":{"label":"Weight pockets"},"addon":{"label":"Add-on"},"assembly":{"label":"Custom assembly"}},"colorOrder":["blue","red","black","lime","camo","pink","aqua"],"colors":{"blue":{"key":"blue","hollis":"blue","label":"Blue","code":"01","hex":"#0d6fd6","css":"#0d6fd6","guideImage":"c-blue.jpg"},"red":{"key":"red","hollis":"red","label":"Red","code":"04","hex":"#cd2627","css":"#cd2627","guideImage":"c-red.jpg"},"black":{"key":"black","hollis":"black","label":"Black","code":"07","hex":"#323235","css":"#323235","guideImage":"c-black.jpg"},"lime":{"key":"lime","hollis":"lime","label":"Lime","code":"18","hex":"#26ca37","css":"#26ca37","guideImage":"c-lime.jpg"},"camo":{"key":"camo","hollis":"camo","label":"Multicam","code":"69","hex":"#85806a","css":"repeating-linear-gradient(115deg, #6f6b55 0 7px, #a79f82 7px 13px, #85806a 13px 19px, #c3bb9e 19px 23px)","pattern":true,"guideImage":"c-multicam.jpg"},"pink":{"key":"pink","hollis":"pink","label":"Pink","code":"78","hex":"#ee5ea4","css":"#ee5ea4","guideImage":"c-pink.jpg"},"aqua":{"key":"aqua","hollis":"aqua","label":"Aqua","code":"89","hex":"#1ac6cc","css":"#1ac6cc","guideImage":"c-aqua.jpg"}},"zones":{"wing":{"key":"wing","field":"wingColor","role":"wing","label":"Wing","hollisLabel":"Wing","hollisSummaryLabel":"Wing Colors"},"backpad":{"key":"backpad","field":"backpadColor","role":"backpad","label":"Backpad","hollisLabel":"Backpad","hollisSummaryLabel":"Backpad"},"shoulder":{"key":"shoulder","field":"shoulderColor","role":"shoulderPads","label":"Shoulder pads","hollisLabel":"Shoulder","hollisSummaryLabel":"Shoulder Colors"},"weightPockets":{"key":"weightPockets","field":"weightPockets","role":"weightPockets","label":"Weight pockets","hollisLabel":"Weight Pockets","hollisSummaryLabel":"Weight Pockets","optional":true,"question":"Add weight pockets?"}},"options":{"wing":{"ST 22":{"hollis":"ST 22","rig":"single","label":"ST 22","shopperLabel":"ST 22 wing","handle":"hollis-crib-custom-st-22-wing","skuPattern":"208.1254.022.{cc}","colors":["blue","red","black","lime","camo","pink","aqua"],"facts":["22 lb lift"],"image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-st-22-wing-black.jpg?v=1779483242","guideImage":"w-st22.jpg"},"ST 35":{"hollis":"ST 35","rig":"single","label":"ST 35","shopperLabel":"ST 35 wing","handle":"hollis-crib-custom-st-35-wing","skuPattern":"208.1254.035.{cc}","colors":["blue","red","black","lime","camo","pink","aqua"],"facts":["35 lb lift"],"image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-st-35-wing-blackwebp.jpg?v=1779483510","guideImage":"w-st35.jpg"},"DT 45 DUAL":{"hollis":"DT 45 DUAL","rig":"double","label":"DT 45 Dual","shopperLabel":"DT 45 Dual wing","handle":"hollis-crib-custom-dt-45-dual-wing","skuPattern":"208.1254.045.{cc}","colors":["blue","red","black","lime","camo","pink","aqua"],"facts":["45 lb lift","Dual bladder"],"image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-dt-45-dual-wing-black.jpg?v=1779483722","guideImage":"w-dt45.jpg"},"DT 50":{"hollis":"DT 50","rig":"double","label":"DT 50","shopperLabel":"DT 50 wing","handle":"hollis-crib-custom-dt-50-wing","skuPattern":"208.1254.052.{cc}","colors":["blue","red","black","lime","camo","pink","aqua"],"facts":["50 lb lift"],"image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-dt-50-wing-black.jpg?v=1779484308","guideImage":"w-dt50.jpg"},"Katana 2 Single":{"hollis":"Katana 2 Single","rig":"sidemount","label":"Katana 2 Single","shopperLabel":"Katana 2 Single wing","handle":"hollis-crib-custom-katana-2-single-wing","skuPattern":"208.1381.{cc}","colors":["blue","red","black","lime","camo","pink"],"facts":["Sidemount","6 colors"],"image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis-CRIB-Katana2-Black-Back.png?v=1778008927","guideImage":"w-katana1.jpg"},"Katana 2 Dual":{"hollis":"Katana 2 Dual","rig":"sidemount","label":"Katana 2 Dual","shopperLabel":"Katana 2 Dual wing","handle":"hollis-crib-custom-katana-2-dual-wing","skuPattern":"208.1382.{cc}","colors":["blue","red","black","lime","camo","pink"],"facts":["Sidemount","6 colors"],"image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis-CRIB-Katana2-Dual-Black-Back.png?v=1778009329","guideImage":"w-katana2.jpg"}},"harness":{"SOLO":{"hollis":"SOLO","family":"Solo","size":null,"dcSize":null,"hollisNice":"Solo","label":"Solo","shopperLabel":"Solo harness","facts":["One size","Continuous webbing"],"handle":"hollis-crib-custom-solo-harness","sku":"208.1260.B","image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis_SoloHarness_StainlessSteelBackplate.jpg?v=1778013216","guideImage":"h-solo.jpg","shoulder":{"style":"solo","label":"Shoulder pads (Solo)","handle":"hollis-crib-custom-shoulder-pad-solo-style","skuPattern":"208.1269.{cc}","guideImage":"p-solo.jpg"}},"ELITE XS SM":{"hollis":"ELITE XS SM","family":"Elite 2","size":"XS/S","dcSize":"XS/SM","hollisNice":"Elite 2 XS/S","label":"Elite 2, XS/S","shopperLabel":"Elite 2 harness XS/S","facts":["Padded","Size XS/S","Listed in the cart as XS/SM"],"handle":"hollis-crib-custom-elite-2-harness","sku":"208.1222.001.B","image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis_Elite2Harness_SSBackplate_web.png?v=1777937848","guideImage":"h-elite.jpg","shoulder":{"style":"elite","label":"Shoulder pads (Elite 2 XS/S)","handle":"hollis-crib-custom-shoulder-pad-elite-style","skuPattern":"208.1270.{cc}","guideImage":"p-elite.jpg"}},"ELITE MD LG":{"hollis":"ELITE MD LG","family":"Elite 2","size":"M/L","dcSize":"MD/LG","hollisNice":"Elite 2 M/L","label":"Elite 2, M/L","shopperLabel":"Elite 2 harness M/L","facts":["Padded","Size M/L","Listed in the cart as MD/LG"],"handle":"hollis-crib-custom-elite-2-harness","sku":"208.1222.003.B","image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis_Elite2Harness_SSBackplate_web.png?v=1777937848","guideImage":"h-elite.jpg","shoulder":{"style":"elite","label":"Shoulder pads (Elite 2 M/L)","handle":"hollis-crib-custom-shoulder-pad-elite-style","skuPattern":"208.1271.{cc}","guideImage":"p-elite.jpg"}},"ELITE XL XXL":{"hollis":"ELITE XL XXL","family":"Elite 2","size":"XL/XXL","dcSize":"XL/3XL","hollisNice":"Elite 2 XL/XXL","label":"Elite 2, XL/XXL","shopperLabel":"Elite 2 harness XL/XXL","facts":["Padded","Size XL/XXL","Listed in the cart as XL/3XL"],"handle":"hollis-crib-custom-elite-2-harness","sku":"208.1222.005.B","image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis_Elite2Harness_SSBackplate_web.png?v=1777937848","guideImage":"h-elite.jpg","shoulder":{"style":"elite","label":"Shoulder pads (Elite 2 XL/XXL)","handle":"hollis-crib-custom-shoulder-pad-elite-style","skuPattern":"208.1272.{cc}","guideImage":"p-elite.jpg"}}},"tankBands":{"DELRIN":{"hollis":"DELRIN","label":"Delrin","shopperLabel":"Delrin tank bands (pair)","facts":["Sold as a pair"],"handle":"hollis-cam-band-delrin-par","sku":"208.1070.020.PR","image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/1722375.jpg?v=1779321575","guideImage":"cb-delrin.jpg"},"STAINLESS STEEL":{"hollis":"STAINLESS STEEL","label":"Stainless Steel","shopperLabel":"Stainless Steel tank bands (pair)","facts":["Sold as a pair"],"handle":"hollis-cam-band-stainless-pair","sku":"208.1070.010.PR","image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/1722374.jpg?v=1779321496","guideImage":"cb-ss.jpg"}},"backplate":{"ALUMINUM":{"hollis":"ALUMINUM","label":"Aluminum","shopperLabel":"Aluminum backplate","facts":[],"handle":"hollis-aluminum-backplate-20-bcd-accessory","sku":"208.1291.000","image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/products/hollis-aluminum-backplate-2_0-bcd-accessory.jpg?v=1743747258","guideImage":"b-alu.jpg"},"STAINLESS STEEL":{"hollis":"STAINLESS STEEL","label":"Stainless Steel","shopperLabel":"Stainless Steel backplate","facts":[],"handle":"hollis-stainless-steel-backplate-20-bcd-accessory","sku":"208.1296.000","image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/products/open-box-hollis-stainless-steel-backplate-2_0-bcd-accessory.png?v=1743771124","guideImage":"b-ss.jpg"}},"backpad":{"label":"Backpad","shopperLabel":"Backpad","handle":"hollis-crib-custom-backpad-2-0","skuPattern":"208.1267.{cc}","colors":["blue","red","black","lime","camo","pink","aqua"],"guideImage":"p-backpad.jpg"},"weightPockets":{"label":"Weight pockets","shopperLabel":"Weight pockets","handle":"hollis-crib-custom-lx2-weight-system","skuPattern":"208.0016.{cc}","colors":["blue","red","black","lime","camo","pink","aqua"],"guideImage":"p-lx2.jpg"},"addons":{"trim_pockets":{"id":"trim_pockets","hollisKey":"5lb_non-ditchable_trim_weight_pockets_(pair)","hollisName":"5lb Non-Ditchable Trim Weight Pockets (PAIR)","label":"5 lb Non-Ditchable Trim Weight Pockets (pair)","facts":["Sold as a pair"],"handle":"hollis-5-lb-non-ditchable-optional-pockets-bcd-accessory","sku":"208.0030.000","variantId":40329667412168,"image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/products/hollis-5-lb-non-ditchable-optional-pockets-bcd-accessory.jpg?v=1662683295"},"sta_v2":{"id":"sta_v2","hollisKey":"single_tank_adapter_w/bolts_\u0026_nuts,_v2","hollisName":"SINGLE TANK ADAPTER W/BOLTS \u0026 NUTS, V2","label":"Single Tank Adapter V2 with Bolts and Nuts","facts":[],"handle":"hollis-single-tank-adapter-w-bolts-and-nuts-v2-bcd-accessory","sku":"208.1071.001","variantId":40329798287560,"image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-single-tank-adapter-w-bolts-and-nuts-v2-bcd-accessory.jpg?v=1743747297"},"mask_pocket":{"id":"mask_pocket","hollisKey":"mask_pocket","hollisName":"Mask Pocket","label":"Mask Pocket","facts":[],"handle":"hollis-mask-pocket","sku":"208.1030","variantId":42223372402909,"image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/products/open-box-hollis-mask-pocket.jpg?v=1743771117"},"katana_butt_plate":{"id":"katana_butt_plate","hollisKey":"katana_butt_plate","hollisName":"Katana Butt Plate","label":"Katana Butt Plate","facts":[],"handle":"hollis-sms-katana-2-butt-plate-tech-bcd-accessory","sku":"208.1265","variantId":40329823781064,"image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/products/hollis-sms-katana-2-butt-plate-tech-bcd-accessory.jpg?v=1662683392"},"storage_pocket":{"id":"storage_pocket","hollisKey":"storage_pocket_with_ss_snaps","hollisName":"Storage Pocket with SS Snaps","label":"Storage Pocket with SS Snaps","facts":[],"handle":"hollis-storage-pocket-with-ss-snaps-tech-bcd-accessory","sku":"208.1266","variantId":35908625498280,"image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/products/open-box-hollis-storage-pocket-with-ss-snaps-tech-bcd-accessory.jpg?v=1743771121"},"sms_mains_rigging_kit":{"id":"sms_mains_rigging_kit","hollisKey":"sms_mains_rigging_kit","hollisName":"SMS MAINS RIGGING KIT","label":"SMS Mains Rigging Kit","facts":[],"handle":"hollis-sms-mains-rigging-kit","sku":"240.1550","variantId":42223385870557,"image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/products/open-box-hollis-sms-mains-rigging-kit.jpg?v=1743771136"},"rubber_tank_wrap_kit":{"id":"rubber_tank_wrap_kit","hollisKey":"rubber_tank_wrap_kit_(pair)","hollisName":"RUBBER TANK WRAP KIT (PAIR)","label":"Rubber Tank Wrap Kit (pair)","facts":["Sold as a pair"],"handle":"hollis-rubber-tank-wrap-kit-bcd-accessory","sku":"208.1322","variantId":40329795633352,"image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/products/hollis-rubber-tank-wrap-kit-bcd-accessory.jpg?v=1662683375"}}},"assembly":{"role":"assembly","label":"Custom assembly","hollisName":"Custom Assembly Charge","handle":"hollis-crib-custom-assembly-charge","sku":"HOLCRIB-ASSEMBLY","exists":false,"note":"Product does not exist yet. The line is added only when the catalog passed to DCCrib.resolve contains an available assembly product (handle from the section setting assembly_handle, or this SKU)."},"sizeChart":{"title":"Elite 2 harness size chart","source":"Hollis CRIB builder, Harness step (read 2026-09-29)","units":"imperial","columns":[{"key":"size","label":"Size"},{"key":"height","label":"Height"},{"key":"weight","label":"Weight (lb)"},{"key":"chest","label":"Chest (in)"},{"key":"waist","label":"Waist (in)"}],"rows":[{"hollis":"ELITE XS SM","size":"XS/S","hollisSize":"XS/SM","height":"5'0\" to 5'7\"","weight":"100 to 155","chest":"28 to 40","waist":"26 to 38"},{"hollis":"ELITE MD LG","size":"M/L","hollisSize":"MD/LG","height":"5'7\" to 6'2\"","weight":"150 to 210","chest":"34 to 48","waist":"32 to 42"},{"hollis":"ELITE XL XXL","size":"XL/XXL","hollisSize":"XL/XXL","height":"6'2\" to 6'5\"","weight":"210 to 300","chest":"40 to 50","waist":"38 to 48"}]},"cart":{"mainProperties":["CRIB Build ID","Build","Colors","Add-ons","_Hollis order sheet","_Hollis builder link","_CRIB config","_Build total","_Builder"],"partProperties":["Part of CRIB Build","Part"],"buildIdPrefix":"CRIB-","buildIdAlphabet":"23456789ABCDEFGHJKLMNPQRSTUVWXYZ","buildIdLength":6,"configVersion":"v1","omitLink":false,"omitSheet":false},"baked":{"source":"research/raw/*.js (storefront, 2026-09-29) and a read-only Admin API product search (backplates, add-ons, 2026-09-29)","products":{"hollis-crib-custom-st-22-wing":{"id":9484225347805,"handle":"hollis-crib-custom-st-22-wing","title":"Hollis CRIB Custom ST 22 Wing","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-st-22-wing-black.jpg?v=1779483242","variants":[{"id":47879536410845,"sku":"208.1254.022.07","title":"Black","price":39995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-st-22-wing-black.jpg?v=1779483242"}},{"id":47879536443613,"sku":"208.1254.022.04","title":"Red","price":39995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-st-22-wing-red.jpg?v=1779568813"}},{"id":47879536476381,"sku":"208.1254.022.18","title":"Lime","price":39995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-st-22-wing-lime.jpg?v=1779483242"}},{"id":47879536509149,"sku":"208.1254.022.01","title":"Blue","price":39995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-st-22-wing-blue.jpg?v=1779483242"}},{"id":47879536541917,"sku":"208.1254.022.69","title":"Multicam","price":39995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-st-22-wing-multicam.jpg?v=1779483242"}},{"id":47879536574685,"sku":"208.1254.022.89","title":"Aqua","price":39995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-st-22-wing-aqua.jpg?v=1779483242"}},{"id":47879536607453,"sku":"208.1254.022.78","title":"Pink","price":39995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-st-22-wing-pink.jpg?v=1779483242"}}]},"hollis-crib-custom-st-35-wing":{"id":9484245303517,"handle":"hollis-crib-custom-st-35-wing","title":"Hollis CRIB Custom ST 35 Wing","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-st-35-wing-blackwebp.jpg?v=1779483510","variants":[{"id":47879661453533,"sku":"208.1254.035.07","title":"Black","price":39995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-st-35-wing-blackwebp.jpg?v=1779483510"}},{"id":47879661486301,"sku":"208.1254.035.04","title":"Red","price":39995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-st-35-wing-redwebp.jpg?v=1779568908"}},{"id":47879661519069,"sku":"208.1254.035.18","title":"Lime","price":39995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-st-35-wing-limewebp.jpg?v=1779483510"}},{"id":47879661551837,"sku":"208.1254.035.01","title":"Blue","price":39995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-st-35-wing-blue.jpg?v=1779483510"}},{"id":47879661584605,"sku":"208.1254.035.69","title":"Multicam","price":39995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-st-35-wing-multicam.jpg?v=1779483510"}},{"id":47879661617373,"sku":"208.1254.035.89","title":"Aqua","price":39995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-st-35-wing-aqua.jpg?v=1779483511"}},{"id":47879661650141,"sku":"208.1254.035.78","title":"Pink","price":39995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-st-35-wing-pink.jpg?v=1779483510"}}]},"hollis-crib-custom-dt-45-dual-wing":{"id":9485203439837,"handle":"hollis-crib-custom-dt-45-dual-wing","title":"Hollis CRIB Custom DT 45 Dual Wing","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-dt-45-dual-wing-black.jpg?v=1779483722","variants":[{"id":47883269570781,"sku":"208.1254.045.07","title":"Black","price":64995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-dt-45-dual-wing-black.jpg?v=1779483722"}},{"id":47883269603549,"sku":"208.1254.045.04","title":"Red","price":64995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-dt-45-dual-wing-red.jpg?v=1779483722"}},{"id":47883269636317,"sku":"208.1254.045.18","title":"Lime","price":64995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-dt-45-dual-wing-lime.jpg?v=1779483722"}},{"id":47883269669085,"sku":"208.1254.045.01","title":"Blue","price":64995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-dt-45-dual-wing-blue.jpg?v=1779483722"}},{"id":47883269701853,"sku":"208.1254.045.69","title":"Multicam","price":64995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-dt-45-dual-wing-multicam.jpg?v=1779483722"}},{"id":47883269734621,"sku":"208.1254.045.89","title":"Aqua","price":64995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-dt-45-dual-wing-aqua.jpg?v=1779483722"}},{"id":47883269767389,"sku":"208.1254.045.78","title":"Pink","price":64995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-dt-45-dual-wing-pinkwebp.jpg?v=1779483722"}}]},"hollis-crib-custom-dt-50-wing":{"id":9485217857757,"handle":"hollis-crib-custom-dt-50-wing","title":"Hollis CRIB Custom DT 50 Wing","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-dt-50-wing-black.jpg?v=1779484308","variants":[{"id":47883301191901,"sku":"208.1254.052.07","title":"Black","price":47995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-dt-50-wing-black.jpg?v=1779484308"}},{"id":47883301224669,"sku":"208.1254.052.04","title":"Red","price":47995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-dt-50-wing-red.jpg?v=1779569024"}},{"id":47883301257437,"sku":"208.1254.052.18","title":"Lime","price":47995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-dt-50-wing-lime.jpg?v=1779484307"}},{"id":47883301290205,"sku":"208.1254.052.01","title":"Blue","price":47995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-dt-50-wing-bluel.jpg?v=1779484307"}},{"id":47883301322973,"sku":"208.1254.052.69","title":"Multicam","price":47995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-dt-50-wing-multicam.png?v=1779484307"}},{"id":47883301355741,"sku":"208.1254.052.89","title":"Aqua","price":47995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-dt-50-wing-aqua.jpg?v=1779484307"}},{"id":47883301388509,"sku":"208.1254.052.78","title":"Pink","price":47995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-dt-50-wing-pink.jpg?v=1779484308"}}]},"hollis-crib-custom-katana-2-single-wing":{"id":9485220348125,"handle":"hollis-crib-custom-katana-2-single-wing","title":"Hollis CRIB Custom Katana 2 Single Wing","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/imgi_13_Sidemount-Colors-2.gif?v=1778009112","variants":[{"id":47883306991837,"sku":"208.1381.07","title":"Black","price":79995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis-CRIB-Katana2-Black-Back.png?v=1778008927"}},{"id":47883307024605,"sku":"208.1381.04","title":"Red","price":79995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis-CRIB-Katana2-Red-Back.png?v=1778008927"}},{"id":47883307057373,"sku":"208.1381.18","title":"Lime","price":79995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis-CRIB-Katana2-Lime-Back.png?v=1778008927"}},{"id":47883307090141,"sku":"208.1381.01","title":"Blue","price":79995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis-CRIB-Katana2-Blue-Back.png?v=1778008927"}},{"id":47883307122909,"sku":"208.1381.69","title":"Multicam","price":79995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis-CRIB-Katana2-Camo-Back.png?v=1778008927"}},{"id":47883307188445,"sku":"208.1381.78","title":"Pink","price":79995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis-CRIB-Katana2-Pink-Back.png?v=1778008927"}}]},"hollis-crib-custom-katana-2-dual-wing":{"id":9485224214749,"handle":"hollis-crib-custom-katana-2-dual-wing","title":"Hollis CRIB Custom Katana 2 Dual Wing","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/imgi_13_Sidemount-Colors-2.gif?v=1778009112","variants":[{"id":47883321737437,"sku":"208.1382.07","title":"Black","price":92995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis-CRIB-Katana2-Dual-Black-Back.png?v=1778009329"}},{"id":47883321770205,"sku":"208.1382.04","title":"Red","price":92995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis-CRIB-Katana2-Dual-Red-Back.png?v=1778009329"}},{"id":47883321802973,"sku":"208.1382.18","title":"Lime","price":92995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis-CRIB-Katana2-Dual-Lime-Back.png?v=1778009329"}},{"id":47883321835741,"sku":"208.1382.01","title":"Blue","price":92995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis-CRIB-Katana2-Dual-Blue-Back.png?v=1778009329"}},{"id":47883321868509,"sku":"208.1382.69","title":"Multicam","price":92995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis-CRIB-Katana2-Dual-Camo-Back.png?v=1778009329"}},{"id":47883321901277,"sku":"208.1382.78","title":"Pink","price":92995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis-CRIB-Katana2-Dual-Pink-Back.png?v=1778009329"}}]},"hollis-crib-custom-solo-harness":{"id":9484241600733,"handle":"hollis-crib-custom-solo-harness","title":"Hollis CRIB Custom Solo Harness","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis_SoloHarness_StainlessSteelBackplate.jpg?v=1778013216","variants":[{"id":47879653228765,"sku":"208.1260.B","title":"Default Title","price":8995,"available":true,"featured_image":null}]},"hollis-crib-custom-elite-2-harness":{"id":9484241699037,"handle":"hollis-crib-custom-elite-2-harness","title":"Hollis CRIB Custom Elite 2 Harness","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis_Elite2Harness_SSBackplate_web.png?v=1777937848","variants":[{"id":47879653392605,"sku":"208.1222.001.B","title":"XS/SM (X-Small / Small)","price":13995,"available":true,"featured_image":null},{"id":47879653425373,"sku":"208.1222.003.B","title":"MD/LG (Medium / Large)","price":13995,"available":true,"featured_image":null},{"id":47879653458141,"sku":"208.1222.005.B","title":"XL/3XL (X-Large / 3X-Large)","price":13995,"available":true,"featured_image":null}]},"hollis-cam-band-delrin-par":{"id":9502157111517,"handle":"hollis-cam-band-delrin-par","title":"Hollis Cam Band (Delrin) - Pair","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/1722375.jpg?v=1779321575","variants":[{"id":47945537257693,"sku":"208.1070.020.PR","title":"Default Title","price":10495,"available":true,"featured_image":null}]},"hollis-cam-band-stainless-pair":{"id":9502156652765,"handle":"hollis-cam-band-stainless-pair","title":"Hollis Cam Band (Stainless) - Pair","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/1722374.jpg?v=1779321496","variants":[{"id":47945531949277,"sku":"208.1070.010.PR","title":"Default Title","price":12495,"available":true,"featured_image":null}]},"hollis-aluminum-backplate-20-bcd-accessory":{"id":6876089319624,"handle":"hollis-aluminum-backplate-20-bcd-accessory","title":"Hollis Aluminum Backplate 2.0 BCD Accessory","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/products/hollis-aluminum-backplate-2_0-bcd-accessory.jpg?v=1743747258","variants":[{"id":40329669017800,"sku":"208.1291.000","title":"Default Title","price":16995,"available":true,"featured_image":null}]},"hollis-stainless-steel-backplate-20-bcd-accessory":{"id":6876243361992,"handle":"hollis-stainless-steel-backplate-20-bcd-accessory","title":"Hollis Stainless Steel Backplate 2.0 BCD Accessory","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/products/open-box-hollis-stainless-steel-backplate-2_0-bcd-accessory.png?v=1743771124","variants":[{"id":40329842524360,"sku":"208.1296.000","title":"Default Title","price":17995,"available":true,"featured_image":null}]},"hollis-crib-custom-backpad-2-0":{"id":9484232360157,"handle":"hollis-crib-custom-backpad-2-0","title":"Hollis CRIB Custom Backpad 2.0","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis_BackplateBackpad2.0-for-hollis-custom-crib.jpg?v=1779479516","variants":[{"id":47879587299549,"sku":"208.1267.07","title":"Black","price":6295,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis_BackplateBackpad2.0-for-hollis-custom-crib.jpg?v=1779479516"}},{"id":47879587332317,"sku":"208.1267.18","title":"Lime","price":6295,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis_BackplateBackpad2.0-for-hollis-custom-crib-green.png?v=1779481330"}},{"id":47879587365085,"sku":"208.1267.01","title":"Blue","price":6295,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis_BackplateBackpad2.0-for-hollis-custom-crib-blue.png?v=1779481330"}},{"id":47879587397853,"sku":"208.1267.69","title":"Multicam","price":6295,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis_BackplateBackpad2.0-for-hollis-custom-crib-camo.png?v=1779483038"}},{"id":47879587430621,"sku":"208.1267.89","title":"Aqua","price":6295,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis_BackplateBackpad2.0-for-hollis-custom-crib-aqua.png?v=1779481330"}},{"id":47879587463389,"sku":"208.1267.78","title":"Pink","price":6295,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis_BackplateBackpad2.0-for-hollis-custom-crib-pink.png?v=1779481330"}},{"id":47879587496157,"sku":"208.1267.04","title":"Red","price":6295,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/Hollis_BackplateBackpad2.0-for-hollis-custom-crib-red.png?v=1779481330"}}]},"hollis-crib-custom-shoulder-pad-solo-style":{"id":9484230000861,"handle":"hollis-crib-custom-shoulder-pad-solo-style","title":"Hollis CRIB Custom Shoulder Pad (Solo style)","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-black.jpg?v=1779478550","variants":[{"id":47879570063581,"sku":"208.1269.07","title":"Black","price":2995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-black.jpg?v=1779478550"}},{"id":47879570096349,"sku":"208.1269.18","title":"Lime","price":2995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-lime.jpg?v=1779478550"}},{"id":47879570129117,"sku":"208.1269.01","title":"Blue","price":2995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-blue.jpg?v=1779478550"}},{"id":47879570161885,"sku":"208.1269.69","title":"Multicam","price":2995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-multicam.jpg?v=1779478550"}},{"id":47879570194653,"sku":"208.1269.89","title":"Aqua","price":2995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-aqua.jpg?v=1779478550"}},{"id":47879570227421,"sku":"208.1269.78","title":"Pink","price":2995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-pink.jpg?v=1779478550"}},{"id":47879570260189,"sku":"208.1269.04","title":"Red","price":2995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-red.jpg?v=1779478550"}}]},"hollis-crib-custom-shoulder-pad-elite-style":{"id":9484231082205,"handle":"hollis-crib-custom-shoulder-pad-elite-style","title":"Hollis CRIB Custom Shoulder Pad (Elite Style)","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-black.jpg?v=1779478550","variants":[{"id":47879580057821,"sku":"208.1270.07","title":"Black / XS/SM (X-Small / Small)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-black.jpg?v=1779478550"}},{"id":47879580090589,"sku":"208.1271.07","title":"Black / MD/LG (Medium / Large)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-black.jpg?v=1779478550"}},{"id":47879580123357,"sku":"208.1272.07","title":"Black / XL/3XL (X-Large / 3X-Large)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-black.jpg?v=1779478550"}},{"id":47879580156125,"sku":"208.1270.18","title":"Lime / XS/SM (X-Small / Small)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-lime.jpg?v=1779478550"}},{"id":47879580188893,"sku":"208.1271.18","title":"Lime / MD/LG (Medium / Large)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-lime.jpg?v=1779478550"}},{"id":47879580221661,"sku":"208.1272.18","title":"Lime / XL/3XL (X-Large / 3X-Large)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-lime.jpg?v=1779478550"}},{"id":47879580254429,"sku":"208.1270.01","title":"Blue / XS/SM (X-Small / Small)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-blue.jpg?v=1779478550"}},{"id":47879580287197,"sku":"208.1271.01","title":"Blue / MD/LG (Medium / Large)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-blue.jpg?v=1779478550"}},{"id":47879580319965,"sku":"208.1272.01","title":"Blue / XL/3XL (X-Large / 3X-Large)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-blue.jpg?v=1779478550"}},{"id":47879580352733,"sku":"208.1270.69","title":"Multicam / XS/SM (X-Small / Small)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-multicam.jpg?v=1779478550"}},{"id":47879580385501,"sku":"208.1271.69","title":"Multicam / MD/LG (Medium / Large)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-multicam.jpg?v=1779478550"}},{"id":47879580418269,"sku":"208.1272.69","title":"Multicam / XL/3XL (X-Large / 3X-Large)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-multicam.jpg?v=1779478550"}},{"id":47879580451037,"sku":"208.1270.89","title":"Aqua / XS/SM (X-Small / Small)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-aqua.jpg?v=1779478550"}},{"id":47879580483805,"sku":"208.1271.89","title":"Aqua / MD/LG (Medium / Large)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-aqua.jpg?v=1779478550"}},{"id":47879580516573,"sku":"208.1272.89","title":"Aqua / XL/3XL (X-Large / 3X-Large)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-aqua.jpg?v=1779478550"}},{"id":47879580549341,"sku":"208.1270.78","title":"Pink / XS/SM (X-Small / Small)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-pink.jpg?v=1779478550"}},{"id":47879580582109,"sku":"208.1271.78","title":"Pink / MD/LG (Medium / Large)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-pink.jpg?v=1779478550"}},{"id":47879580614877,"sku":"208.1272.78","title":"Pink / XL/3XL (X-Large / 3X-Large)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-pink.jpg?v=1779478550"}},{"id":47879580647645,"sku":"208.1270.04","title":"Red / XS/SM (X-Small / Small)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-red.jpg?v=1779478550"}},{"id":47879580680413,"sku":"208.1271.04","title":"Red / MD/LG (Medium / Large)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-red.jpg?v=1779478550"}},{"id":47879580713181,"sku":"208.1272.04","title":"Red / XL/3XL (X-Large / 3X-Large)","price":3995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-shoulder-pad-red.jpg?v=1779478550"}}]},"hollis-crib-custom-lx2-weight-system":{"id":9484232556765,"handle":"hollis-crib-custom-lx2-weight-system","title":"Hollis CRIB Custom LX2 Weight System","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/LX2.jpg?v=1778011674","variants":[{"id":47879588249821,"sku":"208.0016.07","title":"Black","price":13995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/LX2.jpg?v=1778011674"}},{"id":47879588282589,"sku":"208.0016.18","title":"Lime","price":13995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-lx2-weight-system-lime.jpg?v=1779482818"}},{"id":47879588315357,"sku":"208.0016.01","title":"Blue","price":13995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-lx2-weight-system-bluel.jpg?v=1779482818"}},{"id":47879588348125,"sku":"208.0016.69","title":"Multicam","price":13995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-lx2-weight-system-multicamwebp.jpg?v=1779482818"}},{"id":47879588380893,"sku":"208.0016.89","title":"Aqua","price":13995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-lx2-weight-system-aquawebp.jpg?v=1779482818"}},{"id":47879588413661,"sku":"208.0016.78","title":"Pink","price":13995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-lx2-weight-system-pink.jpg?v=1779482818"}},{"id":47879588446429,"sku":"208.0016.04","title":"Red","price":13995,"available":true,"featured_image":{"src":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-custom-lx2-weight-system-red.jpg?v=1779482818"}}]},"hollis-5-lb-non-ditchable-optional-pockets-bcd-accessory":{"id":6876087812296,"handle":"hollis-5-lb-non-ditchable-optional-pockets-bcd-accessory","title":"Hollis 5 LB Non-Ditchable Optional Pockets BCD Accessory","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/products/hollis-5-lb-non-ditchable-optional-pockets-bcd-accessory.jpg?v=1662683295","variants":[{"id":40329667412168,"sku":"208.0030.000","title":"Default Title","price":3195,"available":true,"featured_image":null}]},"hollis-single-tank-adapter-w-bolts-and-nuts-v2-bcd-accessory":{"id":6876202467528,"handle":"hollis-single-tank-adapter-w-bolts-and-nuts-v2-bcd-accessory","title":"Hollis Single Tank Adapter w/ Bolts and Nuts V2 BCD Accessory","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/hollis-single-tank-adapter-w-bolts-and-nuts-v2-bcd-accessory.jpg?v=1743747297","variants":[{"id":40329798287560,"sku":"208.1071.001","title":"Default Title","price":8995,"available":true,"featured_image":null}]},"hollis-mask-pocket":{"id":7514592051421,"handle":"hollis-mask-pocket","title":"HOLLIS MASK POCKET","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/products/open-box-hollis-mask-pocket.jpg?v=1743771117","variants":[{"id":42223372402909,"sku":"208.1030","title":"Default Title","price":3195,"available":false,"featured_image":null}]},"hollis-sms-katana-2-butt-plate-tech-bcd-accessory":{"id":6876226486472,"handle":"hollis-sms-katana-2-butt-plate-tech-bcd-accessory","title":"Hollis SMS Katana 2 Butt Plate Tech BCD Accessory","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/products/hollis-sms-katana-2-butt-plate-tech-bcd-accessory.jpg?v=1662683392","variants":[{"id":40329823781064,"sku":"208.1265","title":"Default Title","price":8995,"available":true,"featured_image":null}]},"hollis-storage-pocket-with-ss-snaps-tech-bcd-accessory":{"id":5674625826984,"handle":"hollis-storage-pocket-with-ss-snaps-tech-bcd-accessory","title":"Hollis Storage Pocket with SS Snaps Tech BCD Accessory","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/products/open-box-hollis-storage-pocket-with-ss-snaps-tech-bcd-accessory.jpg?v=1743771121","variants":[{"id":35908625498280,"sku":"208.1266","title":"Default Title","price":7395,"available":false,"featured_image":null}]},"hollis-sms-mains-rigging-kit":{"id":7514596114653,"handle":"hollis-sms-mains-rigging-kit","title":"HOLLIS SMS MAINS RIGGING KIT","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/products/open-box-hollis-sms-mains-rigging-kit.jpg?v=1743771136","variants":[{"id":42223385870557,"sku":"240.1550","title":"Default Title","price":18495,"available":false,"featured_image":null}]},"hollis-rubber-tank-wrap-kit-bcd-accessory":{"id":6876199944392,"handle":"hollis-rubber-tank-wrap-kit-bcd-accessory","title":"Hollis Rubber Tank Wrap Kit BCD Accessory","featured_image":"https://cdn.shopify.com/s/files/1/0065/3810/0851/products/hollis-rubber-tank-wrap-kit-bcd-accessory.jpg?v=1662683375","variants":[{"id":40329795633352,"sku":"208.1322","title":"Default Title","price":1595,"available":false,"featured_image":null}]}}},"hollis":{"source":"tools/hollis_link.py (verified against hollis.com/crib-builder on 2026-09-29)","urlBase":"https://www.hollis.com/product/","urlQuery":"/?crib_share=1#","COLORS":["blue","red","black","lime","camo","pink","aqua"],"ASSEMBLY":{"name":"Custom Assembly Charge","productId":24838,"price":"129.95","type":"main","navName":"assembly_fee","navNameRaw":"Custom Assembly Charge"},"HARNESS":{"SOLO":{"name":"variation_24079","productId":24080,"price":"89.95"},"ELITE XS SM":{"name":"size_24079_Elite 2","productId":25892,"price":"139.95"},"ELITE MD LG":{"name":"size_24079_Elite 2","productId":25893,"price":"139.95"},"ELITE XL XXL":{"name":"size_24079_Elite 2","productId":25894,"price":"139.95"}},"BACKPLATE":{"ALUMINUM":{"productId":24252,"price":"169.95"},"STAINLESS STEEL":{"productId":24253,"price":"179.95"}},"TANK_BANDS":{"DELRIN":{"productId":24086,"price":"104.95"},"STAINLESS STEEL":{"productId":24085,"price":"124.95"}},"SHOULDER":{"SOLO":{"price":"29.95","ids":{"blue":24119,"red":24120,"black":24781,"lime":24121,"camo":24122,"pink":24123,"aqua":24124}},"ELITE XS SM":{"price":"39.95","ids":{"blue":24126,"red":24127,"black":24782,"lime":24128,"camo":24129,"pink":24130,"aqua":24131}},"ELITE MD LG":{"price":"39.95","ids":{"blue":24133,"red":24134,"black":25864,"lime":24136,"camo":24137,"pink":24138,"aqua":24139}},"ELITE XL XXL":{"price":"39.95","ids":{"blue":24141,"red":24142,"black":24784,"lime":24144,"camo":24145,"pink":24146,"aqua":24147}}},"BACKPAD":{"price":"62.95","ids":{"blue":24102,"red":24103,"black":24779,"lime":24104,"camo":24105,"pink":24106,"aqua":24107}},"WEIGHT_POCKETS":{"price":"169.95","ids":{"blue":24109,"red":24110,"black":24780,"lime":24111,"camo":24112,"pink":24113,"aqua":24114}},"RIGS":{"single":{"slug":"single-tank","summary_slide":8,"bundle":{"name":"Single Tank","productId":24062,"navName":"single_tank"},"wings_group":"variation_24066","wings":{"ST 22":{"productId":24243,"price":"399.95","colors":{"blue":24088,"red":24089,"black":24777,"lime":24090,"camo":24091,"pink":24092,"aqua":24093}},"ST 35":{"productId":24244,"price":"399.95","colors":{"blue":24095,"red":24096,"black":24778,"lime":24097,"camo":24098,"pink":24099,"aqua":24100}}},"steps":["harness","tankBands","backplate"],"weight_pockets":true,"addons":{"5lb_non-ditchable_trim_weight_pockets_(pair)":{"productId":23784,"price":"31.95","navName":"5lb Non-Ditchable Trim Weight Pockets (PAIR)"},"single_tank_adapter_w/bolts_\u0026_nuts,_v2":{"productId":9299,"price":"89.95","navName":"SINGLE TANK ADAPTER W/BOLTS \u0026 NUTS, V2"},"mask_pocket":{"productId":23919,"price":"31.95","navName":"Mask Pocket"}}},"double":{"slug":"double-tank","summary_slide":7,"bundle":{"name":"Double Tank","productId":24063,"navName":"double_tank"},"wings_group":"variation_24115","wings":{"DT 45 DUAL":{"productId":24116,"price":"649.95","colors":{"blue":24149,"red":24150,"black":24785,"lime":24151,"camo":24152,"pink":24153,"aqua":24154}},"DT 50":{"productId":24117,"price":"479.95","colors":{"blue":24156,"red":24157,"black":24786,"lime":24158,"camo":24159,"pink":24160,"aqua":24161}}},"steps":["harness","backplate"],"weight_pockets":false,"addons":{"mask_pocket":{"productId":23919,"price":"31.95","navName":"Mask Pocket"}}},"sidemount":{"slug":"sidemount","summary_slide":5,"bundle":{"name":"Sidemount","productId":24064,"navName":"sidemount"},"wings_group":"variation_24162","wings":{"Katana 2 Single":{"productId":24164,"price":"799.95","colors":{"blue":24166,"red":24167,"black":24788,"lime":24168,"camo":24169,"pink":24170}},"Katana 2 Dual":{"productId":24163,"price":"929.95","colors":{"blue":24173,"red":24174,"black":24787,"lime":24175,"camo":24176,"pink":24177}}},"steps":[],"weight_pockets":false,"addons":{"katana_butt_plate":{"productId":1010,"price":"89.95","navName":"Katana Butt Plate"},"storage_pocket_with_ss_snaps":{"productId":1924,"price":"73.95","navName":"Storage Pocket with SS Snaps"},"sms_mains_rigging_kit":{"productId":23847,"price":"184.95","navName":"SMS MAINS RIGGING KIT"},"rubber_tank_wrap_kit_(pair)":{"productId":9332,"price":"15.95","navName":"RUBBER TANK WRAP KIT (PAIR)"}}}},"priceOverrides":{"about":"Colours that Hollis's builder prices above the flat price of their group (read 2026-09-29). The share link and tools/hollis_link.py carry the flat price, so Hollis's Summary shows the flat price when a build is opened from the link and the price below when the same build is entered by hand. Staff text only, never shown to shoppers.","wing":{"Katana 2 Dual":{"lime":"949.95","camo":"949.95","pink":"949.95","black":"949.95"}},"shoulder":{"ELITE XL XXL":{"black":"49.95"}}}},"renders":{"about":"Hollis render layers stacked by DCCrib.renderLayers(). Values are file names after urlPrefix (Shopify Files, copied from Hollis's public Store API products 24062, 24063 and 24064 on 2026-09-29). Written by tools/make_renders.py, do not edit by hand.","readAt":"2026-09-29","urlPrefix":"https://cdn.shopify.com/s/files/1/0065/3810/0851/files/crib-render-","widths":[360,540,720,900,1200],"views":["side","front"],"layerOrder":["under","base","plate","backpad","shoulder","pockets"],"wingKeys":{"ST 22":"st22","ST 35":"st35","DT 45 DUAL":"dt45","DT 50":"dt50","Katana 2 Single":"k2s","Katana 2 Dual":"k2d"},"harnessKeys":{"SOLO":"solo","ELITE XS SM":"elite","ELITE MD LG":"elite","ELITE XL XXL":"elite"},"defaultHarness":"elite","rigWing":{"single":"ST 35","double":"DT 45 DUAL","sidemount":"Katana 2 Single"},"combos":{"st22_elite":{"side":{"base":{"blue":"st22_elite_travel_side_BLUE.png","red":"st22_elite_travel_side_RED.png","black":"st22_elite_travel_side_BLACK.jpg","lime":"st22_elite_travel_side_LIME.png","camo":"st22_elite_travel_side_CAMO.png","pink":"st22_elite_travel_side_PINK.png","aqua":"st22_elite_travel_side_AQUA.png"},"backpad":{"blue":"st22_elite_travel_side_BLUE-backpad.png","red":"st22_elite_travel_side_RED-backpad.png","black":"st22_elite_travel_side_BLACK-backpad.png","lime":"st22_elite_travel_side_LIME-backpad.png","camo":"st22_elite_travel_side_CAMO-backpad.png","pink":"st22_elite_travel_side_PINK-backpad.png","aqua":"st22_elite_travel_side_AQUA-backpad.png"},"shoulder":{"blue":"st22_elite_travel_side_BLUE-shoulder.png","red":"st22_elite_travel_side_RED-shoulder.png","black":"st22_elite_travel_side_BLACK-shoulder.png","lime":"st22_elite_travel_side_LIME-shoulder.png","camo":"st22_elite_travel_side_CAMO-shoulder.png","pink":"st22_elite_travel_side_PINK-shoulder.png","aqua":"st22_elite_travel_side_AQUA-shoulder.png"},"pockets":{"blue":"st22_elite_travel_side_POCKET-BLUE.png","red":"st22_elite_travel_side_POCKET-RED.png","black":"st22_elite_travel_side_POCKET-BLACK.png","lime":"st22_elite_travel_side_POCKET-LIME.png","camo":"st22_elite_travel_side_POCKET-CAMO.png","pink":"st22_elite_travel_side_POCKET-PINK.png","aqua":"st22_elite_travel_side_POCKET-AQUA.png"},"plate":{"STAINLESS STEEL":"st22_elite_travel_side_STAINLESSSTEEL-plate.png"}},"front":{"under":"st22_elite_travel_BASE.jpg","base":{"blue":"st22_elite_travel_front_BLUE-wing.jpg","red":"st22_elite_travel_front_RED-wing.jpg","black":"st22_elite_travel_front_BLACK-wing.jpg","lime":"st22_elite_travel_front_LIME-wing.jpg","camo":"st22_elite_travel_front_CAMO-wing.jpg","pink":"st22_elite_travel_front_PINK-wing.jpg","aqua":"st22_elite_travel_front_AQUA-wing.jpg"},"backpad":{"blue":"st22_elite_travel_front_BLUE-backpad.png","red":"st22_elite_travel_front_RED-backpad.png","black":"st22_elite_travel_front_BLACK-backpad.png","lime":"st22_elite_travel_front_LIME-backpad.png","camo":"st22_elite_travel_front_CAMO-backpad.png","pink":"st22_elite_travel_front_PINK-backpad.png","aqua":"st22_elite_travel_front_AQUA-backpad.png"},"shoulder":{"blue":"st22_elite_travel_front_BLUE-shoulder.png","red":"st22_elite_travel_front_RED-shoulder.png","black":"st22_elite_travel_front_BLACK-shoulder.png","lime":"st22_elite_travel_front_LIME-shoulder.png","camo":"st22_elite_travel_front_CAMO-shoulder.png","pink":"st22_elite_travel_front_PINK-shoulder.png","aqua":"st22_elite_travel_front_AQUA-shoulder.png"},"pockets":{"blue":"st22_elite_travel_front_BLUE-pockets.png","red":"st22_elite_travel_front_RED-pockets.png","black":"st22_elite_travel_front_BLACK-pockets.png","lime":"st22_elite_travel_front_LIME-pockets.png","camo":"st22_elite_travel_front_CAMO-pockets.png","pink":"st22_elite_travel_front_PINK-pockets.png","aqua":"st22_elite_travel_front_AQUA-pockets.png"},"plate":{"STAINLESS STEEL":"st22_elite_front_STAINLESS-backplate.png"}},"defaultPlate":"ALUMINUM"},"st22_solo":{"side":{"base":{"blue":"st22_solo_travel_side_BLUE.png","red":"st22_solo_travel_side_RED.png","black":"st22_solo_travel_side_BLACK.jpg","lime":"st22_solo_travel_side_LIME.png","camo":"st22_solo_travel_side_CAMO.png","pink":"st22_solo_travel_side_PINK.png","aqua":"st22_solo_travel_side_AQUA.png"},"backpad":{"blue":"st22_solo_travel_side_BLUE-backpad.png","red":"st22_solo_travel_side_RED-backpad.png","black":"st22_solo_travel_side_BLACK-backpad.png","lime":"st22_solo_travel_side_LIME-backpad.png","camo":"st22_solo_travel_side_CAMO-backpad.png","pink":"st22_solo_travel_side_PINK-backpad.png","aqua":"st22_solo_travel_side_AQUA-backpad.png"},"shoulder":{"blue":"st22_solo_travel_side_BLUE-shoulder.png","red":"st22_solo_travel_side_RED-shoulder.png","black":"st22_solo_travel_side_BLACK-shoulder.png","lime":"st22_solo_travel_side_LIME-shoulder.png","camo":"st22_solo_travel_side_CAMO-shoulder.png","pink":"st22_solo_travel_side_PINK-shoulder.png","aqua":"st22_solo_travel_side_AQUA-shoulder.png"},"pockets":{"blue":"st22_solo_travel_side_POCKET-BLUE.png","red":"st22_solo_travel_side_POCKET-RED.png","black":"st22_solo_travel_side_POCKET-BLACK.png","lime":"st22_solo_travel_side_POCKET-LIME.png","camo":"st22_solo_travel_side_POCKET-CAMO.png","pink":"st22_solo_travel_side_POCKET-PINK.png","aqua":"st22_solo_travel_side_POCKET-AQUA.png"},"plate":{"STAINLESS STEEL":"st22_solo_travel_side_STAINLESSSTEEL-plate.png"}},"front":{"under":"st22_solo_travel_BASE.jpg","base":{"blue":"st22_solo_travel_front_BLUE-wing.png","red":"st22_solo_travel_front_RED-wing.png","black":"st22_solo_travel_BASE.jpg","lime":"st22_solo_travel_front_LIME-wing.png","camo":"st22_solo_travel_front_CAMO-wing.png","pink":"st22_solo_travel_front_PINK-wing.png","aqua":"st22_solo_travel_front_AQUA-wing.png"},"backpad":{"blue":"st22_solo_travel_front_BLUE-backpad.png","red":"st22_solo_travel_front_RED-backpad.png","black":"st22_solo_travel_front_BLACK-backpad.png","lime":"st22_solo_travel_front_LIME-backpad.png","camo":"st22_solo_travel_front_CAMO-backpad.png","pink":"st22_solo_travel_front_PINK-backpad.png","aqua":"st22_solo_travel_front_AQUA-backpad.png"},"shoulder":{"blue":"st22_solo_travel_front_BLUE-shoulder.png","red":"st22_solo_travel_front_RED-shoulder.png","black":"st22_solo_travel_front_BLACK-shoulder.png","lime":"st22_solo_travel_front_LIME-shoulder.png","camo":"st22_solo_travel_front_CAMO-shoulder.png","pink":"st22_solo_travel_front_PINK-shoulder.png","aqua":"st22_solo_travel_front_AQUA-shoulder.png"},"pockets":{"blue":"st22_solo_travel_front_BLUE-pockets.png","red":"st22_solo_travel_front_RED-pockets.png","black":"st22_solo_travel_front_BLACK-pockets.png","lime":"st22_solo_travel_front_LIME-pockets.png","camo":"st22_solo_travel_front_CAMO-pockets.png","pink":"st22_solo_travel_front_PINK-pockets.png","aqua":"st22_solo_travel_front_AQUA-pockets.png"},"plate":{"STAINLESS STEEL":"st22_solo_front_STAINLESS-backplate.png"}},"defaultPlate":"ALUMINUM"},"st35_elite":{"side":{"base":{"blue":"st35_elite_travel_side_BLUE.jpg","red":"st35_elite_travel_side_RED.jpg","black":"st35_elite_travel_side_BLACK.jpg","lime":"st35_elite_travel_side_LIME.jpg","camo":"st35_elite_travel_side_CAMO.jpg","pink":"st35_elite_travel_side_PINK.jpg","aqua":"st35_elite_travel_side_AQUA.jpg"},"backpad":{"blue":"st35_elite_travel_side_BLUE-backpad.png","red":"st35_elite_travel_side_RED-backpad.png","black":"st35_elite_travel_side_BLACK-backpad.png","lime":"st35_elite_travel_side_LIME-backpad.png","camo":"st35_elite_travel_side_CAMO-backpad.png","pink":"st35_elite_travel_side_PINK-backpad.png","aqua":"st35_elite_travel_side_AQUA-backpad.png"},"shoulder":{"blue":"st35_elite_travel_side_BLUE-shoulder.png","red":"st35_elite_travel_side_RED-shoulder.png","black":"st35_elite_travel_side_BLACK-shoulder.png","lime":"st35_elite_travel_side_LIME-shoulder.png","camo":"st35_elite_travel_side_CAMO-shoulder.png","pink":"st35_elite_travel_side_PINK-shoulder.png","aqua":"st35_elite_travel_side_AQUA-shoulder.png"},"pockets":{"blue":"st35_elite_travel_side_POCKET-BLUE.png","red":"st35_elite_travel_side_POCKET-RED.png","black":"st35_elite_travel_side_POCKET-BLACK.png","lime":"st35_elite_travel_side_POCKET-LIME.png","camo":"st35_elite_travel_side_POCKET-CAMO.png","pink":"st35_elite_travel_side_POCKET-PINK.png","aqua":"st35_elite_travel_side_POCKET-AQUA.png"},"plate":{"ALUMINUM":"st35_elite_travel_side_ALUMINUM-plate.png"}},"front":{"under":"st35_elite_travel_BASE.jpg","base":{"blue":"st35_elite_travel_front_BLUE-wing.jpg","red":"st35_elite_travel_front_RED-wing.jpg","black":"st35_elite_travel_BASE.jpg","lime":"st35_elite_travel_front_LIME-wing.jpg","camo":"st35_elite_travel_front_CAMO-wing.jpg","pink":"st35_elite_travel_front_PINK-wing.jpg","aqua":"st35_elite_travel_front_AQUA-wing.jpg"},"backpad":{"blue":"st35_elite_travel_front_BLUE-backpad.png","red":"st35_elite_travel_front_RED-backpad.png","black":"st35_elite_travel_front_BLACK-backpad.png","lime":"st35_elite_travel_front_LIME-backpad.png","camo":"st35_elite_travel_front_CAMO-backpad.png","pink":"st35_elite_travel_front_PINK-backpad.png","aqua":"st35_elite_travel_front_AQUA-backpad.png"},"shoulder":{"blue":"st35_elite_travel_front_BLUE-shoulder.png","red":"st35_elite_travel_front_RED-shoulder.png","black":"st35_elite_travel_front_BLACK-shoulder.png","lime":"st35_elite_travel_front_LIME-shoulder.png","camo":"st35_elite_travel_front_CAMO-shoulder.png","pink":"st35_elite_travel_front_PINK-shoulder.png","aqua":"st35_elite_travel_front_AQUA-shoulder.png"},"pockets":{"blue":"st35_elite_travel_front_BLUE-pockets.png","red":"st35_elite_travel_front_RED-pockets.png","black":"st35_elite_travel_front_BLACK-pockets.png","lime":"st35_elite_travel_front_LIME-pockets.png","camo":"st35_elite_travel_front_CAMO-pockets.png","pink":"st35_elite_travel_front_PINK-pockets.png","aqua":"st35_elite_travel_front_AQUA-pockets.png"},"plate":{"ALUMINUM":"st35_elite_travel_front_ALUMINUM-backplate.png"}},"defaultPlate":"STAINLESS STEEL"},"st35_solo":{"side":{"base":{"blue":"st35_solo_travel_side_BLUE.jpg","red":"st35_solo_travel_side_RED.jpg","black":"st35_solo_travel_side_BLACK.jpg","lime":"st35_solo_travel_side_LIME.jpg","camo":"st35_solo_travel_side_CAMO.jpg","pink":"st35_solo_travel_side_PINK.jpg","aqua":"st35_solo_travel_side_AQUA.jpg"},"backpad":{"blue":"st35_solo_travel_side_BLUE-backpad.png","red":"st35_solo_travel_side_RED-backpad.png","black":"st35_solo_travel_side_BLACK-backpad.png","lime":"st35_solo_travel_side_LIME-backpad.png","camo":"st35_solo_travel_side_CAMO-backpad.png","pink":"st35_solo_travel_side_PINK-backpad.png","aqua":"st35_solo_travel_side_AQUA-backpad.png"},"shoulder":{"blue":"st35_solo_travel_side_BLUE-shoulder.png","red":"st35_solo_travel_side_RED-shoulder.png","black":"st35_solo_travel_side_BLACK-shoulder.png","lime":"st35_solo_travel_side_LIME-shoulder.png","camo":"st35_solo_travel_side_CAMO-shoulder.png","pink":"st35_solo_travel_side_PINK-shoulder.png","aqua":"st35_solo_travel_side_AQUA-shoulder.png"},"pockets":{"blue":"st35_solo_travel_side_POCKET-BLUE.png","red":"st35_solo_travel_side_POCKET-RED.png","black":"st35_solo_travel_side_POCKET-BLACK.png","lime":"st35_solo_travel_side_POCKET-LIME.png","camo":"st35_solo_travel_side_POCKET-CAMO.png","pink":"st35_solo_travel_side_POCKET-PINK.png","aqua":"st35_solo_travel_side_POCKET-AQUA.png"},"plate":{"ALUMINUM":"st35_solo_travel_side_ALUMINUM-plate.png"}},"front":{"under":"st35_solo_travel_BASE.png","base":{"blue":"st35_solo_travel_front_BLUE-wing.png","red":"st35_solo_travel_front_RED-wing.png","black":"st35_solo_travel_front_BLACK-wing.png","lime":"st35_solo_travel_front_LIME-wing.png","camo":"st35_solo_travel_front_CAMO-wing.png","pink":"st35_solo_travel_front_PINK-wing.png","aqua":"st35_solo_travel_front_AQUA-wing.png"},"backpad":{"blue":"st35_solo_travel_front_BLUE-backpad.png","red":"st35_solo_travel_front_RED-backpad.png","black":"st35_solo_travel_front_BLACK-backpad.png","lime":"st35_solo_travel_front_LIME-backpad.png","camo":"st35_solo_travel_front_CAMO-backpad.png","pink":"st35_solo_travel_front_PINK-backpad.png","aqua":"st35_solo_travel_front_AQUA-backpad.png"},"shoulder":{"blue":"st35_solo_travel_front_BLUE-shoulder.png","red":"st35_solo_travel_front_RED-shoulder.png","black":"st35_solo_travel_front_BLACK-shoulder.png","lime":"st35_solo_travel_front_LIME-shoulder.png","camo":"st35_solo_travel_front_CAMO-shoulder.png","pink":"st35_solo_travel_front_PINK-shoulder.png","aqua":"st35_solo_travel_front_AQUA-shoulder.png"},"pockets":{"blue":"st35_solo_travel_front_BLUE-pockets.png","red":"st35_solo_travel_front_RED-pockets.png","black":"st35_solo_travel_front_BLACK-pockets.png","lime":"st35_solo_travel_front_LIME-pockets.png","camo":"st35_solo_travel_front_CAMO-pockets.png","pink":"st35_solo_travel_front_PINK-pockets.png","aqua":"st35_solo_travel_front_AQUA-pockets.png"},"plate":{"ALUMINUM":"st35_solo_travel_front_ALUMINUM-backplate.png"}},"defaultPlate":"STAINLESS STEEL"},"dt45_elite":{"side":{"base":{"blue":"dt45_elite_travel_side_BLUE.jpg","red":"dt45_elite_travel_side_RED.jpg","black":"dt45_elite_travel_side_BLACK.jpg","lime":"dt45_elite_travel_side_LIME.jpg","camo":"dt45_elite_travel_side_CAMO.jpg","pink":"dt45_elite_travel_side_PINK.jpg","aqua":"dt45_elite_travel_side_AQUA.jpg"},"backpad":{"blue":"dt45_elite_travel_side_BLUE-backpad.png","red":"dt45_elite_travel_side_RED-backpad.png","black":"dt45_elite_travel_side_BLACK-backpad.png","lime":"dt45_elite_travel_side_LIME-backpad.png","camo":"dt45_elite_travel_side_CAMO-backpad.png","pink":"dt45_elite_travel_side_PINK-backpad.png","aqua":"dt45_elite_travel_side_AQUA-backpad.png"},"shoulder":{"blue":"dt45_elite_travel_side_BLUE-shoulder.png","red":"dt45_elite_travel_side_RED-shoulder.png","black":"dt45_elite_travel_side_BLACK-shoulder.png","lime":"dt45_elite_travel_side_LIME-shoulder.png","camo":"dt45_elite_travel_side_CAMO-shoulder.png","pink":"dt45_elite_travel_side_PINK-shoulder.png","aqua":"dt45_elite_travel_side_AQUA-shoulder.png"},"plate":{"STAINLESS STEEL":"dt45_elite_travel_side_STAINLESSSTEEL-plate.png"}},"front":{"under":"dt45_elite_travel_BASE.jpg","base":{"blue":"dt45_elite_travel_front_BLUE-wing.jpg","red":"dt45_elite_travel_front_RED-wing.jpg","black":"dt45_elite_travel_front_BLACK-wing.jpg","lime":"dt45_elite_travel_front_LIME-wing.jpg","camo":"dt45_elite_travel_front_CAMO-wing.jpg","pink":"dt45_elite_travel_front_PINK-wing.jpg","aqua":"dt45_elite_travel_front_AQUA-wing.jpg"},"backpad":{"blue":"dt45_elite_travel_front_BLUE-backpad.png","red":"dt45_elite_travel_front_RED-backpad.png","black":"dt45_elite_travel_front_BLACK-backpad.png","lime":"dt45_elite_travel_front_LIME-backpad.png","camo":"dt45_elite_travel_front_CAMO-backpad.png","pink":"dt45_elite_travel_front_PINK-backpad.png","aqua":"dt45_elite_travel_front_AQUA-backpad.png"},"shoulder":{"blue":"dt45_elite_travel_front_BLUE-shoulder.png","red":"dt45_elite_travel_front_RED-shoulder.png","black":"dt45_elite_travel_front_BLACK-shoulder.png","lime":"dt45_elite_travel_front_LIME-shoulder.png","camo":"dt45_elite_travel_front_CAMO-shoulder.png","pink":"dt45_elite_travel_front_PINK-shoulder.png","aqua":"dt45_elite_travel_front_AQUA-shoulder.png"},"plate":{"STAINLESS STEEL":"dt45_elite_front_STAINLESS-backplate.png"}},"defaultPlate":"ALUMINUM"},"dt45_solo":{"side":{"base":{"blue":"dt45_solo_travel_side_BLUE.jpg","red":"dt45_solo_travel_side_RED.jpg","black":"dt45_solo_travel_side_BLACK.jpg","lime":"dt45_solo_travel_side_LIME.jpg","camo":"dt45_solo_travel_side_CAMO.jpg","pink":"dt45_solo_travel_side_PINK.jpg","aqua":"dt45_solo_travel_side_AQUA.jpg"},"backpad":{"blue":"dt45_solo_travel_side_BLUE-backpad.png","red":"dt45_solo_travel_side_RED-backpad.png","black":"dt45_solo_travel_side_BLACK-backpad.png","lime":"dt45_solo_travel_side_LIME-backpad.png","camo":"dt45_solo_travel_side_CAMO-backpad.png","pink":"dt45_solo_travel_side_PINK-backpad.png","aqua":"dt45_solo_travel_side_AQUA-backpad.png"},"shoulder":{"blue":"dt45_solo_travel_side_BLUE-shoulder.png","red":"dt45_solo_travel_side_RED-shoulder.png","black":"dt45_solo_travel_side_BLACK-shoulder.png","lime":"dt45_solo_travel_side_LIME-shoulder.png","camo":"dt45_solo_travel_side_CAMO-shoulder.png","pink":"dt45_solo_travel_side_PINK-shoulder.png","aqua":"dt45_solo_travel_side_AQUA-shoulder.png"},"plate":{"ALUMINUM":"dt45_solo_travel_side_ALUMINUM-plate.png"}},"front":{"under":"dt45_solo_travel_BASE.jpg","base":{"blue":"dt45_solo_travel_front_BLUE-wing.jpg","red":"dt45_solo_travel_front_RED-wing.jpg","black":"dt45_solo_travel_front_BLACK-wing.jpg","lime":"dt45_solo_travel_front_LIME-wing.jpg","camo":"dt45_solo_travel_front_CAMO-wing.jpg","pink":"dt45_solo_travel_front_PINK-wing.jpg","aqua":"dt45_solo_travel_front_AQUA-wing.jpg"},"backpad":{"blue":"dt45_solo_travel_front_BLUE-backpad.png","red":"dt45_solo_travel_front_RED-backpad.png","black":"dt45_solo_travel_front_BLACK-backpad.png","lime":"dt45_solo_travel_front_LIME-backpad.png","camo":"dt45_solo_travel_front_CAMO-backpad.png","pink":"dt45_solo_travel_front_PINK-backpad.png","aqua":"dt45_solo_travel_front_AQUA-backpad.png"},"shoulder":{"blue":"dt45_solo_travel_front_BLUE-shoulder.png","red":"dt45_solo_travel_front_RED-shoulder.png","black":"dt45_solo_travel_front_BLACK-shoulder.png","lime":"dt45_solo_travel_front_LIME-shoulder.png","camo":"dt45_solo_travel_front_CAMO-shoulder.png","pink":"dt45_solo_travel_front_PINK-shoulder.png","aqua":"dt45_solo_travel_front_AQUA-shoulder.png"},"plate":{"ALUMINUM":"dt45_solo_travel_front_ALUMINUM-backplate.png"}},"defaultPlate":"STAINLESS STEEL"},"dt50_elite":{"side":{"base":{"blue":"dt50_elite_travel_side_BLUE.jpg","red":"dt50_elite_travel_side_RED.jpg","black":"dt50_elite_travel_side_BLACK.jpg","lime":"dt50_elite_travel_side_LIME.jpg","camo":"dt50_elite_travel_side_CAMO.jpg","pink":"dt50_elite_travel_side_PINK.jpg","aqua":"dt50_elite_travel_side_AQUA.jpg"},"backpad":{"blue":"dt50_elite_travel_side_BLUE-backpad.png","red":"dt50_elite_travel_side_RED-backpad.png","black":"dt50_elite_travel_side_BLACK-backpad.png","lime":"dt50_elite_travel_side_LIME-backpad.png","camo":"dt50_elite_travel_side_CAMO-backpad.png","pink":"dt50_elite_travel_side_PINK-backpad.png","aqua":"dt50_elite_travel_side_AQUA-backpad.png"},"shoulder":{"blue":"dt50_elite_travel_side_BLUE-shoulder.png","red":"dt50_elite_travel_side_RED-shoulder.png","black":"dt50_elite_travel_side_BLACK-shoulder.png","lime":"dt50_elite_travel_side_LIME-shoulder.png","camo":"dt50_elite_travel_side_CAMO-shoulder.png","pink":"dt50_elite_travel_side_PINK-shoulder.png","aqua":"dt50_elite_travel_side_AQUA-shoulder.png"},"plate":{"STAINLESS STEEL":"dt50_elite_travel_side_STAINLESSSTEEL-plate.png"}},"front":{"under":"dt50_elite_travel_BASE.jpg","base":{"blue":"dt50_elite_travel_front_BLUE-wing.jpg","red":"dt50_elite_travel_front_RED-wing.jpg","black":"dt50_elite_travel_front_BLACK-wing.jpg","lime":"dt50_elite_travel_front_LIME-wing.jpg","camo":"dt50_elite_travel_front_CAMO-wing.jpg","pink":"dt50_elite_travel_front_PINK-wing.jpg","aqua":"dt50_elite_travel_front_AQUA-wing.jpg"},"backpad":{"blue":"dt50_elite_travel_front_BLUE-backpad.png","red":"dt50_elite_travel_front_RED-backpad.png","black":"dt50_elite_travel_front_BLACK-backpad.png","lime":"dt50_elite_travel_front_LIME-backpad.png","camo":"dt50_elite_travel_front_CAMO-backpad.png","pink":"dt50_elite_travel_front_PINK-backpad.png","aqua":"dt50_elite_travel_front_AQUA-backpad.png"},"shoulder":{"blue":"dt50_elite_travel_front_BLUE-shoulder.png","red":"dt50_elite_travel_front_RED-shoulder.png","black":"dt50_elite_travel_front_BLACK-shoulder.png","lime":"dt50_elite_travel_front_LIME-shoulder.png","camo":"dt50_elite_travel_front_CAMO-shoulder.png","pink":"dt50_elite_travel_front_PINK-shoulder.png","aqua":"dt50_elite_travel_front_AQUA-shoulder.png"},"plate":{"STAINLESS STEEL":"dt50_elite_front_STAINLESS-backplate.png"}},"defaultPlate":"ALUMINUM"},"dt50_solo":{"side":{"base":{"blue":"dt50_solo_travel_side_BLUE.jpg","red":"dt50_solo_travel_side_RED.jpg","black":"dt50_solo_travel_side_BLACK.jpg","lime":"dt50_solo_travel_side_LIME.jpg","camo":"dt50_solo_travel_side_CAMO.jpg","pink":"dt50_solo_travel_side_PINK.jpg","aqua":"dt50_solo_travel_side_AQUA.jpg"},"backpad":{"blue":"dt50_solo_travel_side_BLUE-backpad.png","red":"dt50_solo_travel_side_RED-backpad.png","black":"dt50_solo_travel_side_BLACK-backpad.png","lime":"dt50_solo_travel_side_LIME-backpad.png","camo":"dt50_solo_travel_side_CAMO-backpad.png","pink":"dt50_solo_travel_side_PINK-backpad.png","aqua":"dt50_solo_travel_side_AQUA-backpad.png"},"shoulder":{"blue":"dt50_solo_travel_side_BLUE-shoulder.png","red":"dt50_solo_travel_side_RED-shoulder.png","black":"dt50_solo_travel_side_BLACK-shoulder.png","lime":"dt50_solo_travel_side_LIME-shoulder.png","camo":"dt50_solo_travel_side_CAMO-shoulder.png","pink":"dt50_solo_travel_side_PINK-shoulder.png","aqua":"dt50_solo_travel_side_AQUA-shoulder.png"},"plate":{"ALUMINUM":"dt50_solo_travel_side_ALUMINUM-plate.png"}},"front":{"under":"dt50_solo_travel_BASE.jpg","base":{"blue":"dt50_solo_travel_front_BLUE-wing.jpg","red":"dt50_solo_travel_front_RED-wing.jpg","black":"dt50_solo_travel_front_BLACK-wing.jpg","lime":"dt50_solo_travel_front_LIME-wing.jpg","camo":"dt50_solo_travel_front_CAMO-wing.jpg","pink":"dt50_solo_travel_front_PINK-wing.jpg","aqua":"dt50_solo_travel_front_AQUA-wing.jpg"},"backpad":{"blue":"dt50_solo_travel_front_BLUE-backpad.png","red":"dt50_solo_travel_front_RED-backpad.png","black":"dt50_solo_travel_front_BLACK-backpad.png","lime":"dt50_solo_travel_front_LIME-backpad.png","camo":"dt50_solo_travel_front_CAMO-backpad.png","pink":"dt50_solo_travel_front_PINK-backpad.png","aqua":"dt50_solo_travel_front_AQUA-backpad.png"},"shoulder":{"blue":"dt50_solo_travel_front_BLUE-shoulder.png","red":"dt50_solo_travel_front_RED-shoulder.png","black":"dt50_solo_travel_front_BLACK-shoulder.png","lime":"dt50_solo_travel_front_LIME-shoulder.png","camo":"dt50_solo_travel_front_CAMO-shoulder.png","pink":"dt50_solo_travel_front_PINK-shoulder.png","aqua":"dt50_solo_travel_front_AQUA-shoulder.png"},"plate":{"ALUMINUM":"dt50_solo_travel_front_ALUMINUM-plate.png"}},"defaultPlate":"STAINLESS STEEL"},"k2s":{"side":{"base":{"blue":"k2s_side_BLUE.jpg","red":"k2s_side_RED.jpg","black":"k2s_side_BLACK.jpg","lime":"k2s_side_LIME.jpg","camo":"k2s_side_CAMO.jpg","pink":"k2s_side_PINK.jpg","aqua":"k2s_side_AQUA.jpg"}},"front":{"under":"k2s_BASE.jpg","base":{"blue":"k2s_front_BLUE-wing.jpg","red":"k2s_front_RED-wing.jpg","black":"k2s_front_BLACK-wing.jpg","lime":"k2s_front_LIME-wing.jpg","camo":"k2s_front_CAMO-wing.jpg","pink":"k2s_front_PINK-wing.jpg","aqua":"k2s_front_AQUA-wing.jpg"}}},"k2d":{"side":{"base":{"blue":"k2d_side_BLUE.jpg","red":"k2d_side_RED.jpg","black":"k2d_side_BLACK.jpg","lime":"k2d_side_LIME.jpg","camo":"k2d_side_CAMO.jpg","pink":"k2d_side_PINK.jpg","aqua":"k2d_side_AQUA.jpg"}},"front":{"under":"k2d_BASE.jpg","base":{"blue":"k2d_front_BLUE-wing.jpg","red":"k2d_front_RED-wing.jpg","black":"k2d_front_BLACK-wing.jpg","lime":"k2d_front_LIME-wing.jpg","camo":"k2d_front_CAMO-wing.jpg","pink":"k2d_front_PINK-wing.jpg","aqua":"k2d_front_AQUA-wing.jpg"}}}}},"builderListings":[{"rig":"single","handle":"hollis-crib-custom-single-tank-rig-builder","productId":15402388947165,"variantIds":[67851532370141]},{"rig":"double","handle":"hollis-crib-custom-double-tank-rig-builder","productId":15402389635293,"variantIds":[67851615502557]},{"rig":"sidemount","handle":"hollis-crib-custom-sidemount-rig-builder","productId":15402406936797,"variantIds":[67852580192477]}]};
/* src/crib-core.js 64fc159dcb50 */
/*
 * DCCrib core 1.0.0
 * Pure logic for the Hollis CRIB builder on divecatalog.com (SPEC.md sections 2, 4, 5).
 *
 * - UMD: window.DCCrib in the browser, module.exports in node.
 * - No DOM access, no network, no storage. ES5 syntax only, so the theme minifier and older
 *   Safari can cope. The source never contains a doubled opening brace or a brace followed by
 *   a percent sign, so it can sit inside a Liquid section untouched.
 * - Data: in the browser the build injects parts.json as window.DCCribData before this file
 *   runs (or call DCCrib.setData(data) later). In node it is require('../parts.json').
 *
 * State (DCCrib.newState):
 *   rig            'single' | 'double' | 'sidemount'
 *   wing           Hollis name, e.g. 'ST 35', 'DT 45 DUAL', 'Katana 2 Single'
 *   harness        'SOLO' | 'ELITE XS SM' | 'ELITE MD LG' | 'ELITE XL XXL'   (single, double)
 *   tankBands      'DELRIN' | 'STAINLESS STEEL'                              (single)
 *   backplate      'ALUMINUM' | 'STAINLESS STEEL'                            (single, double)
 *   wingColor, backpadColor, shoulderColor
 *                  Hollis colour name: blue red black lime camo pink aqua
 *   weightPockets  undefined = not answered, null = No, '<colour>' = Yes      (single)
 *                  true or 'yes' = Yes, colour not chosen yet (incomplete, never reaches the cart)
 *   addons         array of add-on ids from parts.json options.addons
 *                  (Hollis data-item names are accepted as aliases)
 *
 * Behaviour on incomplete builds:
 *   validate()            always answers, never throws
 *   resolve()             returns the lines that are fully decided, plus `pending` for required
 *                         parts that still wait for a colour (price only, for a running total)
 *   configString()        works on partial states ('-' marks an empty field)
 *   parseConfigString()   returns a state, or null when the text is not a CRIB config
 *   hollisLink(), hollisSummary()   return null when validate() fails
 *   orderSheet()          returns '' when validate() fails
 *   cartPayload()         THROWS (error.code 'CRIB_INCOMPLETE' | 'CRIB_UNAVAILABLE' | 'CRIB_STALE' |
 *                         'CRIB_DATA') so a partial build, or a build without its staff sheet
 *                         and Hollis link, can never reach the cart
 *
 * Beyond the API of SPEC.md section 4 this file also offers (all pure):
 *   setData(data)                       inject or replace parts.json after load
 *   normalize(state)                    tidy copy: canonical names, add-ons in Hollis's order
 *   handlesFor(rig, {assemblyHandle})   product handles to read from /products/<handle>.js
 *   mergeCatalogs(baked, live)          live entries replace baked entries
 *   optionsFor(rig, step, catalog)      option cards with price and availability
 *   colorZonesFor(state, catalog)       colour zones with swatches, SKU, price, availability
 *   dropUnavailableAddons(state, catalog)  state without sold out add-ons, plus what was removed
 *   partsFor(state)                     decided parts with SKU, no catalog needed
 *   buildText / colorsText / addonsText the shopper-facing property values
 *   isBuildId(text), escapeHtml(text), PROPS (property names)
 *   catalogFromProducts(products, {assemblyHandle})  marks the assembly product; resolve() adds
 *                                       the assembly line only when that product is available
 *
 * Hollis prices (DATA.hollis) are for staff text only. Never show them to shoppers.
 */
(function (root, factory) {
  'use strict';
  if (typeof module === 'object' && module && module.exports) {
    module.exports = factory(require('../parts.json'));
  } else {
    root.DCCrib = factory(root.DCCribData || null);
  }
})(typeof self !== 'undefined' ? self : (typeof window !== 'undefined' ? window : this), function (INITIAL_DATA) {
  'use strict';

  var VERSION = '1.1.0';
  var CONFIG_VERSION = 'v1';
  var EMPTY = '-';
  var WP_NO = 'no';
  var WP_YES = 'yes';
  var BUILD_ALPHABET = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ';
  var BUILD_PREFIX = 'CRIB-';
  var BUILD_LENGTH = 6;
  /* The longest valid config is about 120 characters, about 200 with Hollis's own add-on names. */
  var CONFIG_MAX = 400;

  var PROP_BUILD_ID = 'CRIB Build ID';
  var PROP_BUILD = 'Build';
  var PROP_COLORS = 'Colors';
  var PROP_ADDONS = 'Add-ons';
  var PROP_SHEET = '_Hollis order sheet';
  var PROP_LINK = '_Hollis builder link';
  var PROP_CONFIG = '_CRIB config';
  var PROP_TOTAL = '_Build total';
  var PROP_BUILDER = '_Builder';
  var PROP_PART_OF = 'Part of CRIB Build';
  var PROP_PART = 'Part';

  var DATA = null;
  var ADDON_ALIAS = {};
  var ALIAS_COMMAS = 0;
  var BAKED = null;
  var api = {};

  /* ------------------------------------------------------------------ helpers */

  function has(obj, key) {
    return obj !== null && obj !== undefined && Object.prototype.hasOwnProperty.call(obj, key);
  }

  function isString(v) {
    return typeof v === 'string';
  }

  function str(v) {
    return (v === null || v === undefined) ? '' : String(v);
  }

  function trim(v) {
    return str(v).replace(/^\s+|\s+$/g, '');
  }

  function copy(obj) {
    var out = {};
    var k;
    for (k in obj) {
      if (has(obj, k)) { out[k] = obj[k]; }
    }
    return out;
  }

  function needData() {
    if (!DATA) {
      throw new Error('DCCrib: no data. Define window.DCCribData before crib-core.js or call DCCrib.setData(data).');
    }
    return DATA;
  }

  var HTML_UNSAFE = new RegExp('[&<>"' + String.fromCharCode(39) + String.fromCharCode(96) + ']', 'g');

  function escapeHtml(value) {
    return str(value).replace(HTML_UNSAFE, function (ch) {
      if (ch === '&') { return '&amp;'; }
      if (ch === '<') { return '&lt;'; }
      if (ch === '>') { return '&gt;'; }
      if (ch === '"') { return '&quot;'; }
      if (ch.charCodeAt(0) === 39) { return '&#39;'; }
      return '&#96;';
    });
  }

  function toCents(value) {
    var s;
    var m;
    if (typeof value === 'number') {
      return isFinite(value) ? Math.round(value) : null;
    }
    if (!isString(value)) { return null; }
    s = trim(value).replace(/[$,\s]/g, '');
    if (/^\d+$/.test(s)) { return parseInt(s, 10); }
    m = /^(\d+)\.(\d{1,2})$/.exec(s);
    if (m) {
      return parseInt(m[1], 10) * 100 + parseInt(m[2].length === 1 ? m[2] + '0' : m[2], 10);
    }
    return null;
  }

  /* Hollis price strings ("129.95") to cents, without float maths. */
  function dollarsToCents(text) {
    var m = /^(\d+)(?:\.(\d{1,2}))?$/.exec(trim(text));
    var frac;
    if (!m) { return 0; }
    frac = m[2] ? (m[2].length === 1 ? m[2] + '0' : m[2]) : '00';
    return parseInt(m[1], 10) * 100 + parseInt(frac, 10);
  }

  function plainMoney(cents) {
    var n = Math.round(Number(cents));
    var neg;
    var whole;
    var frac;
    if (!isFinite(n)) { return ''; }
    neg = n < 0;
    n = Math.abs(n);
    whole = Math.floor(n / 100);
    frac = n % 100;
    return (neg ? '-' : '') + whole + '.' + (frac < 10 ? '0' : '') + frac;
  }

  function formatMoney(cents) {
    var plain = (cents === null || cents === undefined || cents === '') ? '' : plainMoney(cents);
    var neg;
    var parts;
    if (plain === '') { return ''; }
    neg = plain.charAt(0) === '-';
    if (neg) { plain = plain.slice(1); }
    parts = plain.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (neg ? '-' : '') + '$' + parts[0] + '.' + parts[1];
  }

  function httpsUrl(u) {
    if (!isString(u) || u === '') { return null; }
    if (u.indexOf('//') === 0) { return 'https:' + u; }
    return u;
  }

  /* ------------------------------------------------------------------ data */

  function setData(data) {
    var addons;
    var id;
    DATA = data || null;
    ADDON_ALIAS = {};
    ALIAS_COMMAS = 0;
    BAKED = null;
    if (DATA && DATA.options && DATA.options.addons) {
      addons = DATA.options.addons;
      for (id in addons) {
        if (has(addons, id)) {
          ADDON_ALIAS[id] = id;
          if (addons[id].hollisKey) { ADDON_ALIAS[addons[id].hollisKey] = id; }
        }
      }
      for (id in ADDON_ALIAS) {
        if (has(ADDON_ALIAS, id)) { ALIAS_COMMAS = Math.max(ALIAS_COMMAS, id.split(',').length - 1); }
      }
    }
    api.DATA = DATA;
    api.RIGS = DATA && DATA.rigOrder ? DATA.rigOrder.slice() : ['single', 'double', 'sidemount'];
    return api;
  }

  function rigOf(rigKey) {
    var d = needData();
    return (isString(rigKey) && has(d.rigs, rigKey)) ? d.rigs[rigKey] : null;
  }

  function optionOf(group, key) {
    var g = needData().options[group];
    return (isString(key) && has(g, key)) ? g[key] : null;
  }

  function colourOf(key) {
    var c = needData().colors;
    return (isString(key) && has(c, key)) ? c[key] : null;
  }

  function addonId(key) {
    return (isString(key) && has(ADDON_ALIAS, key)) ? ADDON_ALIAS[key] : null;
  }

  function inList(list, value) {
    return !!list && list.indexOf(value) !== -1;
  }

  function skuFrom(pattern, colourKey) {
    var c = colourOf(colourKey);
    if (!pattern || !c) { return null; }
    return pattern.replace('{cc}', c.code);
  }

  function stepsFor(rigKey) {
    var rig = rigOf(rigKey);
    return rig ? rig.steps.slice() : [];
  }

  function newState(rigKey) {
    return {
      rig: rigOf(rigKey) ? rigKey : null,
      wing: null,
      harness: null,
      tankBands: null,
      backplate: null,
      wingColor: null,
      backpadColor: null,
      shoulderColor: null,
      weightPockets: undefined,
      addons: []
    };
  }

  function rigHas(rig, what) {
    if (!rig) { return false; }
    if (what === 'harness') { return rig.harnesses.length > 0; }
    if (what === 'tankBands') { return rig.tankBands.length > 0; }
    if (what === 'backplate') { return rig.backplates.length > 0; }
    if (what === 'weightPockets') { return !!rig.weightPockets; }
    return false;
  }

  function cleanChoice(value) {
    var t = trim(value).replace(/\s+/g, ' ');
    return t === '' ? null : t;
  }

  /* Canonical option name for a value typed with different case or spacing. Unknown values are
     returned unchanged so validate() can reject them. */
  function canonChoice(group, value) {
    var t = cleanChoice(value);
    var g;
    var k;
    var low;
    if (t === null || !DATA) { return t; }
    g = DATA.options[group];
    if (has(g, t)) { return t; }
    low = t.toLowerCase();
    for (k in g) {
      if (has(g, k) && k.toLowerCase() === low) { return k; }
    }
    return t;
  }

  function cleanColour(value) {
    var t = trim(value).toLowerCase();
    if (t === 'cam' || t === 'multicam') { t = 'camo'; }
    return t === '' ? null : t;
  }

  /* Add-ons in Hollis's add-on order for the rig, ids only, no duplicates. Unknown keys are kept
     at the end (as given) so validate() can report them. */
  function cleanAddons(rig, list) {
    var known = {};
    var unknown = [];
    var out = [];
    var i;
    var id;
    if (!list || typeof list.length !== 'number' || isString(list)) { return out; }
    for (i = 0; i < list.length; i++) {
      id = addonId(trim(list[i]));
      if (id && rig && inList(rig.addons, id)) {
        known[id] = true;
      } else if (trim(list[i]) !== '' && !inList(unknown, trim(list[i]))) {
        unknown.push(trim(list[i]));
      }
    }
    if (rig) {
      for (i = 0; i < rig.addons.length; i++) {
        if (known[rig.addons[i]]) { out.push(rig.addons[i]); }
      }
    }
    return out.concat(unknown);
  }

  /* Returns a tidy copy of the state: trimmed values, colours in Hollis spelling, add-ons in
     canonical order, fields that do not belong to the rig cleared. */
  function normalize(state) {
    var s = state || {};
    var rigKey = cleanChoice(s.rig);
    var rig = rigOf(rigKey);
    var out = newState(rig ? rigKey : null);
    var wp;
    out.wing = canonChoice('wing', s.wing);
    out.wingColor = cleanColour(s.wingColor);
    if (!rig || rigHas(rig, 'harness')) {
      out.harness = canonChoice('harness', s.harness);
      out.backpadColor = cleanColour(s.backpadColor);
      out.shoulderColor = cleanColour(s.shoulderColor);
    }
    if (!rig || rigHas(rig, 'tankBands')) { out.tankBands = canonChoice('tankBands', s.tankBands); }
    if (!rig || rigHas(rig, 'backplate')) { out.backplate = canonChoice('backplate', s.backplate); }
    if (!rig || rigHas(rig, 'weightPockets')) {
      wp = s.weightPockets;
      if (wp === undefined) {
        out.weightPockets = undefined;
      } else if (wp === null || wp === false) {
        out.weightPockets = null;
      } else if (wp === true) {
        out.weightPockets = WP_YES;
      } else {
        out.weightPockets = cleanColour(wp);
        if (out.weightPockets === null) {
          out.weightPockets = undefined;
        } else if (out.weightPockets === 'true') {
          out.weightPockets = WP_YES;
        } else if (out.weightPockets === WP_NO || out.weightPockets === 'none' || out.weightPockets === 'false') {
          out.weightPockets = null;
        }
      }
    }
    out.addons = cleanAddons(rig, s.addons);
    return out;
  }

  /* ------------------------------------------------------------------ validation */

  function validate(state) {
    var errors = [];
    var s;
    var rig;
    var wing;
    var i;
    function fail(step, field, message) {
      errors.push({ step: step, field: field, message: message });
    }
    needData();
    s = normalize(state);
    rig = rigOf(s.rig);
    if (!rig) {
      fail('rig', 'rig', 'Choose a rig: Single Tank, Double Tank or Sidemount.');
      return { ok: false, errors: errors };
    }

    wing = inList(rig.wings, s.wing) ? optionOf('wing', s.wing) : null;
    if (!wing) { fail('wing', 'wing', 'Choose a wing.'); }

    if (rigHas(rig, 'harness') && !inList(rig.harnesses, s.harness)) {
      fail('harness', 'harness', 'Choose a harness.');
    }
    if (rigHas(rig, 'tankBands') && !inList(rig.tankBands, s.tankBands)) {
      fail('tankBands', 'tankBands', 'Choose tank bands.');
    }
    if (rigHas(rig, 'backplate') && !inList(rig.backplates, s.backplate)) {
      fail('backplate', 'backplate', 'Choose a backplate.');
    }

    if (!colourOf(s.wingColor)) {
      fail('colors', 'wingColor', 'Choose a wing color.');
    } else if (wing && !inList(wing.colors, s.wingColor)) {
      fail('colors', 'wingColor', 'Hollis\'s builder does not offer the ' + wing.label + ' in ' +
        colourOf(s.wingColor).label + '. Choose another wing color.');
    }
    if (rigHas(rig, 'harness')) {
      if (!colourOf(s.backpadColor)) { fail('colors', 'backpadColor', 'Choose a backpad color.'); }
      if (!colourOf(s.shoulderColor)) { fail('colors', 'shoulderColor', 'Choose a shoulder pad color.'); }
    }
    if (rigHas(rig, 'weightPockets')) {
      if (s.weightPockets === undefined) {
        fail('colors', 'weightPockets', 'Choose Yes or No for weight pockets.');
      } else if (s.weightPockets !== null && !colourOf(s.weightPockets)) {
        fail('colors', 'weightPockets', 'Choose a weight pocket color.');
      }
    }

    for (i = 0; i < s.addons.length; i++) {
      if (!inList(rig.addons, s.addons[i])) {
        fail('addons', 'addons', 'Hollis\'s builder does not offer that add-on for this rig.');
        break;
      }
    }
    return { ok: errors.length === 0, errors: errors };
  }

  /* ------------------------------------------------------------------ parts of a build */

  /* Every part the state has fully decided, in cart line order. No catalog needed. */
  function partsFor(state) {
    var d = needData();
    var s = normalize(state);
    var rig = rigOf(s.rig);
    var parts = [];
    var wing;
    var harness;
    var opt;
    var c;
    var i;
    var a;
    if (!rig) { return parts; }

    wing = inList(rig.wings, s.wing) ? optionOf('wing', s.wing) : null;
    c = colourOf(s.wingColor);
    if (wing && c && inList(wing.colors, s.wingColor)) {
      parts.push({
        role: 'wing', main: true, hollisChoice: wing.hollis, colour: c.key,
        hollisLabel: wing.hollis + ', Wing Colors: ' + c.hollis,
        shopperLabel: wing.shopperLabel + ', ' + c.label,
        sku: skuFrom(wing.skuPattern, c.key), handle: wing.handle
      });
    }

    harness = (rigHas(rig, 'harness') && inList(rig.harnesses, s.harness)) ? optionOf('harness', s.harness) : null;
    if (harness) {
      parts.push({
        role: 'harness', main: false, hollisChoice: harness.hollis, colour: null,
        hollisLabel: harness.hollis + ' Harness',
        shopperLabel: harness.shopperLabel,
        sku: harness.sku, handle: harness.handle
      });
    }

    opt = (rigHas(rig, 'tankBands') && inList(rig.tankBands, s.tankBands)) ? optionOf('tankBands', s.tankBands) : null;
    if (opt) {
      parts.push({
        role: 'tankBands', main: false, hollisChoice: opt.hollis, colour: null,
        hollisLabel: opt.hollis + ' Tank Bands',
        shopperLabel: opt.shopperLabel,
        sku: opt.sku, handle: opt.handle
      });
    }

    opt = (rigHas(rig, 'backplate') && inList(rig.backplates, s.backplate)) ? optionOf('backplate', s.backplate) : null;
    if (opt) {
      parts.push({
        role: 'backplate', main: false, hollisChoice: opt.hollis, colour: null,
        hollisLabel: opt.hollis + ' Backplate',
        shopperLabel: opt.shopperLabel,
        sku: opt.sku, handle: opt.handle
      });
    }

    if (rigHas(rig, 'harness')) {
      c = colourOf(s.backpadColor);
      if (c) {
        parts.push({
          role: 'backpad', main: false, hollisChoice: null, colour: c.key,
          hollisLabel: 'Backpad: ' + c.hollis,
          shopperLabel: d.options.backpad.shopperLabel + ', ' + c.label,
          sku: skuFrom(d.options.backpad.skuPattern, c.key), handle: d.options.backpad.handle
        });
      }
      c = colourOf(s.shoulderColor);
      if (c && harness) {
        parts.push({
          role: 'shoulderPads', main: false, hollisChoice: harness.hollis, colour: c.key,
          hollisLabel: 'Shoulder Colors: ' + c.hollis,
          shopperLabel: harness.shoulder.label + ', ' + c.label,
          sku: skuFrom(harness.shoulder.skuPattern, c.key), handle: harness.shoulder.handle
        });
      }
    }

    if (rigHas(rig, 'weightPockets') && isString(s.weightPockets)) {
      c = colourOf(s.weightPockets);
      if (c) {
        parts.push({
          role: 'weightPockets', main: false, hollisChoice: null, colour: c.key,
          hollisLabel: 'Weight Pockets: ' + c.hollis,
          shopperLabel: d.options.weightPockets.shopperLabel + ', ' + c.label,
          sku: skuFrom(d.options.weightPockets.skuPattern, c.key), handle: d.options.weightPockets.handle
        });
      }
    }

    for (i = 0; i < s.addons.length; i++) {
      if (inList(rig.addons, s.addons[i])) {
        a = d.options.addons[s.addons[i]];
        parts.push({
          role: 'addon', main: false, hollisChoice: a.hollisName, colour: null, addon: a.id,
          hollisLabel: a.hollisName,
          shopperLabel: a.label,
          sku: a.sku, handle: a.handle
        });
      }
    }
    return parts;
  }

  /* Required coloured parts whose product is known but whose colour is not chosen yet. */
  function pendingFor(state) {
    var d = needData();
    var s = normalize(state);
    var rig = rigOf(s.rig);
    var out = [];
    var wing;
    var harness;
    if (!rig) { return out; }
    wing = inList(rig.wings, s.wing) ? optionOf('wing', s.wing) : null;
    if (wing && !(colourOf(s.wingColor) && inList(wing.colors, s.wingColor))) {
      out.push({ role: 'wing', field: 'wingColor', shopperLabel: wing.shopperLabel, handle: wing.handle, skuPattern: wing.skuPattern, colors: wing.colors });
    }
    if (rigHas(rig, 'harness')) {
      if (!colourOf(s.backpadColor)) {
        out.push({ role: 'backpad', field: 'backpadColor', shopperLabel: d.options.backpad.shopperLabel, handle: d.options.backpad.handle, skuPattern: d.options.backpad.skuPattern, colors: d.options.backpad.colors });
      }
      harness = inList(rig.harnesses, s.harness) ? optionOf('harness', s.harness) : null;
      if (harness && !colourOf(s.shoulderColor)) {
        out.push({ role: 'shoulderPads', field: 'shoulderColor', shopperLabel: harness.shoulder.label, handle: harness.shoulder.handle, skuPattern: harness.shoulder.skuPattern, colors: d.colorOrder });
      }
    }
    if (rigHas(rig, 'weightPockets') && isString(s.weightPockets) && !colourOf(s.weightPockets)) {
      out.push({ role: 'weightPockets', field: 'weightPockets', shopperLabel: d.options.weightPockets.shopperLabel, handle: d.options.weightPockets.handle, skuPattern: d.options.weightPockets.skuPattern, colors: d.options.weightPockets.colors });
    }
    return out;
  }

  /* ------------------------------------------------------------------ catalog */

  function emptyCatalog() {
    return { bySku: {}, assembly: null, handles: [] };
  }

  /* productsByHandle: map of handle -> /products/<handle>.js payload (or an array of payloads).
     Entries that are null or have no variants (failed fetches) are skipped.
     opts.assemblyHandle: handle of the assembly charge product (section setting assembly_handle). */
  function catalogFromProducts(productsByHandle, opts) {
    var d = needData();
    var cat = emptyCatalog();
    var asmHandle = (opts && opts.assemblyHandle) ? trim(opts.assemblyHandle) : '';
    var key;
    function addProduct(p, fallbackHandle) {
      var handle;
      var productImage;
      var i;
      var v;
      var sku;
      var entry;
      var isAssembly;
      if (p && p.product && p.product.variants) { p = p.product; }
      if (!p || !p.variants || typeof p.variants.length !== 'number') { return; }
      handle = trim(p.handle || fallbackHandle);
      productImage = httpsUrl(isString(p.featured_image) ? p.featured_image : (p.featured_image && p.featured_image.src));
      if (!productImage && p.image && p.image.src) { productImage = httpsUrl(p.image.src); }
      if (handle !== '' && !inList(cat.handles, handle)) { cat.handles.push(handle); }
      isAssembly = (asmHandle !== '' && handle === asmHandle) || (d.assembly && handle === d.assembly.handle);
      for (i = 0; i < p.variants.length; i++) {
        v = p.variants[i];
        if (!v) { continue; }
        sku = trim(v.sku);
        entry = {
          variantId: v.id,
          price: toCents(v.price),
          available: v.available === true,
          title: str(p.title),
          variantTitle: (v.title && v.title !== 'Default Title') ? str(v.title) : null,
          image: httpsUrl(v.featured_image && v.featured_image.src) || productImage,
          handle: handle,
          sku: sku
        };
        if (sku !== '' && !has(cat.bySku, sku)) { cat.bySku[sku] = entry; }
        if ((isAssembly || (d.assembly && sku !== '' && sku === d.assembly.sku)) &&
            (!cat.assembly || (!cat.assembly.available && entry.available))) {
          cat.assembly = entry;
        }
      }
    }
    if (productsByHandle && typeof productsByHandle.length === 'number' && !isString(productsByHandle)) {
      for (key = 0; key < productsByHandle.length; key++) { addProduct(productsByHandle[key], ''); }
    } else if (productsByHandle) {
      for (key in productsByHandle) {
        if (has(productsByHandle, key)) { addProduct(productsByHandle[key], key); }
      }
    }
    return cat;
  }

  function bakedCatalog() {
    var d = needData();
    if (!BAKED) { BAKED = catalogFromProducts(d.baked && d.baked.products); }
    return BAKED;
  }

  /* Entries of `live` replace entries of `base`. Neither input is changed. */
  function mergeCatalogs(base, live) {
    var out = emptyCatalog();
    var k;
    var i;
    var srcs = [base, live];
    var c;
    for (i = 0; i < srcs.length; i++) {
      c = srcs[i];
      if (!c) { continue; }
      for (k in c.bySku) {
        if (has(c.bySku, k)) { out.bySku[k] = c.bySku[k]; }
      }
      if (c.assembly) { out.assembly = c.assembly; }
      for (k = 0; c.handles && k < c.handles.length; k++) {
        if (!inList(out.handles, c.handles[k])) { out.handles.push(c.handles[k]); }
      }
    }
    return out;
  }

  /* Product handles the storefront needs to read for a rig. */
  function handlesFor(rigKey, opts) {
    var d = needData();
    var rig = rigOf(rigKey);
    var out = [];
    var i;
    var o;
    function add(h) {
      if (h && !inList(out, h)) { out.push(h); }
    }
    if (!rig) { return out; }
    for (i = 0; i < rig.wings.length; i++) { add(d.options.wing[rig.wings[i]].handle); }
    for (i = 0; i < rig.harnesses.length; i++) { add(d.options.harness[rig.harnesses[i]].handle); }
    for (i = 0; i < rig.tankBands.length; i++) { add(d.options.tankBands[rig.tankBands[i]].handle); }
    for (i = 0; i < rig.backplates.length; i++) { add(d.options.backplate[rig.backplates[i]].handle); }
    if (rigHas(rig, 'harness')) {
      add(d.options.backpad.handle);
      for (i = 0; i < rig.harnesses.length; i++) {
        o = d.options.harness[rig.harnesses[i]];
        add(o.shoulder.handle);
      }
    }
    if (rigHas(rig, 'weightPockets')) { add(d.options.weightPockets.handle); }
    for (i = 0; i < rig.addons.length; i++) { add(d.options.addons[rig.addons[i]].handle); }
    if (opts && opts.assemblyHandle && trim(opts.assemblyHandle) !== '') { add(trim(opts.assemblyHandle)); }
    return out;
  }

  /* ------------------------------------------------------------------ resolve */

  function roleLabel(role) {
    var r = needData().roles;
    return has(r, role) ? r[role].label : role;
  }

  function firstPriceFor(catalog, pattern, colours) {
    var i;
    var sku;
    for (i = 0; i < colours.length; i++) {
      sku = skuFrom(pattern, colours[i]);
      if (sku && has(catalog.bySku, sku) && catalog.bySku[sku].price !== null) {
        return catalog.bySku[sku].price;
      }
    }
    return null;
  }

  /* opts.assembly === false leaves the assembly line out even when the catalog has one. */
  function resolve(state, catalog, opts) {
    var cat = catalog || bakedCatalog();
    var parts = partsFor(state);
    var waiting = pendingFor(state);
    var lines = [];
    var missing = [];
    var pending = [];
    var total = 0;
    var estimated = 0;
    var i;
    var p;
    var e;
    var price;
    for (i = 0; i < parts.length; i++) {
      p = parts[i];
      e = has(cat.bySku, p.sku) ? cat.bySku[p.sku] : null;
      if (!e || e.variantId === null || e.variantId === undefined || e.price === null) {
        missing.push({ role: p.role, roleLabel: roleLabel(p.role), sku: p.sku, reason: 'not_in_catalog', shopperLabel: p.shopperLabel, addon: p.addon || null });
        continue;
      }
      lines.push({
        role: p.role,
        roleLabel: roleLabel(p.role),
        hollisLabel: p.hollisLabel,
        shopperLabel: p.shopperLabel,
        colour: p.colour,
        sku: p.sku,
        variantId: e.variantId,
        handle: e.handle || p.handle,
        price: e.price,
        available: e.available,
        qty: 1,
        image: e.image,
        main: p.main,
        addon: p.addon || null,
        title: e.title
      });
      total += e.price;
      if (!e.available) {
        missing.push({ role: p.role, roleLabel: roleLabel(p.role), sku: p.sku, reason: 'unavailable', shopperLabel: p.shopperLabel, addon: p.addon || null });
      }
    }
    if (lines.length > 0 && cat.assembly && cat.assembly.available && cat.assembly.price !== null &&
        cat.assembly.variantId && !(opts && opts.assembly === false)) {
      e = cat.assembly;
      lines.push({
        role: 'assembly',
        roleLabel: roleLabel('assembly'),
        hollisLabel: needData().assembly.hollisName,
        shopperLabel: needData().assembly.label,
        colour: null,
        sku: e.sku,
        variantId: e.variantId,
        handle: e.handle,
        price: e.price,
        available: true,
        qty: 1,
        image: e.image,
        main: false,
        addon: null,
        title: e.title
      });
      total += e.price;
    }
    estimated = total;
    for (i = 0; i < waiting.length; i++) {
      price = firstPriceFor(cat, waiting[i].skuPattern, waiting[i].colors);
      pending.push({
        role: waiting[i].role,
        roleLabel: roleLabel(waiting[i].role),
        field: waiting[i].field,
        shopperLabel: waiting[i].shopperLabel,
        handle: waiting[i].handle,
        price: price
      });
      if (price !== null) { estimated += price; }
    }
    return { lines: lines, missing: missing, pending: pending, total: total, estimatedTotal: estimated };
  }

  /* ------------------------------------------------------------------ build id */

  function randomBytes(n) {
    var out = [];
    var arr;
    var i;
    var g = (typeof self !== 'undefined') ? self : ((typeof window !== 'undefined') ? window : null);
    var c = (typeof crypto !== 'undefined') ? crypto : (g && (g.crypto || g.msCrypto));
    if (c && typeof c.getRandomValues === 'function' && typeof Uint8Array !== 'undefined') {
      arr = new Uint8Array(n);
      c.getRandomValues(arr);
      for (i = 0; i < n; i++) { out.push(arr[i]); }
      return out;
    }
    for (i = 0; i < n; i++) { out.push(Math.floor(Math.random() * 256)); }
    return out;
  }

  function newBuildId() {
    var bytes = randomBytes(BUILD_LENGTH);
    var id = BUILD_PREFIX;
    var i;
    for (i = 0; i < BUILD_LENGTH; i++) {
      id += BUILD_ALPHABET.charAt(bytes[i] % BUILD_ALPHABET.length);
    }
    return id;
  }

  function isBuildId(value) {
    return isString(value) && /^CRIB-[23456789ABCDEFGHJKLMNPQRSTUVWXYZ]{6}$/.test(value);
  }

  /* ------------------------------------------------------------------ Hollis share link */

  /* json.dumps(obj, separators=(',', ':')) with Python's default ensure_ascii. */
  var NON_ASCII = new RegExp('[' + String.fromCharCode(127) + '-' + String.fromCharCode(65535) + ']', 'g');

  function pyJson(value) {
    return JSON.stringify(value).replace(NON_ASCII, function (ch) {
      var hex = ch.charCodeAt(0).toString(16);
      while (hex.length < 4) { hex = '0' + hex; }
      return '\\u' + hex;
    });
  }

  function utf8Bytes(text) {
    var out = [];
    var i;
    var c;
    var next;
    for (i = 0; i < text.length; i++) {
      c = text.charCodeAt(i);
      if (c >= 0xd800 && c <= 0xdbff && i + 1 < text.length) {
        next = text.charCodeAt(i + 1);
        if (next >= 0xdc00 && next <= 0xdfff) {
          c = 0x10000 + ((c - 0xd800) << 10) + (next - 0xdc00);
          i++;
        }
      }
      if (c < 0x80) {
        out.push(c);
      } else if (c < 0x800) {
        out.push(0xc0 | (c >> 6), 0x80 | (c & 0x3f));
      } else if (c < 0x10000) {
        out.push(0xe0 | (c >> 12), 0x80 | ((c >> 6) & 0x3f), 0x80 | (c & 0x3f));
      } else {
        out.push(0xf0 | (c >> 18), 0x80 | ((c >> 12) & 0x3f), 0x80 | ((c >> 6) & 0x3f), 0x80 | (c & 0x3f));
      }
    }
    return out;
  }

  function base64FromBytes(bytes) {
    var abc = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var out = '';
    var i;
    var b0;
    var b1;
    var b2;
    for (i = 0; i < bytes.length; i += 3) {
      b0 = bytes[i];
      b1 = i + 1 < bytes.length ? bytes[i + 1] : 0;
      b2 = i + 2 < bytes.length ? bytes[i + 2] : 0;
      out += abc.charAt(b0 >> 2);
      out += abc.charAt(((b0 & 3) << 4) | (b1 >> 4));
      out += i + 1 < bytes.length ? abc.charAt(((b1 & 15) << 2) | (b2 >> 6)) : '=';
      out += i + 2 < bytes.length ? abc.charAt(b2 & 63) : '=';
    }
    return out;
  }

  /* how: 'buffer' | 'btoa' | 'pure' forces one path (used by the tests). */
  function base64Utf8(text, how) {
    var bytes;
    var bin;
    var i;
    if ((how === 'buffer' || !how) && typeof Buffer !== 'undefined' && typeof Buffer.from === 'function') {
      return Buffer.from(text, 'utf8').toString('base64');
    }
    bytes = utf8Bytes(text);
    if ((how === 'btoa' || !how) && typeof btoa === 'function') {
      bin = '';
      for (i = 0; i < bytes.length; i++) { bin += String.fromCharCode(bytes[i]); }
      return btoa(bin);
    }
    return base64FromBytes(bytes);
  }

  /* Line by line port of build() in tools/hollis_link.py. Returns null for an invalid build, and
     for a build whose choice is missing from the Hollis tables (parts.json "hollis"): a table that
     lags behind the options must never produce a half-filled link or sheet. */
  function hollisData(state) {
    var H = needData().hollis;
    var s;
    var rig;
    var wing;
    var items = [];
    var config = {};
    var item;
    var h;
    var t;
    var b;
    var sh;
    var ad;
    var i;
    var key;
    var hasHarness;
    var total = 0;
    if (!validate(state).ok) { return null; }
    s = normalize(state);
    if (!H || !has(H.RIGS, s.rig) || !H.ASSEMBLY) { return null; }
    rig = H.RIGS[s.rig];
    if (!rig || !rig.bundle || !rig.steps || !has(rig.wings, s.wing)) { return null; }
    wing = rig.wings[s.wing];
    if (!wing || !has(wing.colors, s.wingColor)) { return null; }

    item = copy(rig.bundle);
    item.price = '0.00';
    item.type = 'main';
    item.navNameRaw = rig.bundle.name;
    items.push(item);
    items.push(copy(H.ASSEMBLY));
    items.push({ name: rig.wings_group, productId: wing.productId, price: '0.00', type: 'main', navName: 'wings', navNameRaw: 'Wings' });
    config.wings = s.wing;

    hasHarness = inList(rig.steps, 'harness');
    if (hasHarness) {
      if (!has(H.HARNESS, s.harness) || !has(H.SHOULDER, s.harness) || !H.BACKPAD ||
          !has(H.BACKPAD.ids, s.backpadColor) || !has(H.SHOULDER[s.harness].ids, s.shoulderColor)) {
        return null;
      }
      h = H.HARNESS[s.harness];
      items.push({ name: h.name, productId: h.productId, price: h.price, type: 'main', navName: 'harness', navNameRaw: 'Harness' });
      config.harness = s.harness;
    }
    if (inList(rig.steps, 'tankBands')) {
      if (!has(H.TANK_BANDS, s.tankBands)) { return null; }
      t = H.TANK_BANDS[s.tankBands];
      items.push({ name: 'variation_24084', productId: t.productId, price: t.price, type: 'main', navName: 'tank_bands', navNameRaw: 'Tank Bands' });
      config.tankBands = s.tankBands;
    }
    if (inList(rig.steps, 'backplate')) {
      if (!has(H.BACKPLATE, s.backplate)) { return null; }
      b = H.BACKPLATE[s.backplate];
      items.push({ name: 'variation_24235', productId: b.productId, price: b.price, type: 'main', navName: 'backplate', navNameRaw: 'Backplate' });
      config.backplate = s.backplate;
    }
    items.push({ name: 'wing_colors', productId: wing.colors[s.wingColor], price: wing.price, type: 'color', variationName: s.wingColor, navName: 'wing_colors', navNameRaw: 'Wing Colors' });
    config.wingColor = s.wingColor;
    if (hasHarness) {
      items.push({ name: 'backpad', productId: H.BACKPAD.ids[s.backpadColor], price: H.BACKPAD.price, type: 'color', variationName: s.backpadColor, navName: 'Backpad', navNameRaw: 'Backpad' });
      config.backpad = s.backpadColor;
      sh = H.SHOULDER[s.harness];
      items.push({ name: 'shoulder_colors', productId: sh.ids[s.shoulderColor], price: sh.price, type: 'color', variationName: s.shoulderColor, navName: 'shoulder_colors', navNameRaw: 'Shoulder Colors' });
      config.shoulderColors = s.shoulderColor;
    }
    for (i = 0; i < s.addons.length; i++) {
      key = needData().options.addons[s.addons[i]].hollisKey;
      if (!has(rig.addons, key)) { return null; }
      ad = rig.addons[key];
      items.push({ name: key, productId: ad.productId, price: ad.price, type: 'addon', navName: ad.navName, navNameRaw: ad.navName });
    }
    if (rig.weight_pockets) {
      config.weightPockets = s.weightPockets || null;
      if (s.weightPockets && (!H.WEIGHT_POCKETS || !has(H.WEIGHT_POCKETS.ids, s.weightPockets))) { return null; }
      if (s.weightPockets) {
        items.push({ name: 'weight_pockets', productId: H.WEIGHT_POCKETS.ids[s.weightPockets], price: H.WEIGHT_POCKETS.price, type: 'optional', variationName: s.weightPockets, navName: 'Weight Pockets', navNameRaw: 'Weight Pockets' });
      }
    }
    for (i = 0; i < items.length; i++) { total += dollarsToCents(items[i].price); }
    return {
      slug: rig.slug,
      data: { slide: rig.summary_slide, config: config, items: items },
      total: total
    };
  }

  function hollisLink(state) {
    var H;
    var built = hollisData(state);
    if (!built) { return null; }
    H = needData().hollis;
    return H.urlBase + built.slug + H.urlQuery + base64Utf8(pyJson(built.data));
  }

  /* Hollis prices a few colours above the flat price of their group (parts.json
     hollis.priceOverrides). Returns the price text of that colour, or null when it is flat. */
  function overridePrice(group, name, colour) {
    var table = needData().hollis.priceOverrides;
    var rows = (table && has(table, group)) ? table[group] : null;
    var row = (rows && has(rows, name)) ? rows[name] : null;
    var text = (row && has(row, colour)) ? row[colour] : null;
    return (isString(text) && /^\d+(\.\d{1,2})?$/.test(trim(text))) ? trim(text) : null;
  }

  /* What staff see on Hollis's Summary step, in Hollis's order and words, with HOLLIS prices.

     Two sets of figures, because Hollis's page shows two:
       price, total               the flat prices the share link carries. Hollis's Summary shows
                                  these when the build is opened from the link (equal to
                                  tools/hollis_link.py).
       priceByHand, totalByHand   what the Summary shows when the same build is clicked together
                                  by hand. Differs only for the colours in hollis.priceOverrides.
     differs is true when the two totals are not the same; byHand lists the lines behind it. */
  function hollisSummary(state) {
    var d = needData();
    var H = d.hollis;
    var built = hollisData(state);
    var s;
    var rig;
    var lines = [];
    var byName = {};
    var byHand = [];
    var handTotal;
    var items;
    var i;
    var it;
    function push(label, priceText, kind, handText) {
      var cents = (priceText === null) ? null : dollarsToCents(priceText);
      var hand = (cents === null || handText === null || handText === undefined) ? cents : dollarsToCents(handText);
      lines.push({
        label: label, price: cents, priceText: cents === null ? '' : formatMoney(cents), kind: kind,
        priceByHand: hand, priceByHandText: hand === null ? '' : formatMoney(hand)
      });
      if (hand !== cents) {
        handTotal += hand - cents;
        byHand.push({ label: label, price: cents, priceText: formatMoney(cents), priceByHand: hand, priceByHandText: formatMoney(hand) });
      }
    }
    if (!built) { return null; }
    handTotal = built.total;
    s = normalize(state);
    rig = H.RIGS[s.rig];
    items = built.data.items;
    for (i = 0; i < items.length; i++) { byName[items[i].navName] = items[i]; }

    push(rig.bundle.name, null, 'rig');
    push(H.ASSEMBLY.name, H.ASSEMBLY.price, 'assembly');
    push(s.wing, null, 'wing');
    if (byName.harness) { push(s.harness + ' Harness', byName.harness.price, 'harness'); }
    if (byName.tank_bands) { push(s.tankBands + ' Tank Bands', byName.tank_bands.price, 'tankBands'); }
    if (byName.backplate) { push(s.backplate + ' Backplate', byName.backplate.price, 'backplate'); }
    push('Custom Colors', null, 'heading');
    push('Wing Colors: ' + s.wingColor, byName.wing_colors.price, 'color', overridePrice('wing', s.wing, s.wingColor));
    if (byName.Backpad) { push('Backpad: ' + s.backpadColor, byName.Backpad.price, 'color'); }
    if (byName.shoulder_colors) {
      push('Shoulder Colors: ' + s.shoulderColor, byName.shoulder_colors.price, 'color',
        overridePrice('shoulder', s.harness, s.shoulderColor));
    }
    if (byName['Weight Pockets']) { push('Weight Pockets: ' + s.weightPockets, byName['Weight Pockets'].price, 'weightPockets'); }
    for (i = 0; i < items.length; i++) {
      it = items[i];
      if (it.type === 'addon') { push(it.navName, it.price, 'addon'); }
    }
    return {
      rig: s.rig,
      lines: lines,
      total: built.total,
      totalText: formatMoney(built.total),
      totalByHand: handTotal,
      totalByHandText: formatMoney(handTotal),
      differs: handTotal !== built.total,
      byHand: byHand,
      assembly: dollarsToCents(H.ASSEMBLY.price),
      assemblyText: formatMoney(dollarsToCents(H.ASSEMBLY.price))
    };
  }

  /* ------------------------------------------------------------------ config string */

  function field(value) {
    var t = trim(value);
    return t === '' ? EMPTY : t.replace(/\|/g, '/');
  }

  /* v1|rig|wing|harness|tankBands|backplate|wingColor|backpadColor|shoulderColor|weightPockets|addons
     '-' = empty or not part of this rig. weightPockets: colour, 'no' (declined) or '-' (not answered).
     addons: ids joined by commas, in Hollis's add-on order. */
  function configString(state) {
    var s = normalize(state);
    var wp = EMPTY;
    if (s.weightPockets === null) {
      wp = rigHas(rigOf(s.rig), 'weightPockets') ? WP_NO : EMPTY;
    } else if (isString(s.weightPockets)) {
      wp = s.weightPockets;
    }
    return [
      CONFIG_VERSION,
      field(s.rig),
      field(s.wing),
      field(s.harness),
      field(s.tankBands),
      field(s.backplate),
      field(s.wingColor),
      field(s.backpadColor),
      field(s.shoulderColor),
      field(wp),
      s.addons.length ? s.addons.join(',') : EMPTY
    ].join('|');
  }

  function unfield(value) {
    var t = trim(value);
    return (t === '' || t === EMPTY) ? null : t;
  }

  function parseAddons(text) {
    var out = [];
    var tokens;
    var i;
    var j;
    var acc;
    var id;
    var t = unfield(text);
    if (t === null) { return out; }
    tokens = t.split(',');
    i = 0;
    while (i < tokens.length) {
      acc = '';
      id = null;
      /* a Hollis data-item name can itself contain a comma, so try growing the token, but never
         by more commas than the longest known name has */
      for (j = i; j < tokens.length && j <= i + ALIAS_COMMAS; j++) {
        acc = (j === i) ? tokens[j] : acc + ',' + tokens[j];
        id = addonId(trim(acc));
        if (id) { break; }
      }
      if (id) {
        out.push(id);
        i = j + 1;
      } else {
        if (trim(tokens[i]) !== '') { out.push(trim(tokens[i])); }
        i++;
      }
    }
    return out;
  }

  function parseConfigString(text) {
    var parts;
    var s;
    var wp;
    var rig;
    if (!isString(text) || text.length > CONFIG_MAX) { return null; }
    parts = trim(text).split('|');
    if (parts.length < 3 || trim(parts[0]) !== CONFIG_VERSION) { return null; }
    rig = rigOf(trim(parts[1]));
    if (!rig) { return null; }
    while (parts.length < 11) { parts.push(EMPTY); }
    s = newState(rig.key);
    s.wing = unfield(parts[2]);
    s.harness = unfield(parts[3]);
    s.tankBands = unfield(parts[4]);
    s.backplate = unfield(parts[5]);
    s.wingColor = unfield(parts[6]);
    s.backpadColor = unfield(parts[7]);
    s.shoulderColor = unfield(parts[8]);
    wp = unfield(parts[9]);
    if (wp === null) {
      s.weightPockets = undefined;
    } else if (wp.toLowerCase() === WP_NO || wp.toLowerCase() === 'none') {
      s.weightPockets = null;
    } else if (wp.toLowerCase() === WP_YES) {
      s.weightPockets = true;
    } else {
      s.weightPockets = wp;
    }
    s.addons = parseAddons(parts.slice(10).join('|'));
    return normalize(s);
  }

  /* ------------------------------------------------------------------ text for the order */

  function buildText(state) {
    var s = normalize(state);
    var rig = rigOf(s.rig);
    var bits = [];
    var o;
    if (!rig) { return ''; }
    o = inList(rig.wings, s.wing) ? optionOf('wing', s.wing) : null;
    if (o) { bits.push(o.shopperLabel); }
    o = inList(rig.harnesses, s.harness) ? optionOf('harness', s.harness) : null;
    if (o) { bits.push(o.shopperLabel); }
    o = inList(rig.tankBands, s.tankBands) ? optionOf('tankBands', s.tankBands) : null;
    if (o) { bits.push(o.shopperLabel); }
    o = inList(rig.backplates, s.backplate) ? optionOf('backplate', s.backplate) : null;
    if (o) { bits.push(o.shopperLabel); }
    return rig.label + ': ' + bits.join(', ');
  }

  function colorsText(state) {
    var d = needData();
    var s = normalize(state);
    var rig = rigOf(s.rig);
    var bits = [];
    var c;
    if (!rig) { return ''; }
    c = colourOf(s.wingColor);
    if (c) { bits.push(d.zones.wing.label + ' ' + c.label); }
    if (rigHas(rig, 'harness')) {
      c = colourOf(s.backpadColor);
      if (c) { bits.push(d.zones.backpad.label + ' ' + c.label); }
      c = colourOf(s.shoulderColor);
      if (c) { bits.push(d.zones.shoulder.label + ' ' + c.label); }
    }
    if (rigHas(rig, 'weightPockets')) {
      c = colourOf(s.weightPockets);
      if (c) {
        bits.push(d.zones.weightPockets.label + ' ' + c.label);
      } else if (s.weightPockets === null) {
        bits.push('No weight pockets');
      }
    }
    return bits.join(', ');
  }

  function addonsText(state) {
    var d = needData();
    var s = normalize(state);
    var rig = rigOf(s.rig);
    var bits = [];
    var i;
    if (!rig) { return ''; }
    for (i = 0; i < s.addons.length; i++) {
      if (inList(rig.addons, s.addons[i])) { bits.push(d.options.addons[s.addons[i]].label); }
    }
    return bits.join(', ');
  }

  /* Staff sheet. Mirrors Hollis's step order and uses Hollis's words. `resolved` is optional and
     only used to cross-check: part numbers always come from the build itself.
     The numbers are the numbers of Hollis's own step bar, where choosing the rig is step 1, so
     Wings is 2 (Single Tank 2 to 7, Double Tank 2 to 6, Sidemount 2 to 4). */
  function orderSheet(state, resolved, buildId) {
    var d = needData();
    var s;
    var rig;
    var out = [];
    var n = 1;
    var hand = [];
    var harness;
    var parts;
    var skus = [];
    var names = [];
    var i;
    var summary;
    var colours;
    if (!validate(state).ok) { return ''; }
    s = normalize(state);
    rig = rigOf(s.rig);
    summary = hollisSummary(s);
    if (!summary) { return ''; }

    out.push('HOLLIS CRIB ORDER' + (trim(buildId) !== '' ? ' - build ' + trim(buildId) : ''));
    out.push('Open Hollis builder: ' + rig.hollisName);
    n++;
    out.push(n + ' ' + d.steps.wing.hollisLabel + ': ' + s.wing);
    if (rigHas(rig, 'harness')) {
      harness = optionOf('harness', s.harness);
      n++;
      out.push(n + ' ' + d.steps.harness.hollisLabel + ': ' + s.harness +
        (harness.size ? ' (' + harness.hollisNice + ')' : ''));
    }
    if (rigHas(rig, 'tankBands')) {
      n++;
      out.push(n + ' ' + d.steps.tankBands.hollisLabel + ': ' + s.tankBands);
    }
    if (rigHas(rig, 'backplate')) {
      n++;
      out.push(n + ' ' + d.steps.backplate.hollisLabel + ': ' + s.backplate);
    }
    n++;
    colours = [d.zones.wing.hollisLabel + ' ' + s.wingColor];
    if (rigHas(rig, 'harness')) {
      colours.push(d.zones.backpad.hollisLabel + ' ' + s.backpadColor);
      colours.push(d.zones.shoulder.hollisLabel + ' ' + s.shoulderColor);
    }
    out.push(n + ' ' + d.steps.colors.hollisLabel + ': ' + colours.join(' | '));
    if (rigHas(rig, 'weightPockets')) {
      out.push('  ' + d.zones.weightPockets.hollisLabel + ': ' + (s.weightPockets ? 'YES - ' + s.weightPockets : 'NO'));
    }
    n++;
    for (i = 0; i < s.addons.length; i++) { names.push(d.options.addons[s.addons[i]].hollisName); }
    out.push(n + ' ' + d.steps.addons.hollisLabel + ': ' + (names.length ? names.join('; ') : 'none'));

    parts = partsFor(s);
    for (i = 0; i < parts.length; i++) { skus.push(parts[i].sku); }
    out.push('Parts: ' + skus.join(', '));
    if (summary.differs) {
      /* Hollis prices this colour above the flat price the link carries, see hollisSummary() */
      out.push('Hollis summary should total ' + summary.totalByHandText + ' entered by hand (' +
        summary.totalText + ' when opened from the link) incl. ' + summary.assemblyText + ' assembly');
      for (i = 0; i < summary.byHand.length; i++) {
        hand.push(summary.byHand[i].label + ' ' + summary.byHand[i].priceByHandText);
      }
      out.push('Entered by hand Hollis shows ' + hand.join('; '));
    } else {
      out.push('Hollis summary should total ' + summary.totalText + ' incl. ' + summary.assemblyText + ' assembly');
    }
    return out.join('\n');
  }

  /* ------------------------------------------------------------------ cart */

  function cribError(code, message, details) {
    var err = new Error(message);
    err.code = code;
    err.details = details || null;
    return err;
  }

  /* opts:
       catalog        used when `resolved` is not passed
       omitSheet      true leaves out "_Hollis order sheet" (fallback if long values get cut)
       omitLink       true leaves out "_Hollis builder link"
       sections       string or array, copied to the payload for bundled section rendering
       sectionsUrl    string, copied to the payload as sections_url
     Throws when the build is incomplete, a part is missing or sold out, `resolved` does not
     belong to `state`, or the staff sheet or the Hollis link cannot be made (CRIB_DATA): an order
     without them cannot be re-entered at Hollis, so it must not reach the cart unnoticed. */
  function cartPayload(state, resolved, buildId, opts) {
    var o = opts || {};
    var check = validate(state);
    var s;
    var res;
    var expected;
    var own = [];
    var items = [];
    var payload;
    var props;
    var i;
    var line;
    var text;
    var sheet = '';
    var link = '';
    if (!check.ok) {
      throw cribError('CRIB_INCOMPLETE', 'CRIB build is not complete: ' + check.errors[0].message, check.errors);
    }
    if (!isBuildId(buildId)) {
      throw cribError('CRIB_INCOMPLETE', 'CRIB build id is missing or malformed.', null);
    }
    s = normalize(state);
    res = resolved || resolve(s, o.catalog);
    if (!res || !res.lines || !res.missing) {
      throw cribError('CRIB_STALE', 'CRIB build could not be priced.', null);
    }
    if (res.missing.length) {
      throw cribError('CRIB_UNAVAILABLE', 'A part of this build is currently unavailable: ' + res.missing[0].shopperLabel + '.', res.missing);
    }
    expected = partsFor(s);
    for (i = 0; i < res.lines.length; i++) {
      if (res.lines[i].role !== 'assembly') { own.push(res.lines[i]); }
    }
    if (own.length !== expected.length) {
      throw cribError('CRIB_STALE', 'CRIB build changed after it was priced.', null);
    }
    for (i = 0; i < expected.length; i++) {
      if (own[i].sku !== expected[i].sku || own[i].role !== expected[i].role || !own[i].variantId || own[i].available !== true) {
        throw cribError('CRIB_STALE', 'CRIB build changed after it was priced.', null);
      }
    }
    if (!res.lines.length || res.lines[0].role !== 'wing' || res.lines[0].main !== true) {
      throw cribError('CRIB_STALE', 'CRIB build has no main line.', null);
    }

    try {
      if (!o.omitSheet) { sheet = orderSheet(s, res, buildId); }
      if (!o.omitLink) { link = hollisLink(s); }
    } catch (err) {
      throw cribError('CRIB_DATA', 'The staff order sheet or the Hollis link could not be made: ' + str(err && err.message), null);
    }
    if (!o.omitSheet && (!isString(sheet) || sheet === '')) {
      throw cribError('CRIB_DATA', 'The staff order sheet is blank for this build. Check the Hollis tables in parts.json.', null);
    }
    if (!o.omitLink && (!isString(link) || link.indexOf(str(needData().hollis.urlBase)) !== 0 || str(needData().hollis.urlBase) === '')) {
      throw cribError('CRIB_DATA', 'The Hollis builder link could not be made for this build. Check the Hollis tables in parts.json.', null);
    }

    for (i = 0; i < res.lines.length; i++) {
      line = res.lines[i];
      props = {};
      if (i === 0) {
        props[PROP_BUILD_ID] = buildId;
        props[PROP_BUILD] = buildText(s);
        props[PROP_COLORS] = colorsText(s);
        text = addonsText(s);
        if (text !== '') { props[PROP_ADDONS] = text; }
        if (!o.omitSheet) { props[PROP_SHEET] = sheet; }
        if (!o.omitLink) { props[PROP_LINK] = link; }
        props[PROP_CONFIG] = configString(s);
        props[PROP_TOTAL] = plainMoney(res.total);
        props[PROP_BUILDER] = VERSION;
      } else {
        props[PROP_PART_OF] = buildId;
        props[PROP_PART] = line.roleLabel;
      }
      items.push({ id: line.variantId, quantity: 1, properties: props });
    }
    payload = { items: items };
    if (o.sections) {
      payload.sections = isString(o.sections) ? o.sections : o.sections.join(',');
    }
    if (o.sectionsUrl) { payload.sections_url = str(o.sectionsUrl); }
    return payload;
  }

  /* ------------------------------------------------------------------ helpers for the UI */

  /* Option cards for a step: 'wing' | 'harness' | 'tankBands' | 'backplate' | 'addons'.
     With a catalog each option gets price (cents) and available. Coloured wings report the
     price of the first colour and are available when any colour is. */
  function optionsFor(rigKey, step, catalog) {
    var d = needData();
    var rig = rigOf(rigKey);
    var cat = catalog || bakedCatalog();
    var keys = [];
    var group = step;
    var out = [];
    var i;
    var j;
    var o;
    var e;
    var sku;
    var row;
    if (!rig) { return out; }
    if (step === 'wing') { keys = rig.wings; }
    else if (step === 'harness') { keys = rig.harnesses; }
    else if (step === 'tankBands') { keys = rig.tankBands; }
    else if (step === 'backplate') { keys = rig.backplates; }
    else if (step === 'addons') { keys = rig.addons; }
    else { return out; }
    for (i = 0; i < keys.length; i++) {
      o = d.options[group][keys[i]];
      row = {
        key: keys[i],
        label: o.label,
        hollisLabel: o.hollis || o.hollisName,
        facts: (o.facts || []).slice(),
        handle: o.handle,
        sku: o.sku || null,
        skuPattern: o.skuPattern || null,
        image: o.image || null,
        guideImage: o.guideImage || null,
        price: null,
        available: false
      };
      if (o.sku) {
        e = has(cat.bySku, o.sku) ? cat.bySku[o.sku] : null;
        if (e) {
          row.price = e.price;
          row.available = e.available;
          row.image = e.image || row.image;
        }
      } else if (o.skuPattern) {
        for (j = 0; j < o.colors.length; j++) {
          sku = skuFrom(o.skuPattern, o.colors[j]);
          e = has(cat.bySku, sku) ? cat.bySku[sku] : null;
          if (e) {
            if (row.price === null) { row.price = e.price; }
            if (e.available) { row.available = true; }
          }
        }
      }
      out.push(row);
    }
    return out;
  }

  /* Colour zones of the Colors step for the current state. Each zone lists its swatches with
     the SKU, price and availability behind every colour. */
  /* ------------------------------------------------------------------ rig picture */

  /* The picture of the build, as Hollis's own builder draws it: layers stacked bottom first, one
     list per view ("side", "front"). Table: DATA.renders (tools/make_renders.py). Works on a
     partial state. What is not chosen yet shows Hollis's default: the rig's first picture wing
     (renders.rigWing), the Elite harness, the black wing, no backpad / shoulder / pocket layer
     (the base shows them black) and the backplate drawn in the base.
     Returns null when there is no table, no rig or no picture for the wing.
     { combo, wing, harness, views: { side: [layer], front: [layer] }, chosen: { ... } }
     layer = { zone, colour, file, url }. url = renders.urlPrefix + file, no size parameter. */
  function renderLayers(state) {
    var d = needData();
    var r = d.renders;
    var s = normalize(state);
    var rig = rigOf(s.rig);
    var wingName;
    var wingKey;
    var harnessKey = null;
    var comboKey;
    var combo;
    var plate;
    var pockets;
    var views = {};
    var i;
    if (!r || !r.combos || !rig) { return null; }
    wingName = inList(rig.wings, s.wing) ? s.wing : (r.rigWing && r.rigWing[rig.key]) || rig.wings[0];
    wingKey = r.wingKeys && has(r.wingKeys, wingName) ? r.wingKeys[wingName] : null;
    if (!wingKey) { return null; }
    if (rigHas(rig, 'harness')) {
      harnessKey = inList(rig.harnesses, s.harness) && has(r.harnessKeys, s.harness)
        ? r.harnessKeys[s.harness] : r.defaultHarness;
    }
    comboKey = harnessKey ? wingKey + '_' + harnessKey : wingKey;
    combo = has(r.combos, comboKey) ? r.combos[comboKey] : null;
    if (!combo) { return null; }
    plate = rigHas(rig, 'backplate') && inList(rig.backplates, s.backplate) ? s.backplate : null;
    pockets = rigHas(rig, 'weightPockets') && s.weightPockets && colourOf(s.weightPockets) ? s.weightPockets : null;

    function layersFor(view) {
      var v = combo[view];
      var out = [];
      var seen = {};
      function add(zone, colour, file) {
        if (!isString(file) || file === '' || has(seen, file)) { return; }
        seen[file] = true;
        out.push({ zone: zone, colour: colour, file: file, url: r.urlPrefix + file });
      }
      function pick(zone, colour) {
        return (colour && v[zone] && has(v[zone], colour)) ? v[zone][colour] : null;
      }
      if (!v) { return out; }
      if (isString(v.under)) { add('under', null, v.under); }
      if (s.wingColor && pick('base', s.wingColor)) {
        add('base', s.wingColor, pick('base', s.wingColor));
      } else {
        add('base', 'black', pick('base', 'black'));
      }
      if (plate && v.plate && has(v.plate, plate)) { add('plate', null, v.plate[plate]); }
      if (rigHas(rig, 'harness')) {
        add('backpad', s.backpadColor, pick('backpad', s.backpadColor));
        add('shoulder', s.shoulderColor, pick('shoulder', s.shoulderColor));
      }
      if (pockets) { add('pockets', pockets, pick('pockets', pockets)); }
      return out;
    }

    for (i = 0; i < (r.views || ['side', 'front']).length; i++) {
      views[(r.views || ['side', 'front'])[i]] = layersFor((r.views || ['side', 'front'])[i]);
    }
    return {
      combo: comboKey,
      wing: wingName,
      harness: harnessKey,
      views: views,
      chosen: {
        wing: inList(rig.wings, s.wing),
        harness: !rigHas(rig, 'harness') || inList(rig.harnesses, s.harness),
        wingColor: !!(s.wingColor && colourOf(s.wingColor))
      }
    };
  }

  /* The lowest total of a complete build of the rig that can be bought from the catalog today
     (no add-ons, no weight pockets, cheapest available color in every zone). Cents, or null when
     no complete build can be bought. Used for the "From" price next to the product title. */
  function lowestTotal(rigKey, catalog) {
    var rig = rigOf(rigKey);
    var cat = catalog || bakedCatalog();
    var best = null;
    var harnesses;
    var bands;
    var plates;
    var a;
    var b;
    var c;
    var e;
    var s;
    if (!rig) { return null; }
    harnesses = rig.harnesses.length ? rig.harnesses : [null];
    bands = rig.tankBands.length ? rig.tankBands : [null];
    plates = rig.backplates.length ? rig.backplates : [null];
    function tryBuild(state) {
      var zones = colorZonesFor(state, cat);
      var i;
      var j;
      var sw;
      var pick;
      var r;
      for (i = 0; i < zones.length; i++) {
        if (zones[i].optional) { continue; }
        pick = null;
        for (j = 0; j < zones[i].swatches.length; j++) {
          sw = zones[i].swatches[j];
          if (sw.available && sw.price !== null && (pick === null || sw.price < pick.price)) { pick = sw; }
        }
        if (!pick) { return; }
        state[zones[i].field] = pick.key;
      }
      if (!validate(state).ok) { return; }
      r = resolve(state, cat, { assembly: false });
      if (r.missing.length || !r.lines.length) { return; }
      if (best === null || r.total < best) { best = r.total; }
    }
    for (a = 0; a < rig.wings.length; a++) {
      for (b = 0; b < harnesses.length; b++) {
        for (c = 0; c < bands.length; c++) {
          for (e = 0; e < plates.length; e++) {
            s = newState(rigKey);
            s.wing = rig.wings[a];
            s.harness = harnesses[b];
            s.tankBands = bands[c];
            s.backplate = plates[e];
            s.weightPockets = rigHas(rig, 'weightPockets') ? null : undefined;
            tryBuild(s);
          }
        }
      }
    }
    return best;
  }

  /* One plain sentence that says what the picture shows, for the alt text. Only chosen parts. */
  function renderLabel(state) {
    var d = needData();
    var s = normalize(state);
    var rig = rigOf(s.rig);
    var bits = [];
    var wing;
    function colourLabel(key) {
      var c = colourOf(key);
      return c ? c.label : '';
    }
    if (!rig) { return ''; }
    wing = inList(rig.wings, s.wing) ? optionOf('wing', s.wing) : null;
    if (wing) {
      bits.push(wing.shopperLabel + (colourOf(s.wingColor) ? ' in ' + colourLabel(s.wingColor) : ''));
    }
    if (rigHas(rig, 'harness') && colourOf(s.backpadColor)) { bits.push(colourLabel(s.backpadColor) + ' backpad'); }
    if (rigHas(rig, 'harness') && colourOf(s.shoulderColor)) { bits.push(colourLabel(s.shoulderColor) + ' shoulder pads'); }
    if (rigHas(rig, 'weightPockets') && s.weightPockets && colourOf(s.weightPockets)) {
      bits.push(colourLabel(s.weightPockets) + ' weight pockets');
    }
    if (rigHas(rig, 'backplate') && inList(rig.backplates, s.backplate)) {
      bits.push(optionOf('backplate', s.backplate).shopperLabel);
    }
    return 'Hollis ' + rig.label + ' rig' + (bits.length ? ': ' + bits.join(', ') : '') + '.';
  }

  function colorZonesFor(state, catalog) {
    var d = needData();
    var s = normalize(state);
    var rig = rigOf(s.rig);
    var cat = catalog || bakedCatalog();
    var out = [];
    var i;
    var wing;
    var harness;
    function zone(key, ready, product, pattern, colours, value, note) {
      var z = d.zones[key];
      var sw = [];
      var j;
      var c;
      var sku;
      var e;
      for (j = 0; j < colours.length; j++) {
        c = d.colors[colours[j]];
        sku = pattern ? skuFrom(pattern, c.key) : null;
        e = (sku && has(cat.bySku, sku)) ? cat.bySku[sku] : null;
        sw.push({
          key: c.key, label: c.label, code: c.code, hex: c.hex, css: c.css, pattern: !!c.pattern,
          sku: sku,
          price: e ? e.price : null,
          available: e ? e.available : false,
          image: e ? e.image : null
        });
      }
      out.push({
        zone: key, field: z.field, role: z.role, label: z.label,
        optional: !!z.optional, question: z.question || null,
        ready: ready, productLabel: product, value: value, note: note || null, swatches: sw
      });
    }
    if (!rig) { return out; }
    for (i = 0; i < rig.colorZones.length; i++) {
      if (rig.colorZones[i] === 'wing') {
        wing = inList(rig.wings, s.wing) ? optionOf('wing', s.wing) : null;
        zone('wing', !!wing, wing ? wing.shopperLabel : null, wing ? wing.skuPattern : null,
          wing ? wing.colors : d.colorOrder, s.wingColor, null);
      } else if (rig.colorZones[i] === 'backpad') {
        zone('backpad', true, d.options.backpad.shopperLabel, d.options.backpad.skuPattern,
          d.options.backpad.colors, s.backpadColor, null);
      } else if (rig.colorZones[i] === 'shoulder') {
        harness = inList(rig.harnesses, s.harness) ? optionOf('harness', s.harness) : null;
        zone('shoulder', !!harness, harness ? harness.shoulder.label : null,
          harness ? harness.shoulder.skuPattern : null, d.colorOrder, s.shoulderColor,
          'In Hollis\'s builder the shoulder pads follow the harness you chose.');
      }
    }
    if (rigHas(rig, 'weightPockets')) {
      zone('weightPockets', true, d.options.weightPockets.shopperLabel, d.options.weightPockets.skuPattern,
        d.options.weightPockets.colors, s.weightPockets, null);
    }
    return out;
  }

  /* Returns a copy of the state without add-ons that the catalog cannot sell right now. */
  function dropUnavailableAddons(state, catalog) {
    var d = needData();
    var cat = catalog || bakedCatalog();
    var s = normalize(state);
    var keep = [];
    var removed = [];
    var i;
    var a;
    var e;
    for (i = 0; i < s.addons.length; i++) {
      a = has(d.options.addons, s.addons[i]) ? d.options.addons[s.addons[i]] : null;
      e = (a && has(cat.bySku, a.sku)) ? cat.bySku[a.sku] : null;
      if (a && e && e.available && e.variantId && e.price !== null) {
        keep.push(s.addons[i]);
      } else {
        removed.push(s.addons[i]);
      }
    }
    s.addons = keep;
    return { state: s, removed: removed };
  }

  /* ------------------------------------------------------------------ export */

  api.VERSION = VERSION;
  api.DATA = null;
  api.RIGS = ['single', 'double', 'sidemount'];
  api.setData = setData;
  api.stepsFor = stepsFor;
  api.newState = newState;
  api.normalize = normalize;
  api.validate = validate;
  api.catalogFromProducts = catalogFromProducts;
  api.bakedCatalog = bakedCatalog;
  api.mergeCatalogs = mergeCatalogs;
  api.handlesFor = handlesFor;
  api.partsFor = partsFor;
  api.resolve = resolve;
  api.newBuildId = newBuildId;
  api.isBuildId = isBuildId;
  api.hollisLink = hollisLink;
  api.hollisSummary = hollisSummary;
  api.configString = configString;
  api.parseConfigString = parseConfigString;
  api.buildText = buildText;
  api.colorsText = colorsText;
  api.addonsText = addonsText;
  api.orderSheet = orderSheet;
  api.cartPayload = cartPayload;
  api.optionsFor = optionsFor;
  api.colorZonesFor = colorZonesFor;
  api.renderLayers = renderLayers;
  api.renderLabel = renderLabel;
  api.lowestTotal = lowestTotal;
  api.dropUnavailableAddons = dropUnavailableAddons;
  api.formatMoney = formatMoney;
  api.escapeHtml = escapeHtml;
  api.PROPS = {
    buildId: PROP_BUILD_ID, build: PROP_BUILD, colors: PROP_COLORS, addons: PROP_ADDONS,
    sheet: PROP_SHEET, link: PROP_LINK, config: PROP_CONFIG, total: PROP_TOTAL, builder: PROP_BUILDER,
    partOf: PROP_PART_OF, part: PROP_PART
  };
  /* exposed for the tests only */
  api._internal = {
    pyJson: pyJson,
    base64Utf8: base64Utf8,
    utf8Bytes: utf8Bytes,
    base64FromBytes: base64FromBytes,
    hollisData: hollisData,
    toCents: toCents,
    dollarsToCents: dollarsToCents,
    plainMoney: plainMoney
  };

  if (INITIAL_DATA) { setData(INITIAL_DATA); }
  return api;
});
/* src/crib-viewer.js cc389acb5c7d */
/*
 * DCCribViewer 1.1.0
 * The live rig picture of the Hollis CRIB builder on divecatalog.com (SPEC-1.1.md section 5).
 * The picture is Hollis's own render layers, stacked bottom first, so it changes color as the
 * shopper picks colors.
 *
 * - Plain JavaScript, ES5 syntax plus Promise. No framework, no dependencies. It loads pictures
 *   and nothing else.
 * - Every node is built with createElement, textContent and setAttribute. Nothing is ever parsed
 *   as HTML.
 * - The source never contains a doubled opening brace or a brace followed by a percent sign, so it
 *   can sit next to Liquid untouched.
 *
 * Usage
 *   var v = DCCribViewer.create(element, options);    element = the [data-dc-crib-viewer] node
 *   v.show(DCCrib.renderLayers(state), DCCrib.renderLabel(state));
 *   v.setTotal('Total so far', '$844.80');
 *
 * The element may already hold the first picture the page printed (inside
 * [data-dc-crib-stage]). That <img> is taken over as it is: never loaded twice, never replaced
 * while it shows the right picture.
 *
 * Options
 *   doc, win        document and window (default: the element's own)
 *   widths          srcset widths (default [360, 540, 720, 900, 1200])
 *   sizes           sizes of the big picture (default: the sizes of the picture the page printed,
 *                   else "(min-width: 769px) 50vw, 100vw")
 *   resolveImage    function (url, info) returning the address to use for a picture, or nothing
 *                   to keep the default. Called once per srcset width with the bare layer
 *                   address (no width parameter). info = { slot: 'render', zone, view, width }.
 *                   When every width gets the same answer the picture gets that one src, no
 *                   srcset. The static preview uses it for inlined pictures.
 *   fallbackImage   picture shown by show(null), when there is no render table, and when the
 *                   stage has nothing at all to show (no first picture and the base failed)
 *   labels          { side, front, views, note, total } visible words (English defaults below).
 *                   The option may also be called label.
 *   onView          function (view) called after the view changed (a Side / Front button, a
 *                   setView() call, or a build without the view on screen). The builder keeps
 *                   the phone dock's own Side / Front buttons in line with it.
 *
 * Loading rules: every new layer is loaded (and decoded) before the picture changes. A layer
 * that fails is left out and logged once; when the base fails the last good picture stays. A
 * layer that takes longer than 8 s is left out for now and joins the picture when it arrives,
 * unless a newer choice came first. The stage is hidden while it has nothing to show and nothing
 * on its way (no empty white square).
 *
 * Instance
 *   el, show(result, label), setView('side' | 'front'), getView(), hasView(view), prefetch(urls),
 *   thumb(options), setTotal(text, value), isBusy(), destroy()
 *
 *   thumb() is a small live picture of the side view (56 px files). thumb({ view: 'current',
 *   big: true }) follows the view on screen (setView) and uses the sizes of the big picture, so
 *   the browser takes the files the stage already loaded: the phone dock of the builder. view may
 *   also be 'side' or 'front'. A string is read as the view.
 *
 * The one rule that matters: layers of two different combos (wing + harness) never line up, so
 * a new picture is loaded in full first and then shown at once. A stage never shows a mix.
 */
(function (root, factory) {
  'use strict';
  var api = factory(root);
  if (typeof module === 'object' && module && module.exports) {
    module.exports = api;
  }
  if (root && root.document) {
    if (!root.DCCribViewer || root.DCCribViewer.VERSION !== api.VERSION) {
      root.DCCribViewer = api;
    }
  }
})(typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : this), function (root) {
  'use strict';

  var VERSION = '1.1.0';
  var VIEWS = ['side', 'front'];
  var WIDTHS = [360, 540, 720, 900, 1200];
  var SIZES = '(min-width: 769px) 50vw, 100vw';
  var MINI_SIZES = '56px';
  var SRC_WIDTH = 900;
  var FADE = 180;
  var SPIN_AFTER = 300;
  var LOAD_LIMIT = 8000;
  var PREFETCH_CAP = 60;
  var PREFETCH_PARALLEL = 3;
  var POOL_CAP = 40;
  var FALLBACK_KEY = 'fallback';

  /* Without these the picture is not the build: the stage keeps the last good picture. */
  var ESSENTIAL = { under: true, base: true, fallback: true };

  var LABELS = {
    side: 'Side',
    front: 'Front',
    views: 'Picture view',
    note: 'The picture follows your choices.',
    total: 'Total so far'
  };

  /* ------------------------------------------------------------------ small helpers */

  function has(obj, key) {
    return obj !== null && obj !== undefined && Object.prototype.hasOwnProperty.call(obj, key);
  }

  function isFn(v) {
    return typeof v === 'function';
  }

  function str(v) {
    return (v === null || v === undefined) ? '' : String(v);
  }

  function trim(v) {
    return str(v).replace(/^\s+|\s+$/g, '');
  }

  /* Only pictures from a web address or an inlined picture are ever used. */
  function safeUrl(url) {
    var u = trim(url);
    if (u === '') { return ''; }
    if (u.indexOf('//') === 0) { u = 'https:' + u; }
    if (/^https?:\/\//i.test(u) || /^data:image\//i.test(u)) { return u; }
    return '';
  }

  /* The address without its query and hash, the key of a picture. */
  function bareUrl(url) {
    var u = safeUrl(url);
    if (/^data:/i.test(u)) { return u; }
    return u.split('#')[0].split('?')[0];
  }

  function withWidth(url, width) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  /* Shopify's CDN takes a width parameter. */
  function isCdn(url) {
    return /^https?:\/\/[^/]+\/(?:s\/files|cdn\/shop)\//i.test(url);
  }

  function addClass(node, name) {
    if (node.classList) {
      node.classList.add(name);
    } else if ((' ' + node.className + ' ').indexOf(' ' + name + ' ') === -1) {
      node.className = trim(node.className + ' ' + name);
    }
  }

  function removeClass(node, name) {
    if (node.classList) {
      node.classList.remove(name);
    } else {
      node.className = trim((' ' + node.className + ' ').replace(' ' + name + ' ', ' '));
    }
  }

  function hasClass(node, name) {
    if (!node || node.nodeType !== 1) { return false; }
    if (node.classList) { return node.classList.contains(name); }
    return (' ' + node.className + ' ').indexOf(' ' + name + ' ') !== -1;
  }

  function detach(node) {
    if (node && node.parentNode) { node.parentNode.removeChild(node); }
  }

  function childrenOf(node) {
    var out = [];
    var c = node ? node.firstChild : null;
    while (c) {
      out.push(c);
      c = c.nextSibling;
    }
    return out;
  }

  function isImg(node) {
    return !!node && node.nodeType === 1 && String(node.tagName).toLowerCase() === 'img';
  }

  /* The layers of one view as { zone, url, view }, bottom first. Anything without a usable
     address is left out. */
  function layersOf(result, view) {
    var list = (result && result.views && result.views[view]) || [];
    var out = [];
    var seen = {};
    var i;
    var url;
    for (i = 0; i < list.length; i++) {
      url = list[i] ? bareUrl(list[i].url) : '';
      if (url === '' || has(seen, url)) { continue; }
      seen[url] = true;
      out.push({ zone: str(list[i].zone) || 'base', url: url, view: view });
    }
    return out;
  }

  function urlsOf(items) {
    var out = [];
    var i;
    for (i = 0; i < items.length; i++) { out.push(items[i].url); }
    return out;
  }

  /* ------------------------------------------------------------------ one stack of layers */

  /* A box that shows one picture made of stacked layers: the big stage, a view button's mini
     picture or the bottom bar's thumb. set() loads every new layer first and swaps the whole
     picture at once. A generation counter drops loads that a newer choice has overtaken.

     Inside the box: the current stack (a .dc-crib-viewer__stack element, or, for the picture
     the page printed, the box itself) and, while a new combo fades in, the outgoing stack below
     it. Each stack holds the layers of ONE combo and view only. */
  function makeStack(ctx, box, cfg) {
    var self = {};
    var cur = null;       /* { key, sig, el (null = the box itself), items: [{ url, zone, node }] } */
    var pending = null;   /* { gen, key, sig, list, label } */
    var gen = 0;
    var limitTimer = null;
    var fadeTimer = null;
    var leaving = [];
    var entering = [];
    var pool = {};        /* url -> { url, zone, node, state: loading | ok | failed, waiters, used } */
    var poolSize = 0;
    var used = 0;
    var failedSig = '';

    function before() {
      return isFn(cfg.before) ? cfg.before() : null;
    }

    function parentOf(stack) {
      return stack.el || box;
    }

    function setBusy(on) {
      if (isFn(cfg.onBusy)) { cfg.onBusy(on); }
    }

    function applied(label) {
      if (isFn(cfg.onApplied)) { cfg.onApplied(label); }
    }

    function failedNow() {
      if (isFn(cfg.onFailed)) { cfg.onFailed(); }
    }

    function clearLimit() {
      if (limitTimer !== null) {
        ctx.clear(limitTimer);
        limitTimer = null;
      }
    }

    function reset(node) {
      node.className = 'dc-crib-viewer__layer';
    }

    function prune() {
      var keep = {};
      var keys = [];
      var k;
      var i;
      if (poolSize <= POOL_CAP) { return; }
      if (cur) {
        for (i = 0; i < cur.items.length; i++) { keep[cur.items[i].url] = true; }
      }
      if (pending) {
        for (i = 0; i < pending.list.length; i++) { keep[pending.list[i].url] = true; }
      }
      for (k in pool) {
        if (has(pool, k) && !keep[k] && pool[k].state !== 'loading') { keys.push(k); }
      }
      keys.sort(function (a, b) { return pool[a].used - pool[b].used; });
      while (poolSize > POOL_CAP && keys.length) {
        delete pool[keys.shift()];
        poolSize--;
      }
    }

    function finishLoad(e, state) {
      var list;
      var i;
      if (e.state !== 'loading') { return; }
      e.state = state;
      list = e.waiters;
      e.waiters = [];
      if (state === 'failed') { ctx.warnOnce(e.url); }
      for (i = 0; i < list.length; i++) { list[i](); }
    }

    /* A picture counts as ready once it is loaded and decoded, so it paints at once. */
    function settle(e, ok) {
      var node = e.node;
      var p;
      if (e.state !== 'loading') { return; }
      node.onload = null;
      node.onerror = null;
      if (!ok) {
        finishLoad(e, 'failed');
        return;
      }
      if (isFn(node.decode)) {
        try {
          p = node.decode();
          if (p && isFn(p.then)) {
            p.then(function () { finishLoad(e, 'ok'); }, function () { finishLoad(e, 'ok'); });
            return;
          }
        } catch (err) { /* the picture loaded, that is enough */ }
      }
      finishLoad(e, 'ok');
    }

    function request(item) {
      var e = has(pool, item.url) ? pool[item.url] : null;
      var img;
      if (e && e.state !== 'failed') {
        e.used = ++used;
        return e;
      }
      if (!e) { poolSize++; }
      img = ctx.newImage();
      e = { url: item.url, zone: item.zone, node: img, state: 'loading', waiters: [], used: ++used };
      pool[item.url] = e;
      reset(img);
      img.setAttribute('alt', '');
      img.setAttribute('decoding', 'async');
      img.setAttribute('data-zone', item.zone);
      img.setAttribute('data-layer', item.url);
      img.onload = function () { settle(e, true); };
      img.onerror = function () { settle(e, false); };
      ctx.setSources(img, item, cfg.sizes);
      prune();
      return e;
    }

    /* Ends the fades of the last swap at once: what leaves is removed, what came stays. */
    function finalize() {
      var i;
      if (fadeTimer !== null) {
        ctx.clear(fadeTimer);
        fadeTimer = null;
      }
      for (i = 0; i < leaving.length; i++) { detach(leaving[i]); }
      for (i = 0; i < entering.length; i++) { removeClass(entering[i], 'is-entering'); }
      leaving = [];
      entering = [];
    }

    function covers(items, old) {
      var want = {};
      var i;
      for (i = 0; i < items.length; i++) { want[items[i].url] = true; }
      for (i = 0; i < old.length; i++) {
        if (!want[old[i].url]) { return false; }
      }
      return true;
    }

    /* Same combo and view: the layers line up, so only the layers that change are swapped. A
       new layer fades in right above the one it replaces, a layer that goes away fades out. */
    function applySame(items, calm) {
      var parent = parentOf(cur);
      var want = {};
      var zones = {};
      var replaced = {};
      var prev = null;
      var anchor;
      var node;
      var old;
      var i;
      for (i = 0; i < items.length; i++) {
        want[items[i].url] = true;
        zones[items[i].zone] = true;
      }
      for (i = 0; i < cur.items.length; i++) {
        old = cur.items[i];
        if (!want[old.url] && old.node.parentNode === parent) { replaced[old.zone] = old.node; }
      }
      for (i = 0; i < items.length; i++) {
        node = items[i].node;
        if (node.parentNode === parent) {
          prev = node;
          continue;
        }
        reset(node);
        anchor = has(replaced, items[i].zone) ? replaced[items[i].zone] : prev;
        if (anchor) {
          parent.insertBefore(node, anchor.nextSibling);
        } else if (cur.items.length && cur.items[0].node.parentNode === parent) {
          parent.insertBefore(node, cur.items[0].node);
        } else {
          parent.insertBefore(node, cur.el ? parent.firstChild : before());
        }
        if (!calm) {
          addClass(node, 'is-entering');
          entering.push(node);
        }
        prev = node;
      }
      for (i = 0; i < cur.items.length; i++) {
        old = cur.items[i];
        if (want[old.url]) { continue; }
        if (calm) {
          detach(old.node);
        } else {
          if (!zones[old.zone]) { addClass(old.node, 'is-leaving'); }
          leaving.push(old.node);
        }
      }
    }

    /* Another combo or view: a new stack with every layer, laid over the old one and faded in
       as one picture. The old stack goes when the fade ends. */
    function applyNew(items, calm) {
      var el = ctx.doc.createElement('div');
      var i;
      var hadStage = !!cur && (cur.el ? cur.el.parentNode === box : true);
      el.className = 'dc-crib-viewer__stack';
      for (i = 0; i < items.length; i++) {
        reset(items[i].node);
        el.appendChild(items[i].node);
      }
      box.insertBefore(el, before());
      if (cur && hadStage) {
        if (calm) {
          if (cur.el) {
            detach(cur.el);
          } else {
            for (i = 0; i < cur.items.length; i++) { detach(cur.items[i].node); }
          }
        } else {
          addClass(el, 'is-entering');
          entering.push(el);
          if (cur.el) {
            leaving.push(cur.el);
          } else {
            for (i = 0; i < cur.items.length; i++) { leaving.push(cur.items[i].node); }
          }
        }
      }
      cur = { key: null, sig: '', el: el, items: [] };
    }

    function apply(items, key, sig) {
      var calm = !cfg.fade || ctx.calm();
      finalize();
      if (cur && (cur.key === key || (cur.key === null && covers(items, cur.items)))) {
        applySame(items, calm);
      } else {
        applyNew(items, calm);
      }
      cur.key = key;
      cur.sig = sig;
      cur.items = items;
      if (leaving.length || entering.length) {
        fadeTimer = ctx.later(function () {
          fadeTimer = null;
          finalize();
        }, FADE + 40);
      }
    }

    /* A layer that answers after the time limit is still wanted as long as nothing newer was
       asked for: the picture is then drawn again with it, without waiting for the next choice. */
    function whenLate(p, g) {
      var i;
      var e;
      function again() {
        if (g === gen && !pending) { self.set(p.list, p.key, p.label); }
      }
      for (i = 0; i < p.list.length; i++) {
        e = has(pool, p.list[i].url) ? pool[p.list[i].url] : null;
        if (e && e.state === 'loading') { e.waiters.push(again); }
      }
    }

    function finish(g, late) {
      var p = pending;
      var ok = [];
      var broken = false;
      var skipped = false;
      var e;
      var i;
      if (!p || p.gen !== g || g !== gen) { return; }
      pending = null;
      clearLimit();
      for (i = 0; i < p.list.length; i++) {
        e = has(pool, p.list[i].url) ? pool[p.list[i].url] : null;
        if (e && e.state === 'ok') {
          ok.push({ url: e.url, zone: p.list[i].zone, node: e.node });
        } else {
          if (e && e.state === 'loading') { skipped = true; }
          if (ESSENTIAL[p.list[i].zone]) { broken = true; }
        }
      }
      if (skipped) { whenLate(p, g); }
      setBusy(false);
      if (broken || !ok.length) {
        /* the last good picture stays. A picture that failed is not asked for again on every
           redraw, one that was only slow is. */
        failedSig = late ? '' : p.sig;
        failedNow();
        return;
      }
      /* the stand-in picture shown after a failure does not clear the failure */
      if (p.key !== FALLBACK_KEY) { failedSig = ''; }
      apply(ok, p.key, skipped ? p.sig + '|partial' : p.sig);
      applied(p.label);
    }

    /* Forgets the load on its way. Its pictures still land in the pool when they arrive. */
    function drop() {
      if (!pending) { return false; }
      gen++;
      pending = null;
      clearLimit();
      return true;
    }

    function cancel() {
      if (drop()) { setBusy(false); }
    }

    function clearAll() {
      cancel();
      finalize();
      if (cur) {
        if (cur.el) {
          detach(cur.el);
        } else {
          while (cur.items.length) { detach(cur.items.shift().node); }
        }
      }
      cur = null;
      failedSig = '';
    }

    /* list: [{ zone, url, view }], key: combo and view, label: said once the picture shows. */
    self.set = function (list, key, label) {
      var sig = key + '#' + urlsOf(list).join(' ');
      var entries = [];
      var waiting = 0;
      var g;
      var i;
      function one() {
        waiting--;
        if (waiting === 0) { finish(g, false); }
      }
      if (pending && pending.sig === sig) {
        pending.label = label;
        return;
      }
      if (cur && cur.sig === sig) {
        cancel();
        applied(label);
        return;
      }
      if (!list.length) {
        clearAll();
        return;
      }
      if (sig === failedSig && !pending) { return; }
      /* a load on its way is overtaken: the busy state simply goes on */
      drop();
      gen++;
      g = gen;
      pending = { gen: g, key: key, sig: sig, list: list, label: label };
      for (i = 0; i < list.length; i++) { entries.push(request(list[i])); }
      for (i = 0; i < entries.length; i++) {
        if (entries[i].state === 'loading') {
          waiting++;
          entries[i].waiters.push(one);
        }
      }
      if (waiting === 0) {
        finish(g, false);
        return;
      }
      setBusy(true);
      limitTimer = ctx.later(function () {
        limitTimer = null;
        finish(g, true);
      }, LOAD_LIMIT);
    };

    /* Takes over pictures that are already in the box: the page's first picture, or the stack
       a viewer before this one left behind. Nothing is loaded again. */
    self.adopt = function () {
      var kids = childrenOf(box);
      var stacks = [];
      var nodes = [];
      var el = null;
      var items = [];
      var url;
      var zone;
      var i;
      for (i = 0; i < kids.length; i++) {
        if (hasClass(kids[i], 'dc-crib-viewer__stack')) { stacks.push(kids[i]); }
      }
      if (stacks.length) {
        el = stacks[stacks.length - 1];
        for (i = 0; i < stacks.length - 1; i++) { detach(stacks[i]); }
        kids = childrenOf(el);
      }
      for (i = 0; i < kids.length; i++) {
        if (isImg(kids[i])) { nodes.push(kids[i]); } else if (el && kids[i].nodeType === 1) { detach(kids[i]); }
      }
      if (!nodes.length) {
        if (el) { detach(el); }
        return false;
      }
      for (i = 0; i < nodes.length; i++) {
        url = bareUrl(nodes[i].getAttribute('data-layer') || nodes[i].getAttribute('src') || nodes[i].src);
        zone = trim(nodes[i].getAttribute('data-zone')) || 'base';
        nodes[i].setAttribute('alt', '');
        items.push({ url: url, zone: zone, node: nodes[i] });
        if (url !== '' && !has(pool, url)) {
          pool[url] = { url: url, zone: zone, node: nodes[i], state: 'ok', waiters: [], used: ++used };
          poolSize++;
        }
      }
      cur = { key: null, sig: '', el: el, items: items };
      return true;
    };

    /* loaded, or on its way */
    self.has = function (url) {
      return has(pool, url) && pool[url].state !== 'failed';
    };

    self.isEmpty = function () {
      return !cur || !cur.items.length;
    };

    self.isBusy = function () {
      return !!pending;
    };

    self.destroy = function () {
      var k;
      cancel();
      finalize();
      for (k in pool) {
        if (has(pool, k) && pool[k].state === 'loading') {
          pool[k].node.onload = null;
          pool[k].node.onerror = null;
        }
      }
      pool = {};
      poolSize = 0;
    };

    return self;
  }

  /* ------------------------------------------------------------------ the viewer */

  function create(element, options) {
    var o = options || {};
    var doc;
    var win;
    var labels = {};
    var widths = WIDTHS;
    var sizes;
    var inst = {};
    var timers = [];
    var warned = {};
    var destroyed = false;
    var view = 'side';
    var last = null;
    var lastLabel = '';
    var stage;
    var spinner;
    var group;
    var buttons = {};
    var minis = {};
    var thumbs = [];
    var total;
    var totalLabel;
    var totalValue;
    var note;
    var main;
    var spinTimer = null;
    var queue = [];
    var queued = {};
    var queuedCount = 0;
    var running = [];
    var ctx;
    var given;
    var k;
    var i;

    if (!element || element.nodeType !== 1) { return null; }
    doc = o.doc || element.ownerDocument;
    win = o.win || (doc && doc.defaultView) || root;
    if (!doc || !isFn(doc.createElement)) { return null; }
    if (element.__dcCribViewer && isFn(element.__dcCribViewer.destroy)) { element.__dcCribViewer.destroy(); }

    for (k in LABELS) {
      if (has(LABELS, k)) { labels[k] = LABELS[k]; }
    }
    given = (o.labels && typeof o.labels === 'object') ? o.labels : ((o.label && typeof o.label === 'object') ? o.label : {});
    for (k in given) {
      if (has(given, k) && has(LABELS, k) && trim(given[k]) !== '') { labels[k] = str(given[k]); }
    }
    if (o.widths && typeof o.widths.length === 'number' && o.widths.length) {
      widths = [];
      for (i = 0; i < o.widths.length; i++) {
        if (typeof o.widths[i] === 'number' && o.widths[i] > 0) { widths.push(Math.round(o.widths[i])); }
      }
      if (!widths.length) { widths = WIDTHS; }
    }

    /* ---------------------------------------------------------------- services */

    function later(fn, ms) {
      var id = win.setTimeout(function () {
        var at = timers.indexOf(id);
        if (at !== -1) { timers.splice(at, 1); }
        if (!destroyed) { fn(); }
      }, ms);
      timers.push(id);
      return id;
    }

    function clear(id) {
      var at = timers.indexOf(id);
      if (at !== -1) { timers.splice(at, 1); }
      win.clearTimeout(id);
    }

    function calm() {
      try {
        return !!(win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches);
      } catch (err) {
        return true;
      }
    }

    function warnOnce(url) {
      var c = win.console || root.console;
      if (has(warned, url)) { return; }
      warned[url] = true;
      if (c && isFn(c.warn)) { c.warn('[DCCribViewer] A picture layer could not be loaded and was left out: ' + url); }
    }

    function newImage() {
      var I = win.Image;
      if (isFn(I)) {
        try { return new I(); } catch (err) { /* below */ }
      }
      return doc.createElement('img');
    }

    /* The addresses of one layer: a srcset over the widths, or what the page's hook answers. */
    function sourcesOf(item) {
      var render = item.zone !== FALLBACK_KEY || isCdn(item.url);
      var list = [];
      var custom = false;
      var same = true;
      var srcAt = widths.length - 1;
      var answer;
      var i;
      for (i = 0; i < widths.length; i++) {
        answer = '';
        if (isFn(o.resolveImage)) {
          try {
            answer = o.resolveImage(item.url, { slot: 'render', zone: item.zone, view: item.view || null, width: widths[i] });
          } catch (err) {
            answer = '';
          }
          answer = (typeof answer === 'string') ? safeUrl(answer) : '';
        }
        if (answer !== '') {
          custom = true;
        } else {
          answer = render ? withWidth(item.url, widths[i]) : item.url;
        }
        if (list.length && answer !== list[0]) { same = false; }
        list.push(answer);
        if (widths[i] === SRC_WIDTH) { srcAt = i; }
      }
      if (same || (!render && !custom)) { return { src: list[0] || item.url, srcset: '' }; }
      for (i = 0; i < list.length; i++) { list[i] = list[i] + ' ' + widths[i] + 'w'; }
      return { src: list[srcAt].split(' ')[0], srcset: list.join(', ') };
    }

    /* sizes first, then srcset, then src: the browser picks the candidate once. */
    function setSources(img, item, boxSizes) {
      var s = sourcesOf(item);
      if (s.srcset !== '') {
        img.setAttribute('sizes', boxSizes || sizes);
        img.setAttribute('srcset', s.srcset);
      }
      img.setAttribute('src', s.src);
    }

    ctx = {
      doc: doc,
      win: win,
      later: later,
      clear: clear,
      calm: calm,
      warnOnce: warnOnce,
      newImage: newImage,
      setSources: setSources
    };

    /* ---------------------------------------------------------------- dom */

    function el(tag, cls, text) {
      var n = doc.createElement(tag);
      if (cls) { n.className = cls; }
      if (text !== undefined && text !== null) { n.textContent = str(text); }
      return n;
    }

    function setText(node, text) {
      if (node.textContent !== text) { node.textContent = text; }
    }

    function findStage() {
      var kids = childrenOf(element);
      var j;
      for (j = 0; j < kids.length; j++) {
        if (kids[j].nodeType === 1 && (kids[j].hasAttribute('data-dc-crib-stage') || hasClass(kids[j], 'dc-crib-viewer__stage'))) {
          return kids[j];
        }
      }
      return null;
    }

    /* Parts a viewer before this one may have left: they are made again. */
    function removeLeftovers() {
      var names = ['dc-crib-viewer__views', 'dc-crib-viewer__total', 'dc-crib-viewer__note'];
      var kids = childrenOf(element);
      var j;
      var n;
      for (j = 0; j < kids.length; j++) {
        for (n = 0; n < names.length; n++) {
          if (hasClass(kids[j], names[n])) { detach(kids[j]); }
        }
      }
      kids = childrenOf(stage);
      for (j = 0; j < kids.length; j++) {
        if (hasClass(kids[j], 'dc-crib-viewer__spinner')) { detach(kids[j]); }
      }
    }

    function setBusy(on) {
      if (destroyed) { return; }
      if (on) {
        stage.setAttribute('aria-busy', 'true');
        if (spinTimer === null) {
          spinTimer = later(function () {
            spinTimer = null;
            addClass(element, 'is-loading');
          }, SPIN_AFTER);
        }
        syncStage();
        return;
      }
      if (main && main.isBusy()) { return; }
      stage.removeAttribute('aria-busy');
      if (spinTimer !== null) {
        clear(spinTimer);
        spinTimer = null;
      }
      removeClass(element, 'is-loading');
      syncStage();
    }

    function setLabel(label) {
      var text = trim(label);
      if (text !== '' && stage.getAttribute('aria-label') !== text) { stage.setAttribute('aria-label', text); }
    }

    /* No empty white square: the stage shows while it holds a picture or one is on its way. */
    function syncStage() {
      var empty;
      if (destroyed || !main) { return; }
      empty = main.isEmpty() && !main.isBusy();
      if (stage.hidden !== empty) { stage.hidden = empty; }
    }

    function onApplied(label) {
      setLabel(label);
      syncStage();
    }

    /* The new picture could not be shown. The last good one stays. With nothing on the stage at
       all (no first picture, the base failed) the product picture stands in, when there is one. */
    function onFailed() {
      var url = safeUrl(o.fallbackImage);
      if (!destroyed && main && main.isEmpty() && !main.isBusy() && url !== '') {
        main.set([{ zone: FALLBACK_KEY, url: url, view: null }], FALLBACK_KEY, lastLabel);
      }
      syncStage();
    }

    function hasLayers(v) {
      return layersOf(last, v).length > 0;
    }

    function syncViews() {
      var shown = 0;
      var j;
      var v;
      for (j = 0; j < VIEWS.length; j++) {
        v = VIEWS[j];
        buttons[v].hidden = !last || !hasLayers(v);
        if (!buttons[v].hidden) { shown++; }
        buttons[v].setAttribute('aria-pressed', v === view ? 'true' : 'false');
      }
      group.hidden = shown < 2;
    }

    function showMain() {
      var list = layersOf(last, view);
      if (!list.length) { return; }
      main.set(list, str(last.combo) + '|' + view, lastLabel);
      syncStage();
    }

    /* The view a thumb shows: its own, or the one on screen. */
    function thumbView(t) {
      return t.mode === 'current' ? view : t.mode;
    }

    function setThumb(t) {
      var v;
      if (!last) { return; }
      v = thumbView(t);
      t.stack.set(layersOf(last, v), str(last.combo) + '|' + v, '');
    }

    /* Tells the page that the view changed. A page hook that fails changes nothing here. */
    function viewChanged() {
      if (!isFn(o.onView)) { return; }
      try { o.onView(view); } catch (err) { /* the picture goes on */ }
    }

    /* No render table: the product picture, else the picture that is there stays. */
    function showFallback() {
      var url = safeUrl(o.fallbackImage);
      var j;
      for (j = 0; j < VIEWS.length; j++) { minis[VIEWS[j]].set([], 'none', ''); }
      for (j = 0; j < thumbs.length; j++) { thumbs[j].stack.set([], 'none', ''); }
      syncViews();
      if (url !== '') {
        main.set([{ zone: FALLBACK_KEY, url: url, view: null }], FALLBACK_KEY, lastLabel);
      } else {
        setLabel(lastLabel);
      }
      syncStage();
    }

    function onGroupClick(evt) {
      var t = evt && evt.target;
      while (t && t !== group) {
        if (t.nodeType === 1 && t.getAttribute('data-view')) {
          inst.setView(t.getAttribute('data-view'));
          return;
        }
        t = t.parentNode;
      }
    }

    /* ---------------------------------------------------------------- prefetch */

    function pump() {
      var url;
      var img;
      var item;
      while (!destroyed && running.length < PREFETCH_PARALLEL && queue.length) {
        url = queue.shift();
        img = newImage();
        item = { img: img };
        running.push(item);
        img.onload = img.onerror = (function (entry) {
          return function () {
            var at = running.indexOf(entry);
            entry.img.onload = null;
            entry.img.onerror = null;
            if (at !== -1) { running.splice(at, 1); }
            pump();
          };
        })(item);
        try { img.fetchPriority = 'low'; } catch (err) { /* not supported */ }
        img.setAttribute('fetchpriority', 'low');
        img.setAttribute('decoding', 'async');
        img.setAttribute('alt', '');
        setSources(img, { zone: 'base', url: url, view: view }, sizes);
      }
    }

    /* ---------------------------------------------------------------- public */

    inst.el = element;
    inst.version = VERSION;

    inst.show = function (result, label) {
      var was = view;
      var j;
      if (destroyed) { return inst; }
      last = (result && result.views && typeof result.views === 'object') ? result : null;
      lastLabel = str(label);
      if (!last) {
        showFallback();
        return inst;
      }
      if (!hasLayers(view)) {
        for (j = 0; j < VIEWS.length; j++) {
          if (hasLayers(VIEWS[j])) {
            view = VIEWS[j];
            break;
          }
        }
      }
      syncViews();
      showMain();
      for (j = 0; j < VIEWS.length; j++) {
        minis[VIEWS[j]].set(layersOf(last, VIEWS[j]), str(last.combo) + '|' + VIEWS[j], '');
      }
      for (j = 0; j < thumbs.length; j++) { setThumb(thumbs[j]); }
      if (view !== was) { viewChanged(); }
      return inst;
    };

    inst.setView = function (next) {
      var j;
      if (destroyed || VIEWS.indexOf(next) === -1 || next === view) { return inst; }
      if (last && !hasLayers(next)) { return inst; }
      view = next;
      syncViews();
      if (last) {
        showMain();
        for (j = 0; j < thumbs.length; j++) {
          if (thumbs[j].mode === 'current') { setThumb(thumbs[j]); }
        }
      }
      viewChanged();
      return inst;
    };

    /* True when the picture of the build has layers for this view. */
    inst.hasView = function (v) {
      return VIEWS.indexOf(v) !== -1 && !!last && hasLayers(v);
    };

    inst.getView = function () {
      return view;
    };

    /* Loads pictures the shopper may ask for next, quietly: at most three at a time, each
       address once, sixty per page view. */
    inst.prefetch = function (urls) {
      var list = (urls && typeof urls.length === 'number') ? urls : [urls];
      var j;
      var u;
      if (destroyed) { return inst; }
      for (j = 0; j < list.length; j++) {
        u = bareUrl(list[j]);
        if (u === '' || /^data:/i.test(u) || has(queued, u) || main.has(u)) { continue; }
        if (isFn(o.resolveImage) && sourcesOf({ zone: 'base', url: u, view: view }).src.indexOf(u) !== 0) { continue; }
        if (queuedCount >= PREFETCH_CAP) { break; }
        queued[u] = true;
        queuedCount++;
        queue.push(u);
      }
      pump();
      return inst;
    };

    /* A small live picture: the side view (default), the front view, or the view on screen
       (view 'current', it follows setView). big: the sizes of the big picture, so the browser
       takes the files the stage already has (the phone dock shows it up to about 330 px). */
    inst.thumb = function (options) {
      var t = (typeof options === 'string') ? { view: options } : (options || {});
      var mode = (t.view === 'front' || t.view === 'current') ? t.view : 'side';
      var box = el('span', 'dc-crib-viewer__thumb');
      var entry;
      box.setAttribute('aria-hidden', 'true');
      if (destroyed) { return box; }
      entry = { mode: mode, stack: makeStack(ctx, box, { sizes: t.big ? sizes : MINI_SIZES, fade: false }) };
      thumbs.push(entry);
      setThumb(entry);
      return box;
    };

    inst.setTotal = function (text, value) {
      if (destroyed) { return inst; }
      setText(totalLabel, trim(text) || labels.total);
      setText(totalValue, str(value));
      total.hidden = str(value) === '';
      return inst;
    };

    inst.isBusy = function () {
      return !!main && main.isBusy();
    };

    inst.destroy = function () {
      var j;
      if (destroyed) { return; }
      main.destroy();
      for (j = 0; j < VIEWS.length; j++) { minis[VIEWS[j]].destroy(); }
      for (j = 0; j < thumbs.length; j++) { thumbs[j].stack.destroy(); }
      destroyed = true;
      for (j = 0; j < timers.length; j++) { win.clearTimeout(timers[j]); }
      timers = [];
      for (j = 0; j < running.length; j++) {
        running[j].img.onload = null;
        running[j].img.onerror = null;
      }
      running = [];
      queue = [];
      if (group) { group.removeEventListener('click', onGroupClick); }
      detach(group);
      detach(total);
      detach(note);
      detach(spinner);
      stage.removeAttribute('aria-busy');
      removeClass(element, 'is-loading');
      if (element.__dcCribViewer === inst) { element.__dcCribViewer = null; }
    };

    /* ---------------------------------------------------------------- build */

    stage = findStage();
    if (!stage) {
      stage = el('div', 'dc-crib-viewer__stage');
      stage.setAttribute('data-dc-crib-stage', '');
      element.insertBefore(stage, element.firstChild);
    }
    removeLeftovers();
    /* The same sizes as the picture the page printed, so the browser picks the same file. */
    sizes = trim(o.sizes);
    if (sizes === '') {
      (function () {
        var kids = childrenOf(stage);
        var j;
        for (j = 0; j < kids.length; j++) {
          if (isImg(kids[j]) && trim(kids[j].getAttribute('sizes')) !== '') {
            sizes = trim(kids[j].getAttribute('sizes'));
            return;
          }
        }
      })();
    }
    if (sizes === '') { sizes = SIZES; }
    addClass(element, 'dc-crib-viewer');
    addClass(stage, 'dc-crib-viewer__stage');
    stage.setAttribute('role', 'img');

    spinner = el('span', 'dc-crib-viewer__spinner');
    spinner.setAttribute('aria-hidden', 'true');

    main = makeStack(ctx, stage, {
      sizes: sizes,
      fade: true,
      before: function () { return spinner.parentNode === stage ? spinner : null; },
      onBusy: setBusy,
      onApplied: onApplied,
      onFailed: onFailed
    });
    (function () {
      var first = null;
      var kids = childrenOf(stage);
      var j;
      for (j = 0; j < kids.length && !first; j++) {
        if (isImg(kids[j])) { first = kids[j]; }
      }
      if (first && trim(first.getAttribute('alt')) !== '' && !trim(stage.getAttribute('aria-label'))) {
        stage.setAttribute('aria-label', trim(first.getAttribute('alt')));
      }
      main.adopt();
    })();
    stage.appendChild(spinner);

    group = el('div', 'dc-crib-viewer__views');
    group.setAttribute('role', 'group');
    group.setAttribute('aria-label', labels.views);
    for (i = 0; i < VIEWS.length; i++) {
      (function (v) {
        var btn = el('button', 'dc-crib-viewer__view');
        var mini = el('span', 'dc-crib-viewer__mini');
        btn.type = 'button';
        btn.setAttribute('type', 'button');
        btn.setAttribute('data-view', v);
        btn.setAttribute('aria-pressed', v === view ? 'true' : 'false');
        mini.setAttribute('aria-hidden', 'true');
        btn.appendChild(mini);
        btn.appendChild(el('span', 'dc-crib-viewer__view-name', labels[v]));
        buttons[v] = btn;
        minis[v] = makeStack(ctx, mini, { sizes: MINI_SIZES, fade: false });
        group.appendChild(btn);
      })(VIEWS[i]);
    }
    group.addEventListener('click', onGroupClick);
    group.hidden = true;

    total = el('p', 'dc-crib-viewer__total');
    total.setAttribute('aria-live', 'polite');
    total.setAttribute('aria-atomic', 'true');
    totalLabel = el('span', 'dc-crib-viewer__total-label', labels.total);
    totalValue = el('strong', 'dc-crib-viewer__total-value', '');
    total.appendChild(totalLabel);
    total.appendChild(doc.createTextNode(' '));
    total.appendChild(totalValue);
    total.hidden = true;

    note = el('p', 'dc-crib-viewer__note', labels.note);

    element.appendChild(group);
    element.appendChild(total);
    element.appendChild(note);
    syncStage();

    element.__dcCribViewer = inst;
    return inst;
  }

  return {
    VERSION: VERSION,
    VIEWS: VIEWS.slice(),
    LABELS: LABELS,
    create: create,
    _internal: {
      safeUrl: safeUrl,
      bareUrl: bareUrl,
      layersOf: layersOf,
      isCdn: isCdn
    }
  };
});
/* src/crib-builder.js aa1684074c5e */
/*
 * DCCribBuilder 1.1.0
 * Storefront UI for the Hollis CRIB builder on divecatalog.com (SPEC.md sections 5 and 6,
 * SPEC-1.1.md sections 5 and 6).
 *
 * - Plain JavaScript, ES5 syntax plus Promise. No framework, no dependencies.
 * - Uses the core (window.DCCrib, src/crib-core.js) only through its public API, and the live
 *   rig picture (window.DCCribViewer, src/crib-viewer.js) only through its public API.
 * - Every node is built with createElement and textContent. Nothing is ever parsed as HTML.
 * - Network: GET <root>products/<handle>.js (sequential, small gaps, once per page view,
 *   cached in sessionStorage for 10 minutes) and one POST <root>cart/add.js per build.
 *   Only when an add fails or never answers: one GET <root>cart.js to see whether the build
 *   reached the cart after all, and one POST <root>cart/update.js to take back the lines of a
 *   build that arrived in part (by line key, only lines that carry the id of that attempt).
 *   The picture loads Hollis's render layers from Shopify Files. Nothing else.
 * - The source never contains a doubled opening brace or a brace followed by a percent sign,
 *   so it can sit next to Liquid untouched.
 *
 * Mounting
 *   Automatic: every element matching [data-dc-crib] is mounted when this file loads and again
 *   on DOMContentLoaded and shopify:section:load. Add data-dc-crib-manual to opt an element out.
 *   A builder whose section is taken away (shopify:section:unload in the theme editor), or whose
 *   element has left the page by other means, is destroyed: its window listeners, its observer
 *   and its picture go with it.
 *   Manual:    var ctl = DCCribBuilder.mount(element, options)
 *   Defaults for automatic mounts can be set before this file loads:
 *              window.DCCribBuilderConfig = { autoMount: false, fetch: fn, onAdded: fn, ... }
 *
 * Attributes read from the element (options win over attributes)
 *   data-rig               single | double | sidemount
 *   data-rig-param         name of the URL parameter used when data-rig is blank (default crib_rig)
 *   data-assembly-handle   handle of the assembly charge product, blank = no assembly line
 *   data-lead-time         text shown in the Summary step
 *   data-final-sale        text shown in the Summary step, blank = not shown
 *   data-cashback-note     "true" shows the cashback note in the Summary step
 *   data-viewer            id of the picture element ([data-dc-crib-viewer]) the snippet printed.
 *                          Without it (preview, tests, a page without the snippet) the builder
 *                          makes a picture of its own at its top. Never two for one builder.
 *   data-fallback-image    picture shown when the data has no render table (optional)
 *
 * Read from the page around the element
 *   [data-dc-crib-block] [data-dc-crib-from-value]   the "From" price, set to the lowest total
 *                          of a complete build once the live prices are read
 *   [data-dc-crib-block] [data-dc-crib-lead]         the lead time line: its time span ("4-8
 *                          weeks") is put in <strong> by splitting its text node (SPEC-1.1 10.1)
 *   .dc-crib-media         the theme's media column that holds the picture: the builder keeps
 *                          --dc-crib-top on <html> in line with the visible part of the sticky
 *                          header (the column's sticky top), sets --dc-crib-cap on <html> to the
 *                          room the header takes when it is all there (the picture's size limit,
 *                          read on start and on resize only, so the picture keeps one size while
 *                          the header folds or slides on scroll) and adds dc-crib-media--static
 *                          when the picture is taller than the screen below that room
 *
 * Read from the data (parts.json "cart")
 *   omitLink, omitSheet    true leaves "_Hollis builder link" / "_Hollis order sheet" out of the
 *                          cart request. The switch for the case that the store cuts or refuses
 *                          long property values. "_CRIB config" always stays, the staff helper
 *                          rebuilds both from it.
 *
 * Options
 *   rig, assemblyHandle, leadTimeText, finalSaleText, showCashbackNote   same as the attributes
 *   fallbackImage same as data-fallback-image
 *   core          DCCrib instance (default window.DCCrib)
 *   viewerApi     DCCribViewer module (default window.DCCribViewer). Without it the builder
 *                 works without a picture.
 *   fetch         function (url, init) returning a promise of a Response-like object
 *                 ({ ok, status, json() }) or of the parsed data itself. Default window.fetch.
 *   onAdded       function (payload, response, info) called after a successful cart add.
 *                 info = { buildId, state, resolved }. When onAdded is given the builder does
 *                 NOT open the cart drawer or leave the page, unless openCart is true.
 *   openCart      true | false, forces or prevents the cart drawer / redirect after the add
 *   cache         false turns the sessionStorage cache off (default: on, off when fetch is given)
 *   storage       Storage-like object used for the cache (default window.sessionStorage)
 *   fetchGap      milliseconds between two product reads (default 150)
 *   drawerWait    milliseconds to wait for the theme's cart drawer to show the new build before
 *                 the shopper is taken to the cart page (default 3000)
 *   resolveImage  function (url, info) returning the URL to use for a picture, or nothing to keep
 *                 the default. info = { slot, role, key, colour, guideImage, size } for the
 *                 option cards and summary lines, { slot: 'render', zone, view, width } for the
 *                 rig picture (passed on to the viewer). The static preview uses it to swap CDN
 *                 pictures for inlined ones.
 *   state         partial build state to start from, step: step key to open first
 *
 * Phones (below 769 px, SPEC-1.1 sections 10.2 and 10.5)
 *   A dock at the top of the screen (.dc-crib__dock, made here, at the end of <body>) shows a live
 *   picture of the build and a short summary while the big picture is off screen and the builder
 *   is on screen (IntersectionObserver; without it there is no dock). A tap on its picture makes
 *   the picture larger, with Side / Front. Scrolls made by the builder leave room for it. A screen
 *   wider than tall and under 500 px high (a phone on its side, a zoomed laptop) has no dock.
 *   The lead time of the Summary step sits at the top of the step on one column pages, where it
 *   shows when the step opens (the bar at the bottom holds the add button there).
 *
 * Controller returned by mount()
 *   el, rig, viewer, getState(), setState(partial), goTo(step), refresh(), destroy()
 */
(function (root, factory) {
  'use strict';
  var api = factory(root);
  if (typeof module === 'object' && module && module.exports) {
    module.exports = api;
  }
  if (root && root.document) {
    if (!root.DCCribBuilder || root.DCCribBuilder.VERSION !== api.VERSION) {
      root.DCCribBuilder = api;
    }
    root.DCCribBuilder.autoMount();
  }
})(typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : this), function (root) {
  'use strict';

  var VERSION = '1.1.0';
  var CACHE_PREFIX = 'dcCrib:v1:p:';
  var CACHE_TTL = 10 * 60 * 1000;
  var DEFAULT_GAP = 150;
  var READ_TIMEOUT = 12000;
  var ADD_TIMEOUT = 20000;
  var RIG_KEYS = ['single', 'double', 'sidemount'];
  var DRAWER_WAIT = 3000;
  var RIG_PARAM = 'crib_rig';
  var uidCounter = 0;

  /* The phone dock (SPEC-1.1 section 10.2) */
  var DOCK_MAX = 768;           /* the theme's two columns start at 769 px */
  var DOCK_MIN_HEIGHT = 500;    /* a screen wider than tall shows the dock only from this height */
  var DOCK_RATIO = 0.3;         /* the big picture counts as on screen while 30 % of it shows */
  var DOCK_HEIGHT = 106;        /* until it is measured: 88 px picture, 2 x 8 px padding, line */
  var DOCK_SCROLL = 200;        /* the larger picture folds back after this much scrolling */
  var DOCK_HOLD = 800;          /* the longest a scroll of the builder's own keeps the dock shown */
  var PULSE = 400;
  var VIEW_KEYS = ['side', 'front'];

  /* The time span of the lead time: "4-8 weeks", "4 to 8 weeks", "6 weeks" (SPEC-1.1 10.1) */
  var WEEKS = /\d+(?:\s*(?:-|\u2013|to)\s*\d+)?\s*weeks?\b/i;
  /* The namespace of the clock drawing next to the lead time, not an address that is loaded */
  var SVG_NS = 'http://www.w3.org/2000/svg';

  /* ------------------------------------------------------------------ copy */

  /* Every string a shopper can see. Rules (SPEC.md section 0): catalog facts only, anything
     about what goes with what is stated as a rule of Hollis's builder, no pricing promises,
     no phone invitations, no app names, no long dashes. */
  var STR = {
    eyebrow: 'Hollis CRIB builder',
    intro: 'Choose your parts and colors one step at a time. Every part is added to your cart as its own line.',
    noscript: 'Turn on JavaScript to use the builder.',
    from: 'From',
    viewSide: 'Side',
    viewFront: 'Front',
    viewsLabel: 'Picture view',
    pictureNote: 'The picture follows your choices.',
    dockLabel: 'Your build picture',
    dockEyebrow: 'Your build',
    dockEnlarge: 'Tap to enlarge',
    dockLess: 'Show less',
    dockColour: '{colour} {part}',
    totalSoFar: 'Total so far',
    totalBuild: 'Build total',
    stepCount: 'Step {n} of {count}',
    edit: 'Edit',
    editStep: 'Edit {step}',
    next: 'Continue',
    toSummary: 'Back to summary',
    back: 'Back',
    add: 'Add build to cart',
    addAgain: 'Add as a new build',
    adding: 'Adding to cart',
    checking: 'Checking availability',
    viewCart: 'View cart',
    restart: 'Start another build',
    unavailable: 'Currently unavailable',
    optional: 'Optional',
    yes: 'Yes',
    no: 'No',
    zoneColor: '{zone} color',
    chosen: 'Chosen: {value}',
    partNumber: 'Part number {sku}',
    noAddons: 'No add-ons',
    sizeChartNote: 'Sizes as listed in Hollis\'s builder.',
    wingColorNote: 'Hollis\'s builder offers this wing in {count} colors.',
    summaryTotal: 'Total',
    summaryLines: 'Parts in this build',
    cashbackNote: 'Cashback rewards may apply to this build. Your cart shows the details.',
    loading: 'Checking current prices and availability.',
    partial: 'Some prices could not be refreshed just now. Your cart always shows the current price.',
    addonRemoved: '{name} was removed from your build because it is currently unavailable.',
    addedTitle: 'Your build is in your cart',
    addedText: 'Build {id} was added with {count} parts.',
    addedEarlier: 'Build {id} was added to your cart earlier. Adding again creates a second build.',
    fallback: 'The builder could not load. Please reload the page.',
    steps: {
      wing: {
        legend: 'Wing options',
        pending: 'Choose a wing',
        hint: 'Choose one wing. You pick its color in the Colors step.'
      },
      harness: {
        legend: 'Harness options',
        pending: 'Choose a harness',
        hint: 'Choose one harness. Elite 2 is offered in three sizes.'
      },
      tankBands: {
        legend: 'Tank band options',
        pending: 'Choose tank bands',
        hint: 'Choose one pair of tank bands.'
      },
      backplate: {
        legend: 'Backplate options',
        pending: 'Choose a backplate',
        hint: 'Choose one backplate.'
      },
      colors: {
        legend: 'Color choices',
        pending: 'Choose your colors',
        hint: 'Choose a color for each part. Every part can have its own color.'
      },
      addons: {
        legend: 'Add-on options',
        pending: 'Optional',
        hint: 'Add-ons are optional. Choose any you want in this build.'
      },
      summary: {
        legend: 'Build summary',
        pending: 'Review and add to cart',
        hint: 'Review your build, then add it to your cart.'
      }
    },
    errors: {
      partUnavailable: '{name} is currently unavailable. Choose another option to continue.',
      stepSoldOut: '{step}: every option is currently unavailable, so this rig cannot be completed right now.',
      pocketsSoldOut: 'Weight pockets are currently unavailable. Choose No to continue.',
      blocked: 'This build cannot be added to your cart yet.',
      addFailed: 'We could not add this build to your cart. Please try again.',
      network: 'We could not reach the cart. Check your connection and try again.',
      changed: 'Prices or availability changed while you were building. Review your build and try again.',
      refresh: 'Prices and availability could not be refreshed just now. Please try again in a moment.'
    }
  };

  /* Which step fixes a part that cannot be sold right now. */
  var ROLE_STEP = {
    wing: 'colors',
    harness: 'harness',
    tankBands: 'tankBands',
    backplate: 'backplate',
    backpad: 'colors',
    shoulderPads: 'colors',
    weightPockets: 'colors',
    addon: 'addons'
  };

  var FIELD_GROUP = {
    wing: 'wing',
    harness: 'harness',
    tankBands: 'tankBands',
    backplate: 'backplate'
  };

  /* Choices that change the rig picture. Pointing at one of them loads its layers ahead. */
  var PICTURE_FIELDS = {
    wing: true,
    harness: true,
    backplate: true,
    wingColor: true,
    backpadColor: true,
    shoulderColor: true,
    weightPockets: true
  };

  /* The field of the Colors step that fixes a coloured part. */
  var ROLE_FIELD = {
    wing: 'wingColor',
    backpad: 'backpadColor',
    shoulderPads: 'shoulderColor',
    weightPockets: 'weightPockets'
  };

  /* ------------------------------------------------------------------ small helpers */

  function has(obj, key) {
    return obj !== null && obj !== undefined && Object.prototype.hasOwnProperty.call(obj, key);
  }

  function isFn(v) {
    return typeof v === 'function';
  }

  function str(v) {
    return (v === null || v === undefined) ? '' : String(v);
  }

  function trim(v) {
    return str(v).replace(/^\s+|\s+$/g, '');
  }

  function fmt(template, values) {
    return str(template).replace(/\{(\w+)\}/g, function (all, key) {
      return has(values, key) ? str(values[key]) : '';
    });
  }

  function pick(a, b) {
    return (a === undefined || a === null) ? b : a;
  }

  function truthy(v) {
    return v === true || v === 'true' || v === '1' || v === 1;
  }

  function copyState(s) {
    var out = {};
    var k;
    for (k in s) {
      if (has(s, k)) { out[k] = s[k]; }
    }
    out.addons = (s.addons || []).slice();
    return out;
  }

  function warn(message) {
    if (root && root.console && isFn(root.console.warn)) {
      root.console.warn('[DCCribBuilder] ' + message);
    }
  }

  function urlParam(name) {
    var search = (root && root.location && root.location.search) ? String(root.location.search) : '';
    var m;
    if (search === '' || !name) { return ''; }
    try {
      if (isFn(root.URLSearchParams)) {
        return trim(new root.URLSearchParams(search).get(name));
      }
    } catch (err) { /* fall through to the pattern below */ }
    m = new RegExp('[?&]' + name.replace(/[^\w-]/g, '') + '=([^&#]*)').exec(search);
    if (!m) { return ''; }
    try { return trim(decodeURIComponent(m[1].replace(/\+/g, ' '))); } catch (err2) { return ''; }
  }

  /* The picture module: given, or the one the page loaded. */
  function viewerApiOf(opts, win) {
    var v = opts.viewerApi || (win && win.DCCribViewer) || (root && root.DCCribViewer) || null;
    return (v && isFn(v.create)) ? v : null;
  }

  function routesRoot() {
    var r = root && root.Shopify && root.Shopify.routes && root.Shopify.routes.root;
    if (typeof r !== 'string' || r === '' || r.charAt(0) !== '/') { return '/'; }
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  /* Only pictures from a web address or an inlined picture are ever used. */
  function safeImageUrl(url) {
    var u = trim(url);
    if (u === '') { return ''; }
    if (u.indexOf('//') === 0) { u = 'https:' + u; }
    if (/^https?:\/\//i.test(u) || /^data:image\//i.test(u)) { return u; }
    return '';
  }

  /* Shopify CDN pictures accept a width. Anything else is used as it is. */
  function sizedImage(url, width) {
    var u = safeImageUrl(url);
    if (u === '' || !/^https?:\/\/[^/]+\/(?:s\/files|cdn\/shop)\//i.test(u)) { return u; }
    if (/[?&]width=\d+/.test(u)) { return u; }
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  /* Keeps only what the core needs from a /products/<handle>.js answer. */
  function slimProduct(p, handle) {
    var out;
    var i;
    var v;
    var img;
    if (p && p.product && p.product.variants) { p = p.product; }
    if (!p || !p.variants || typeof p.variants.length !== 'number') { return null; }
    img = (typeof p.featured_image === 'string') ? p.featured_image : (p.featured_image && p.featured_image.src);
    out = {
      id: p.id,
      handle: trim(p.handle) || handle,
      title: str(p.title),
      featured_image: img || null,
      variants: []
    };
    for (i = 0; i < p.variants.length; i++) {
      v = p.variants[i];
      if (!v) { continue; }
      out.variants.push({
        id: v.id,
        sku: str(v.sku),
        title: str(v.title),
        price: v.price,
        available: v.available === true,
        featured_image: (v.featured_image && v.featured_image.src) ? { src: v.featured_image.src } : null
      });
    }
    return out;
  }

  /* Accepts a Response, a Response-like object or already parsed data. */
  function readAnswer(res) {
    var ok;
    var status;
    if (res === null || res === undefined) {
      return Promise.resolve({ ok: false, status: 0, data: null });
    }
    status = (typeof res.status === 'number') ? res.status : 0;
    ok = (res.ok !== undefined) ? !!res.ok : (status === 0 || (status >= 200 && status < 300));
    if (isFn(res.json)) {
      return Promise.resolve().then(function () {
        return res.json();
      }).then(function (data) {
        return { ok: ok, status: status, data: data };
      }, function () {
        return { ok: false, status: status, data: null };
      });
    }
    return Promise.resolve({ ok: ok, status: status, data: res });
  }

  /* ------------------------------------------------------------------ controller */

  function createController(host, opts, core, rig) {
    var doc = host.ownerDocument;
    var win = doc.defaultView || root;
    var uid = 'dccrib' + (++uidCounter);
    var DATA = core.DATA;
    var rigData = DATA.rigs[rig];
    var steps = core.stepsFor(rig);
    var assemblyHandle = trim(pick(opts.assemblyHandle, host.getAttribute('data-assembly-handle')));
    var leadTimeText = trim(pick(opts.leadTimeText, host.getAttribute('data-lead-time')));
    var finalSaleText = trim(pick(opts.finalSaleText, host.getAttribute('data-final-sale')));
    var showCashback = truthy(pick(opts.showCashbackNote, host.getAttribute('data-cashback-note')));
    var fetchImpl = isFn(opts.fetch) ? opts.fetch : (isFn(win.fetch) ? function (u, i) { return win.fetch(u, i); } : null);
    var useCache = (opts.cache === undefined) ? !isFn(opts.fetch) : !!opts.cache;
    var gap = (typeof opts.fetchGap === 'number' && opts.fetchGap >= 0) ? opts.fetchGap : DEFAULT_GAP;
    var drawerWait = (typeof opts.drawerWait === 'number' && opts.drawerWait >= 0) ? opts.drawerWait : DRAWER_WAIT;
    var handles = core.handlesFor(rig, { assemblyHandle: assemblyHandle });

    var state = core.newState(rig);
    var liveProducts = {};
    var catalog = null;
    var live = { status: 'idle', failed: [] };
    var open = 0;
    var furthest = 0;
    var alertFor = null;
    var notice = '';
    var busy = false;
    var added = null;
    var lastAdded = null;    /* a build of this page view that reached the cart before an edit */
    var unsettled = null;    /* an add whose outcome is not known yet, checked before the next add */
    var addError = '';
    var destroyed = false;
    var timers = [];
    var imgs = {};
    var nodes = {};
    var ctl = {};

    var viewerApi = viewerApiOf(opts, win);
    var viewer = null;        /* the DCCribViewer instance */
    var viewerEl = null;      /* its element: the snippet's, or one of our own (inline) */
    var viewerInline = false;
    var observer = null;
    var listeners = [];
    var stickyFrame = null;
    var stickyTrail = null;
    var stickyTopNow = -1;
    var capNow = -1;          /* the header's full room, see headerRoom() */
    var capSet = -1;          /* the value --dc-crib-cap holds */
    var capDirty = true;      /* read the room again (start, resize) */
    var prefetchedFor = '';
    var hintKey = '';
    var renders = 0;
    var ready = false;        /* the first paint of the builder is done */

    /* the phone dock (SPEC-1.1 section 10.2) */
    var stageEl = null;       /* the big picture, watched by the observer */
    var seenStage = null;     /* at least 30 % of it on screen (null: not told yet) */
    var seenHost = null;      /* some of the builder on screen */
    var dock = null;          /* { el, pic, sum, toggle, toggleText, views, buttons } */
    var dockShown = false;
    var dockOpen = false;
    var dockTall = 0;         /* measured height of the small dock */
    var dockY = 0;            /* page offset when the larger picture was opened */
    var dockRoomSet = '';
    var pulseTimer = null;
    var holdTimer = null;     /* set while a smooth scroll of the builder's own is on its way */
    var oneColumn = null;     /* the page was one column wide at the last render */

    /* ---------------------------------------------------------------- dom helpers */

    function el(tag, cls, text) {
      var n = doc.createElement(tag);
      if (cls) { n.className = cls; }
      if (text !== undefined && text !== null) { n.textContent = str(text); }
      return n;
    }

    function set(n, name, value) {
      n.setAttribute(name, str(value));
      return n;
    }

    function put(parent) {
      var i;
      for (i = 1; i < arguments.length; i++) {
        if (arguments[i]) { parent.appendChild(arguments[i]); }
      }
      return parent;
    }

    function clear(n) {
      while (n.firstChild) { n.removeChild(n.firstChild); }
    }

    function later(fn, ms) {
      var id = win.setTimeout(function () {
        if (!destroyed) { fn(); }
      }, ms);
      timers.push(id);
      return id;
    }

    /* True when the shopper asks for less motion (or the page cannot tell). */
    function calm() {
      try {
        return !!(win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches);
      } catch (err) {
        return true;
      }
    }

    function pageY() {
      return win.pageYOffset || (doc.documentElement && doc.documentElement.scrollTop) || 0;
    }

    function money(cents) {
      return core.formatMoney(cents);
    }

    function stepLabel(step) {
      return has(DATA.steps, step) ? DATA.steps[step].label : step;
    }

    function stepText(step) {
      return has(STR.steps, step) ? STR.steps[step] : { legend: stepLabel(step), pending: '', hint: '' };
    }

    /* A picture node. The same node is reused while its address does not change, so choosing
       an option never makes the pictures flash. */
    function picture(slot, url, alt, size, info) {
      var meta = info || {};
      var src = '';
      var custom;
      var img;
      meta.slot = meta.slot || slot;
      meta.size = size;
      if (isFn(opts.resolveImage)) {
        try { custom = opts.resolveImage(url, meta); } catch (err) { custom = null; }
        if (typeof custom === 'string' && custom !== '') { src = safeImageUrl(custom); }
      }
      if (src === '') { src = sizedImage(url, size * 2); }
      if (src === '') { return null; }
      if (has(imgs, slot) && imgs[slot].src === src) {
        imgs[slot].node.alt = str(alt);
        return imgs[slot].node;
      }
      img = doc.createElement('img');
      img.className = 'dc-crib__img';
      img.alt = str(alt);
      set(img, 'loading', 'lazy');
      set(img, 'decoding', 'async');
      set(img, 'width', size);
      set(img, 'height', size);
      img.src = src;
      imgs[slot] = { src: src, node: img };
      return img;
    }

    /* ---------------------------------------------------------------- data */

    function buildCatalog() {
      var baked = (DATA.baked && DATA.baked.products) || {};
      var map = {};
      var i;
      var h;
      for (i = 0; i < handles.length; i++) {
        h = handles[i];
        if (has(liveProducts, h)) {
          map[h] = liveProducts[h];
        } else if (has(baked, h)) {
          map[h] = baked[h];
        }
      }
      return core.catalogFromProducts(map, { assemblyHandle: assemblyHandle });
    }

    function resolveNow() {
      return core.resolve(state, catalog, { assembly: assemblyHandle !== '' });
    }

    function storage() {
      try {
        return opts.storage || win.sessionStorage || null;
      } catch (err) {
        return null;
      }
    }

    /* Prices depend on the market, so the key carries the active currency when the theme
       exposes it. */
    function cacheKey(handle) {
      var cur = win.Shopify && win.Shopify.currency && win.Shopify.currency.active;
      return CACHE_PREFIX + ((typeof cur === 'string' && /^[A-Za-z]{3}$/.test(cur)) ? cur.toUpperCase() + ':' : '') + handle;
    }

    function cacheGet(handle) {
      var store;
      var raw;
      var o;
      if (!useCache) { return null; }
      try {
        store = storage();
        raw = store ? store.getItem(cacheKey(handle)) : null;
        if (!raw) { return null; }
        o = JSON.parse(raw);
        if (!o || typeof o.t !== 'number' || !o.p || !o.p.variants) { return null; }
        if (Date.now() - o.t > CACHE_TTL || Date.now() < o.t) { return null; }
        return o.p;
      } catch (err) {
        return null;
      }
    }

    function cacheSet(handle, product) {
      var store;
      if (!useCache) { return; }
      try {
        store = storage();
        if (store) { store.setItem(cacheKey(handle), JSON.stringify({ t: Date.now(), p: product })); }
      } catch (err) { /* storage full or blocked: the builder works without the cache */ }
    }

    /* A read that takes too long counts as failed, the baked values stay for that product.
       onLate runs when the limit is reached (used to cancel the request). */
    function inTime(promise, ms, onLate) {
      var limit = (typeof ms === 'number' && ms > 0) ? ms : READ_TIMEOUT;
      return new Promise(function (resolve, reject) {
        var timer = win.setTimeout(function () {
          if (isFn(onLate)) {
            try { onLate(); } catch (err) { /* the request simply stays open */ }
          }
          reject(new Error('timeout'));
        }, limit);
        promise.then(function (v) {
          win.clearTimeout(timer);
          resolve(v);
        }, function (e) {
          win.clearTimeout(timer);
          reject(e);
        });
      });
    }

    function readProduct(handle) {
      var url = routesRoot() + 'products/' + encodeURIComponent(handle) + '.js';
      return inTime(Promise.resolve().then(function () {
        return fetchImpl(url, { method: 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' } });
      }).then(readAnswer)).then(function (ans) {
        var slim;
        if (ans.status === 404) {
          return { gone: true, product: { handle: handle, title: '', featured_image: null, variants: [] } };
        }
        if (!ans.ok) { return { failed: true, status: ans.status }; }
        slim = slimProduct(ans.data, handle);
        return slim ? { product: slim } : { failed: true, status: ans.status };
      }, function () {
        return { failed: true, status: 0 };
      });
    }

    /* Reads the products one after the other. Stops early when the storefront asks to slow
       down (429) or does not answer at all (status 0: timeout or no connection), the baked
       values stay in place for whatever was not read. Without that stop a stalled connection
       keeps the Add button on "Checking availability" for one timeout per product. */
    function loadLive(only) {
      var list = (only || handles).slice();
      var i = 0;
      var failed = [];
      if (!fetchImpl || !list.length) {
        live.status = 'done';
        return Promise.resolve();
      }
      live.status = 'loading';
      return new Promise(function (done) {
        function finish() {
          var drop;
          var k;
          if (destroyed) { done(); return; }
          live.failed = failed;
          live.status = failed.length ? 'partial' : 'done';
          catalog = buildCatalog();
          updateFrom();
          drop = core.dropUnavailableAddons(state, catalog);
          if (drop.removed.length) {
            state.addons = drop.state.addons.slice();
            notice = '';
            for (k = 0; k < drop.removed.length; k++) {
              if (has(DATA.options.addons, drop.removed[k])) {
                notice += (notice ? ' ' : '') + fmt(STR.addonRemoved, { name: DATA.options.addons[drop.removed[k]].label });
              }
            }
          }
          render();
          done();
        }
        function next() {
          var handle;
          var cached;
          if (destroyed) { done(); return; }
          if (i >= list.length) { finish(); return; }
          handle = list[i++];
          cached = cacheGet(handle);
          if (cached) {
            liveProducts[handle] = cached;
            next();
            return;
          }
          readProduct(handle).then(function (r) {
            if (r.product) {
              liveProducts[handle] = r.product;
              if (!r.gone) { cacheSet(handle, r.product); }
            } else {
              failed.push(handle);
              if (r.status === 429 || r.status === 0) {
                while (i < list.length) { failed.push(list[i++]); }
              }
            }
            if (i >= list.length) { finish(); } else { later(next, gap); }
          });
        }
        next();
      });
    }

    /* ---------------------------------------------------------------- step logic */

    /* True when the step has options and not one of them can be sold right now. */
    function stepSoldOut(step) {
      var rows;
      var i;
      if (!has(FIELD_GROUP, step)) { return false; }
      rows = core.optionsFor(rig, step, catalog);
      for (i = 0; i < rows.length; i++) {
        if (rows[i].available) { return false; }
      }
      return rows.length > 0;
    }

    function pocketsSoldOut() {
      var zones;
      var i;
      var j;
      if (!rigData.weightPockets) { return false; }
      zones = core.colorZonesFor(state, catalog);
      for (i = 0; i < zones.length; i++) {
        if (zones[i].zone !== 'weightPockets') { continue; }
        for (j = 0; j < zones[i].swatches.length; j++) {
          if (zones[i].swatches[j].available) { return false; }
        }
        return true;
      }
      return false;
    }

    /* Messages of one step as a list of {field, message}. A step whose options are all sold out
       says so, instead of asking for a choice nobody can make. */
    function stepProblems(step, check, resolved) {
      var out = [];
      var i;
      var m;
      var e;
      var soldOut = stepSoldOut(step);
      if (soldOut) {
        out.push({ field: step, message: fmt(STR.errors.stepSoldOut, { step: stepLabel(step) }) });
      }
      for (i = 0; i < check.errors.length; i++) {
        e = check.errors[i];
        if (e.step !== step || (soldOut && e.field === step)) { continue; }
        if (e.field === 'weightPockets' && pocketsSoldOut()) {
          out.push({ field: e.field, message: STR.errors.pocketsSoldOut });
        } else {
          out.push({ field: e.field, message: e.message });
        }
      }
      for (i = 0; i < resolved.missing.length; i++) {
        m = resolved.missing[i];
        if (ROLE_STEP[m.role] === step) {
          out.push({
            field: has(ROLE_FIELD, m.role) && step === 'colors' ? ROLE_FIELD[m.role] : step,
            message: fmt(STR.errors.partUnavailable, { name: m.shopperLabel })
          });
        }
      }
      return out;
    }

    function stepErrors(step, check, resolved) {
      var list = stepProblems(step, check, resolved);
      var out = [];
      var i;
      for (i = 0; i < list.length; i++) { out.push(list[i].message); }
      return out;
    }

    /* What Continue shows for a step: every message, and the first message of each field so the
       Colors step can mark the zone that still needs an answer. */
    function alertOf(step, check, resolved) {
      var list = stepProblems(step, check, resolved);
      var out = { step: step, messages: [], fields: {} };
      var i;
      for (i = 0; i < list.length; i++) {
        out.messages.push(list[i].message);
        if (!has(out.fields, list[i].field)) { out.fields[list[i].field] = list[i].message; }
      }
      return out;
    }

    function firstBadStep(check, resolved) {
      var i;
      for (i = 0; i < steps.length; i++) {
        if (stepErrors(steps[i], check, resolved).length) { return i; }
      }
      return -1;
    }

    function stepChoice(step) {
      var o;
      var text;
      if (has(FIELD_GROUP, step)) {
        o = state[step] && has(DATA.options[step], state[step]) ? DATA.options[step][state[step]] : null;
        return o ? o.label : '';
      }
      if (step === 'colors') { return core.colorsText(state); }
      if (step === 'addons') {
        text = core.addonsText(state);
        return text === '' ? STR.noAddons : text;
      }
      return '';
    }

    /* Any change of the build. A build that was added before the change stays in the cart, so
       it is remembered and named next to the button (see renderSummary and render). */
    function changed() {
      alertFor = null;
      addError = '';
      if (added) { lastAdded = added; }
      added = null;
    }

    /* The build with one answer changed, or null for a field the builder does not know. The
       state passed in is not touched (the picture preview of a choice uses it too). */
    function withField(from, field, value, checked) {
      var s = copyState(from);
      var wing;
      if (has(FIELD_GROUP, field)) {
        s[field] = value;
        if (field === 'wing') {
          wing = has(DATA.options.wing, value) ? DATA.options.wing[value] : null;
          if (wing && s.wingColor && wing.colors.indexOf(s.wingColor) === -1) {
            s.wingColor = null;
          }
        }
      } else if (field === 'wingColor' || field === 'backpadColor' || field === 'shoulderColor') {
        s[field] = value;
      } else if (field === 'weightPocketsAnswer') {
        if (value === 'no') {
          s.weightPockets = null;
        } else if (typeof s.weightPockets !== 'string' || !has(DATA.colors, s.weightPockets)) {
          s.weightPockets = true;
        }
      } else if (field === 'weightPockets') {
        s.weightPockets = value;
      } else if (field === 'addon') {
        s.addons = s.addons.filter(function (id) { return id !== value; });
        if (checked) { s.addons.push(value); }
      } else {
        return null;
      }
      return copyState(core.normalize(s));
    }

    function applyField(field, value, checked) {
      var next = withField(state, field, value, checked);
      if (!next) { return false; }
      state = next;
      return true;
    }

    function goTo(index, focusHead) {
      var check = core.validate(state);
      var resolved = resolveNow();
      var bad = firstBadStep(check, resolved);
      var target = Math.max(0, Math.min(steps.length - 1, index));
      if (bad !== -1 && target > bad) { target = bad; }
      open = target;
      if (open > furthest) { furthest = open; }
      alertFor = null;
      render();
      if (focusHead) { focusStep(open); }
    }

    /* True once the shopper has seen the Summary step and came back to change something. */
    function backToSummary() {
      return furthest === steps.length - 1 && open < steps.length - 1;
    }

    function nextStep() {
      var check = core.validate(state);
      var resolved = resolveNow();
      var found = alertOf(steps[open], check, resolved);
      if (found.messages.length) {
        alertFor = found;
        render();
        focusAlert();
        return;
      }
      /* After an edit from the Summary step every later step is still answered, so Continue
         returns there. goTo() stops at the first step that needs an answer. */
      goTo(backToSummary() ? steps.length - 1 : open + 1, true);
    }

    /* The step head gets the focus. The page scrolls when the head is out of view, or when the
       open step does not fit above the bottom bar, so its first options are never hidden. */
    function focusStep(index) {
      var head = nodes.heads ? nodes.heads[index] : null;
      var item;
      if (!head) { return; }
      try { head.focus({ preventScroll: true }); } catch (err) { head.focus(); }
      item = (head.parentNode && head.parentNode.parentNode) ? head.parentNode.parentNode : null;
      scrollTo(head, item);
    }

    /* The zone that still needs an answer first, the message box otherwise. */
    function focusAlert() {
      var a = host.querySelector('.dc-crib__zone.is-error') || host.querySelector('.dc-crib__alert');
      if (!a) { return; }
      set(a, 'tabindex', '-1');
      try { a.focus({ preventScroll: true }); } catch (err) { a.focus(); }
      scrollTo(a);
    }

    function stickyHeader() {
      return doc.querySelector('store-header[data-is-sticky="true"], [data-dc-crib-sticky-header]');
    }

    /* The space the theme's sticky header takes at the top of the screen, plus 16 px. A header
       that slid away (it hides while the page scrolls down) takes none. */
    function stickyTop() {
      var header = stickyHeader();
      var h = 0;
      var r;
      if (header && isFn(header.getBoundingClientRect)) {
        r = header.getBoundingClientRect();
        h = (typeof r.bottom === 'number') ? Math.min(r.bottom, r.height) : r.height;
        h = Math.max(0, Math.round(h || 0));
        if (h > 200) { h = 0; }
      }
      return h + 16;
    }

    /* The space the sticky header takes when it is all there, plus 16 px, however far it has
       slid or folded right now. The theme's own --header-height on <html> first: the theme sets
       it on load and on resize, and it stays the same while the header folds its menu row on
       scroll (the header element itself shrinks then). Else the header's box height, which a
       header that slides away keeps. No sticky header: 16. */
    function headerRoom() {
      var header = stickyHeader();
      var h = NaN;
      var r;
      if (!header) { return 16; }
      try {
        if (isFn(win.getComputedStyle) && doc.documentElement) {
          h = parseFloat(win.getComputedStyle(doc.documentElement).getPropertyValue('--header-height'));
        }
      } catch (err) {
        h = NaN;
      }
      if (!(h > 0) && isFn(header.getBoundingClientRect)) {
        r = header.getBoundingClientRect();
        h = r.height;
      }
      h = Math.max(0, Math.round(h || 0));
      if (h > 200) { h = 0; }
      return h + 16;
    }

    function scrollPage(y) {
      var smooth;
      if (!isFn(win.scrollTo)) { return; }
      smooth = !calm();
      /* A smooth scroll takes a moment: the step that just folded may have left the builder
         above the screen until the scroll brings it back. The dock waits for the scroll
         (holdDock) instead of hiding and sliding in again. */
      if (smooth) { holdDock(); }
      try {
        win.scrollTo({ top: Math.max(0, y), behavior: smooth ? 'smooth' : 'auto' });
      } catch (err2) {
        win.scrollTo(0, Math.max(0, y));
      }
    }

    /* The room at the top of the screen that the page covers: the sticky header, 16 px, and on a
       phone the dock. now: what covers it right now (the dock only while it shows). Otherwise
       where the page is going: a scroll away from the big picture brings the dock in, so its
       room is kept whenever the dock can show. */
    function roomTop(now) {
      var top = stickyTop();
      if (dockLive() && (!now || dockShown)) { top += dockHeight(); }
      return top;
    }

    /* fit: optional node that should be on screen as well (the whole open step). */
    function scrollTo(node, fit) {
      var rect;
      var box;
      if (!node || !isFn(node.getBoundingClientRect) || !isFn(win.scrollTo)) { return; }
      foldDock(false);
      rect = node.getBoundingClientRect();
      box = (fit && isFn(fit.getBoundingClientRect)) ? fit.getBoundingClientRect() : rect;
      if (rect.top >= roomTop(true) && box.bottom <= (win.innerHeight || 0) - 96) { return; }
      scrollPage(rect.top + pageY() - roomTop(false));
    }

    /* ---------------------------------------------------------------- guide picture names */

    function guideFor(role, line) {
      var o;
      if (role === 'wing') {
        o = has(DATA.options.wing, state.wing) ? DATA.options.wing[state.wing] : null;
        return o ? o.guideImage : null;
      }
      if (role === 'harness' || role === 'tankBands' || role === 'backplate') {
        o = has(DATA.options[role], state[role]) ? DATA.options[role][state[role]] : null;
        return o ? o.guideImage : null;
      }
      if (role === 'backpad') { return DATA.options.backpad.guideImage || null; }
      if (role === 'weightPockets') { return DATA.options.weightPockets.guideImage || null; }
      if (role === 'shoulderPads') {
        o = has(DATA.options.harness, state.harness) ? DATA.options.harness[state.harness] : null;
        return (o && o.shoulder) ? o.shoulder.guideImage : null;
      }
      if (role === 'addon' && line && has(DATA.options.addons, line.addon)) {
        return DATA.options.addons[line.addon].guideImage || null;
      }
      return null;
    }

    /* ---------------------------------------------------------------- render: frame */

    /* The picture element the snippet printed for this builder, found by its id. */
    function findViewer() {
      var id = trim(host.getAttribute('data-viewer'));
      var node = (id !== '' && isFn(doc.getElementById)) ? doc.getElementById(id) : null;
      return (node && node.nodeType === 1 && node !== host) ? node : null;
    }

    function build() {
      var head = el('div', 'dc-crib__head');
      var bar = el('div', 'dc-crib__bar');
      var barTotal = el('div', 'dc-crib__bar-total');

      viewerEl = findViewer();
      if (viewerEl && host.contains(viewerEl)) { viewerInline = true; }
      clear(host);
      host.classList.add('dc-crib');
      host.classList.add('dc-crib--ready');
      set(host, 'data-rig', rig);
      set(host, 'data-dc-crib-version', VERSION);

      /* No big title: the product title above says it. */
      put(head,
        el('p', 'dc-crib__eyebrow', STR.eyebrow),
        el('p', 'dc-crib__intro', STR.intro));

      /* one column: the page's other column holds the picture */
      nodes.status = el('p', 'dc-crib__status');
      set(nodes.status, 'role', 'status');
      nodes.notice = el('p', 'dc-crib__notice');
      set(nodes.notice, 'role', 'status');
      nodes.list = el('ol', 'dc-crib__steps');
      nodes.main = put(el('div', 'dc-crib__main'), nodes.status, nodes.notice, nodes.list);

      /* small screens: the total and the next action (the picture is in the dock at the top) */
      nodes.barLabel = el('span', 'dc-crib__bar-label', STR.totalSoFar);
      nodes.barValue = el('strong', 'dc-crib__bar-value', '');
      put(barTotal, nodes.barLabel, nodes.barValue);
      nodes.barAction = el('div', 'dc-crib__bar-action');
      put(bar, barTotal, nodes.barAction);

      if (!viewerEl && viewerApi) {
        viewerEl = el('div', 'dc-crib-viewer dc-crib-viewer--inline');
        set(viewerEl, 'data-dc-crib-viewer', '');
        set(viewerEl, 'data-placed', 'inline');
        viewerInline = true;
      }
      put(host, viewerInline ? viewerEl : null, head, nodes.main, bar);
      host.addEventListener('change', onChange);
      host.addEventListener('click', onClick);
      listen(host, 'focusin', onHint, false);
      listen(host, 'pointerenter', onHint, true);
      listen(host, 'touchstart', onHint, { passive: true, capture: true });
      startViewer();
    }

    function setText(node, text) {
      if (node.textContent !== text) { node.textContent = text; }
    }

    function listen(target, type, fn, how) {
      if (!target || !isFn(target.addEventListener)) { return; }
      target.addEventListener(type, fn, how);
      listeners.push({ target: target, type: type, fn: fn, capture: how === true || !!(how && how.capture) });
    }

    function addClass(node, name) {
      if (node && node.classList) { node.classList.add(name); }
    }

    function removeClass(node, name) {
      if (node && node.classList) { node.classList.remove(name); }
    }

    /* ---------------------------------------------------------------- the picture */

    function startViewer() {
      var table = DATA.renders || null;
      if (!viewerApi || !viewerEl) {
        if (viewerInline && viewerEl) { host.removeChild(viewerEl); }
        viewerEl = null;
        return;
      }
      if (viewerEl.hidden) { viewerEl.hidden = false; }
      set(viewerEl, 'data-rig', rig);
      try {
        viewer = viewerApi.create(viewerEl, {
          doc: doc,
          win: win,
          widths: (table && table.widths) || undefined,
          resolveImage: isFn(opts.resolveImage) ? opts.resolveImage : undefined,
          fallbackImage: trim(pick(opts.fallbackImage, host.getAttribute('data-fallback-image'))),
          labels: {
            side: STR.viewSide,
            front: STR.viewFront,
            views: STR.viewsLabel,
            note: STR.pictureNote,
            total: STR.totalSoFar
          },
          onView: onViewChange
        });
      } catch (err) {
        warn('The picture could not start: ' + err);
        viewer = null;
      }
      if (!viewer) {
        if (viewerInline && viewerEl.parentNode === host) { host.removeChild(viewerEl); }
        viewerEl = null;
        return;
      }
      watchPicture();
      watchPage();
    }

    /* The big picture of the build (the stage), the part the dock stands in for. */
    function stageOf() {
      var n = null;
      if (viewerEl && isFn(viewerEl.querySelector)) {
        n = viewerEl.querySelector('[data-dc-crib-stage]') || viewerEl.querySelector('.dc-crib-viewer__stage');
      }
      return n || viewerEl;
    }

    /* Two things decide whether the phone dock shows: the big picture (at least 30 % of it on
       screen) and the builder (any part of it on screen). The part of the screen under the
       sticky header does not count (rootMargin), so a picture hidden behind the header counts
       as gone. Without IntersectionObserver the page stays as it was: no dock. */
    function watchPicture() {
      var IO = win.IntersectionObserver;
      var room;
      if (!isFn(IO)) { return; }
      stageEl = stageOf();
      room = Math.max(0, headerRoom() - 16);
      try {
        observer = new IO(onSeen, { threshold: [0, DOCK_RATIO], rootMargin: (room ? '-' + room : '0') + 'px 0px 0px 0px' });
        observer.observe(stageEl);
        observer.observe(host);
      } catch (err) {
        observer = null;
      }
    }

    function onSeen(entries) {
      var e;
      var i;
      if (destroyed) { return; }
      for (i = 0; i < (entries || []).length; i++) {
        e = entries[i];
        if (!e) { continue; }
        if (e.target === host) {
          seenHost = !!e.isIntersecting;
        } else if (e.target === stageEl) {
          /* No tolerance under 30 %: the observer reports again only when the share crosses a
             threshold, so a picture counted as on screen at 29.9 % would keep the dock away
             until the whole picture is gone. A report of the move into the 30 % band always
             carries a share of 30 % or more. */
          seenStage = !!e.isIntersecting && (typeof e.intersectionRatio !== 'number' || e.intersectionRatio >= DOCK_RATIO);
        }
      }
      syncDock();
    }

    /* ---------------------------------------------------------------- the phone dock */

    /* One column: the theme's two columns start at 769 px. */
    function narrow() {
      try {
        if (isFn(win.matchMedia)) { return !!win.matchMedia('(max-width: ' + DOCK_MAX + 'px)').matches; }
      } catch (err) {
        return false;
      }
      return typeof win.innerWidth === 'number' && win.innerWidth > 0 && win.innerWidth <= DOCK_MAX;
    }

    /* Room for the dock: one column, and a screen that is taller than wide or at least 500 px
       high. A phone on its side (740 x 360) or a laptop at 200 % zoom (683 x 384) would keep
       under 200 px for the steps between the header, the dock and the bar. Every phone held
       upright keeps it, whatever its browser bars do. The same test as the stylesheet's. */
    function dockFits() {
      var w;
      var h;
      try {
        if (isFn(win.matchMedia)) {
          return !!win.matchMedia('(max-width: ' + DOCK_MAX + 'px) and (orientation: portrait), (max-width: ' +
            DOCK_MAX + 'px) and (min-height: ' + DOCK_MIN_HEIGHT + 'px)').matches;
        }
      } catch (err) {
        return false;
      }
      w = win.innerWidth;
      h = win.innerHeight;
      return typeof w === 'number' && typeof h === 'number' && w > 0 && w <= DOCK_MAX && (h >= w || h >= DOCK_MIN_HEIGHT);
    }

    /* The dock can show on this page now: made, the builder drawn, room for it. */
    function dockLive() {
      return !!dock && ready && dockFits();
    }

    function dockHeight() {
      return dockTall > 0 ? dockTall : DOCK_HEIGHT;
    }

    /* The dock is made the first time the page has room for it (on start or on a resize).
       It sits at the end of <body>: a theme wrapper with a transform would otherwise turn its
       fixed position into a position inside that wrapper. */
    function ensureDock() {
      if (dock || destroyed || !ready || !viewer || !observer || !dockFits()) { return; }
      dock = makeDock();
      (doc.body || host).appendChild(dock.el);
      renderDock();
      syncDockRoom();
      syncDock();
      queueSticky();
    }

    function makeDock() {
      var d = { buttons: {} };
      var id = uid + '-dock';
      var actions;
      var text;
      var b;
      var i;
      d.el = el('div', 'dc-crib dc-crib__dock');
      d.el.id = id;
      set(d.el, 'role', 'region');
      set(d.el, 'aria-label', STR.dockLabel);
      set(d.el, 'data-dc-crib-dock', '');
      set(d.el, 'data-rig', rig);
      d.el.hidden = true;

      /* the picture is the button that makes it larger; its name is the sentence of the picture */
      d.pic = el('button', 'dc-crib__dock-pic');
      d.pic.type = 'button';
      set(d.pic, 'data-dock', 'toggle');
      set(d.pic, 'aria-expanded', 'false');
      set(d.pic, 'aria-controls', id);
      put(d.pic, viewer.thumb({ view: 'current', big: true }));

      d.sum = el('p', 'dc-crib__dock-sum');
      d.toggle = el('button', 'dc-crib__dock-toggle');
      d.toggle.type = 'button';
      set(d.toggle, 'data-dock', 'toggle');
      set(d.toggle, 'aria-expanded', 'false');
      set(d.toggle, 'aria-controls', id);
      d.toggleText = el('span', 'dc-crib__dock-toggle-text', STR.dockEnlarge);
      put(d.toggle, set(el('span', 'dc-crib__dock-icon'), 'aria-hidden', 'true'), d.toggleText);

      /* Side / Front, only while the picture is large */
      d.views = el('div', 'dc-crib__dock-views');
      set(d.views, 'role', 'group');
      set(d.views, 'aria-label', STR.viewsLabel);
      for (i = 0; i < VIEW_KEYS.length; i++) {
        b = el('button', 'dc-crib__dock-view', VIEW_KEYS[i] === 'side' ? STR.viewSide : STR.viewFront);
        b.type = 'button';
        set(b, 'data-dock', 'view');
        set(b, 'data-view', VIEW_KEYS[i]);
        set(b, 'aria-pressed', 'false');
        d.buttons[VIEW_KEYS[i]] = b;
        d.views.appendChild(b);
      }
      d.views.hidden = true;

      actions = put(el('div', 'dc-crib__dock-actions'), d.views, d.toggle);
      text = put(el('div', 'dc-crib__dock-text'), el('p', 'dc-crib__dock-eyebrow', STR.dockEyebrow), d.sum, actions);
      put(d.el, put(el('div', 'dc-crib__dock-row'), d.pic, text));
      d.el.addEventListener('click', onDockClick);
      listen(doc, 'keydown', onDockKey, false);
      return d;
    }

    /* The words of the dock: the wing and every colour chosen so far, from the data's own
       labels, joined by a middle dot: ST 35, Red wing, Lime backpad, Multicam shoulder pads. */
    function dockSummary() {
      var wing = has(DATA.options.wing, state.wing) ? DATA.options.wing[state.wing] : null;
      var parts = [];
      var zones;
      var z;
      var i;
      if (!wing) { return STR.steps.wing.pending; }
      parts.push(wing.label);
      try {
        zones = core.colorZonesFor(state, catalog);
      } catch (err) {
        zones = [];
      }
      for (i = 0; i < zones.length; i++) {
        z = zones[i];
        if (typeof z.value === 'string' && has(DATA.colors, z.value)) {
          parts.push(fmt(STR.dockColour, { colour: DATA.colors[z.value].label, part: str(z.label).toLowerCase() }));
        }
      }
      return parts.join(' \u00b7 ');
    }

    /* What the dock says and the name of its picture. */
    function renderDock() {
      var label = '';
      if (!dock) { return; }
      setText(dock.sum, dockSummary());
      try { label = core.renderLabel(state); } catch (err) { label = ''; }
      if (label !== '' && dock.pic.getAttribute('aria-label') !== label) { set(dock.pic, 'aria-label', label); }
      syncDockViews();
    }

    function syncDockViews() {
      var both;
      var v;
      var i;
      if (!dock || !viewer) { return; }
      both = viewer.hasView('side') && viewer.hasView('front');
      dock.views.hidden = !dockOpen || !both;
      for (i = 0; i < VIEW_KEYS.length; i++) {
        v = VIEW_KEYS[i];
        set(dock.buttons[v], 'aria-pressed', viewer.getView() === v ? 'true' : 'false');
      }
    }

    /* The Side / Front buttons of the big picture or of the dock: both show the same view. */
    function onViewChange() {
      if (!destroyed) { syncDockViews(); }
    }

    /* The dock shows while the builder has started, the page has room for it, the big
       picture is off screen and the builder is on screen. It is fixed at the top under the
       store's header, so it never moves the page. */
    function syncDock() {
      var fits;
      var show;
      if (!dock) { return; }
      fits = ready && dockFits();
      show = fits && seenStage === false && seenHost === true;
      /* The builder left the screen during a scroll of its own: it comes back with the scroll
         (holdDock). A big picture that comes on screen still hides the dock at once. */
      if (!show && dockShown && fits && seenStage === false && holdTimer !== null) { return; }
      if (show === dockShown) { return; }
      dockShown = show;
      if (!show) {
        foldDock(false);
        focusOutOfDock(fits);
      }
      dock.el.hidden = !show;
      if (show) {
        measureDock();
        queueSticky();
      }
    }

    /* A smooth scroll of the builder's own has started: until it ends (scrollend, or at most
       800 ms) a builder off screen does not hide the dock. The dock is checked once more at the
       end. */
    function holdDock() {
      if (!dock || destroyed) { return; }
      if (holdTimer !== null) { win.clearTimeout(holdTimer); }
      holdTimer = win.setTimeout(releaseDock, DOCK_HOLD);
    }

    function releaseDock() {
      if (holdTimer === null) { return; }
      win.clearTimeout(holdTimer);
      holdTimer = null;
      if (!destroyed) { syncDock(); }
    }

    /* The dock is about to hide with the keyboard focus in it: the focus moves to a control
       that stays in sight, so the next Tab goes on from there and not from the top of the page.
       The big picture's pressed Side / Front button when the picture is back (or the page has
       no room for the dock), else the head of the open step. */
    function focusOutOfDock(fits) {
      var active = doc.activeElement;
      var target = null;
      var head = nodes.heads ? nodes.heads[open] : null;
      if (!dock || !active || !dock.el.contains(active)) { return; }
      if (seenStage === true || !fits) { target = pressedView(); }
      if (!target && head && !head.disabled) { target = head; }
      if (!target) { target = pressedView(); }
      if (!target) { return; }
      try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
    }

    /* The pressed Side / Front button under the big picture, when it shows. */
    function pressedView() {
      var btn = (viewerEl && isFn(viewerEl.querySelector)) ? viewerEl.querySelector('.dc-crib-viewer__view[aria-pressed="true"]') : null;
      var n = btn;
      if (!btn || btn.disabled) { return null; }
      while (n && n !== viewerEl) {
        if (n.hidden) { return null; }
        n = n.parentNode;
      }
      return (n === viewerEl && !viewerEl.hidden) ? btn : null;
    }

    /* The height of the small dock: the room the builder's own scrolls keep at the top. */
    function measureDock() {
      var r;
      if (!dock || !dockShown || dockOpen || !isFn(dock.el.getBoundingClientRect)) { return; }
      r = dock.el.getBoundingClientRect();
      if (r && r.height > 0 && Math.round(r.height) !== dockTall) {
        dockTall = Math.round(r.height);
        syncDockRoom();
      }
    }

    /* --dc-crib-dock on the builder: the scroll margin of the steps and colour zones, so the
       browser's own scrolling (Tab from the keyboard) keeps them clear of the dock as well. */
    function syncDockRoom() {
      var value = dockLive() ? dockHeight() + 'px' : '0px';
      if (value === dockRoomSet || !host.style || !isFn(host.style.setProperty)) { return; }
      dockRoomSet = value;
      host.style.setProperty('--dc-crib-dock', value);
    }

    function openDock() {
      if (!dock || !dockShown || dockOpen) { return; }
      dockOpen = true;
      dockY = pageY();
      syncDockState();
    }

    /* Back to the small dock. Side / Front hide: the focus on one of them goes to the picture,
       however the dock folds (scrolling, a tap). focusBack (Escape): the focus anywhere in the
       dock goes to the picture. */
    function foldDock(focusBack) {
      var active;
      var had;
      if (!dock || !dockOpen) { return; }
      active = doc.activeElement;
      had = !!active && (dock.views.contains(active) || (!!focusBack && dock.el.contains(active)));
      dockOpen = false;
      syncDockState();
      if (had) {
        try { dock.pic.focus({ preventScroll: true }); } catch (err) { dock.pic.focus(); }
      }
    }

    function syncDockState() {
      var open = dockOpen ? 'true' : 'false';
      if (dockOpen) { addClass(dock.el, 'is-open'); } else { removeClass(dock.el, 'is-open'); }
      set(dock.pic, 'aria-expanded', open);
      set(dock.toggle, 'aria-expanded', open);
      setText(dock.toggleText, dockOpen ? STR.dockLess : STR.dockEnlarge);
      syncDockViews();
    }

    function onDockClick(evt) {
      var t = evt && evt.target;
      var act;
      if (destroyed || !dock) { return; }
      while (t && t !== dock.el && !(t.nodeType === 1 && t.getAttribute('data-dock'))) { t = t.parentNode; }
      if (!t || t === dock.el) { return; }
      act = t.getAttribute('data-dock');
      if (act === 'toggle') {
        if (dockOpen) { foldDock(false); } else { openDock(); }
      } else if (act === 'view' && viewer) {
        viewer.setView(t.getAttribute('data-view'));
        syncDockViews();
      }
    }

    function onDockKey(evt) {
      var key = evt ? (evt.key || evt.keyCode) : '';
      if (dockOpen && (key === 'Escape' || key === 'Esc' || key === 27)) { foldDock(true); }
    }

    /* A choice changed the picture while the dock shows: a short ring around the dock's
       picture (none for shoppers who ask for less motion). */
    function pulseDock() {
      var pic;
      if (!dock || !dockShown || calm()) { return; }
      pic = dock.pic;
      removeClass(pic, 'is-pulse');
      /* reading the layout lets the ring start again when two choices come quickly */
      if (pic.offsetWidth < 0) { return; }
      addClass(pic, 'is-pulse');
      if (pulseTimer !== null) { win.clearTimeout(pulseTimer); }
      pulseTimer = later(function () {
        pulseTimer = null;
        removeClass(pic, 'is-pulse');
      }, PULSE);
    }

    /* The layers of the view on screen: tells whether a choice changed the picture. */
    function pictureKey() {
      var r;
      var list;
      var out = [];
      var i;
      if (!viewer) { return ''; }
      try { r = core.renderLayers(state); } catch (err) { return ''; }
      list = (r && r.views && r.views[viewer.getView()]) || [];
      for (i = 0; i < list.length; i++) { out.push(list[i].url); }
      return out.join(' ');
    }

    function removeDock() {
      if (pulseTimer !== null) {
        win.clearTimeout(pulseTimer);
        pulseTimer = null;
      }
      if (holdTimer !== null) {
        win.clearTimeout(holdTimer);
        holdTimer = null;
      }
      if (!dock) { return; }
      dock.el.removeEventListener('click', onDockClick);
      if (dock.el.parentNode) { dock.el.parentNode.removeChild(dock.el); }
      dock = null;
      dockShown = false;
      dockOpen = false;
      if (host.style && isFn(host.style.removeProperty)) { host.style.removeProperty('--dc-crib-dock'); }
      dockRoomSet = '';
    }

    /* The theme's media column that holds the picture (set up by the snippet's boot script). */
    function mediaOf() {
      var n = viewerEl ? viewerEl.parentNode : null;
      while (n && n.nodeType === 1) {
        if (n.classList && n.classList.contains('dc-crib-media')) { return n; }
        n = n.parentNode;
      }
      return null;
    }

    /* The picture column sticks below the header. When the picture is taller than the screen it
       would never show its lower part, so the column scrolls with the page instead.
       Two numbers: --dc-crib-top follows the visible part of the header (the column's sticky
       top slides with it). --dc-crib-cap is the header's full room: the picture's size limit and
       the sticky or static choice use it, so neither changes when the header folds or slides
       away on scroll. The room is read on start and on resize, and only grows in between.
       The phone dock sits right under the visible header: its top is --dc-crib-top minus 16 px,
       so --dc-crib-top is kept while there is a dock, with or without a media column. */
    function syncSticky() {
      var media = mediaOf();
      var top;
      var rootEl;
      var styled;
      var tall;
      var rect;
      if (destroyed || (!media && !dock)) { return; }
      top = stickyTop();
      rootEl = doc.documentElement;
      styled = !!(rootEl && rootEl.style && isFn(rootEl.style.setProperty));
      if (top !== stickyTopNow && styled) {
        stickyTopNow = top;
        rootEl.style.setProperty('--dc-crib-top', top + 'px');
      }
      measureDock();
      if (!media) { return; }
      if (capDirty || capNow < 0) {
        capDirty = false;
        capNow = headerRoom();
      }
      if (top > capNow) { capNow = top; }
      if (capNow !== capSet && styled) {
        capSet = capNow;
        rootEl.style.setProperty('--dc-crib-cap', capNow + 'px');
      }
      if (!isFn(viewerEl.getBoundingClientRect)) { return; }
      rect = viewerEl.getBoundingClientRect();
      tall = (rect.height || 0) > (win.innerHeight || 0) - capNow - 16;
      if (tall !== media.classList.contains('dc-crib-media--static')) {
        if (tall) {
          media.classList.add('dc-crib-media--static');
        } else {
          media.classList.remove('dc-crib-media--static');
        }
      }
    }

    /* A window scroll or resize. The builder's part of the page may have been replaced since
       (theme editor, a theme script): an orphan lets go of the window, its observer and its
       picture instead of measuring a detached page on every frame. */
    function onSticky() {
      if (destroyed) { return; }
      if (!connected(host)) {
        ctl.destroy();
        return;
      }
      if (dockOpen && Math.abs(pageY() - dockY) > DOCK_SCROLL) { foldDock(false); }
      queueSticky();
    }

    /* Once per frame while the page scrolls or resizes, and once more when the header's own
       slide has ended. */
    function queueSticky() {
      if (destroyed) { return; }
      if (stickyTrail !== null) { win.clearTimeout(stickyTrail); }
      stickyTrail = win.setTimeout(function () {
        stickyTrail = null;
        syncSticky();
      }, 400);
      if (stickyFrame !== null) { return; }
      stickyFrame = { raf: isFn(win.requestAnimationFrame), id: null };
      if (stickyFrame.raf) {
        stickyFrame.id = win.requestAnimationFrame(function () {
          stickyFrame = null;
          syncSticky();
        });
      } else {
        stickyFrame.id = win.setTimeout(function () {
          stickyFrame = null;
          syncSticky();
        }, 50);
      }
    }

    function stopSticky() {
      if (stickyTrail !== null) {
        win.clearTimeout(stickyTrail);
        stickyTrail = null;
      }
      if (stickyFrame !== null) {
        if (stickyFrame.raf && isFn(win.cancelAnimationFrame)) {
          win.cancelAnimationFrame(stickyFrame.id);
        } else if (!stickyFrame.raf) {
          win.clearTimeout(stickyFrame.id);
        }
        stickyFrame = null;
      }
    }

    /* A resize may cross 769 px, or turn a phone on its side: the dock is made the first time
       the page has room for it and hides when it has none. The Summary step places its lead
       time by the number of columns, so an open Summary is drawn again when that changes. */
    function onResize() {
      capDirty = true;
      if (!destroyed && connected(host)) {
        ensureDock();
        syncDock();
        syncDockRoom();
        if (oneColumn !== null && narrow() !== oneColumn && steps[open] === 'summary') { render(); }
      }
      onSticky();
    }

    /* The end of a scroll: a smooth scroll of the builder's own has arrived. */
    function onScrollEnd() {
      if (holdTimer !== null) { releaseDock(); }
    }

    /* The window is watched for the sticky picture column (a media column) and for the phone
       dock (an observer). A page with neither is left alone. */
    function watchPage() {
      var media = !!mediaOf();
      if (!media && !observer) { return; }
      if (media) { syncSticky(); }
      listen(win, 'resize', onResize, false);
      listen(win, 'scroll', onSticky, { passive: true, capture: false });
      if (observer) { listen(win, 'scrollend', onScrollEnd, { passive: true, capture: false }); }
    }

    /* The layers the shopper sees and, on the Colors step, every color of the wing loaded
       ahead for the view on screen. */
    function renderPicture(check, resolved) {
      var complete = check.ok && !resolved.missing.length;
      if (!viewer) { return; }
      try {
        viewer.show(core.renderLayers(state), core.renderLabel(state));
        viewer.setTotal.apply(viewer, totalFor(complete, resolved));
        if (steps[open] === 'colors') { prefetchWingColors(); }
      } catch (err) {
        warn('The picture could not be updated: ' + err);
      }
      renderDock();
      measureDock();
    }

    function prefetchWingColors() {
      var view = viewer.getView();
      var now = core.renderLayers(state);
      var wing = has(DATA.options.wing, state.wing) ? DATA.options.wing[state.wing] : null;
      var colours = wing ? wing.colors : DATA.colorOrder;
      var urls = [];
      var s;
      var layers;
      var list;
      var i;
      var j;
      if (!now || prefetchedFor === now.combo + '|' + view) { return; }
      prefetchedFor = now.combo + '|' + view;
      for (i = 0; i < colours.length; i++) {
        s = copyState(state);
        s.wingColor = colours[i];
        layers = core.renderLayers(s);
        list = (layers && layers.views && layers.views[view]) || [];
        for (j = 0; j < list.length; j++) {
          if (list[j].zone === 'base') { urls.push(list[j].url); }
        }
      }
      viewer.prefetch(urls);
    }

    /* A pointer on, a finger on, or the focus on a choice that changes the picture: its layers
       are loaded before the shopper picks it. */
    function onHint(evt) {
      var t = evt && evt.target;
      var card = null;
      var input;
      var field;
      var key;
      var next;
      var layers;
      var list;
      var urls = [];
      var i;
      if (!viewer || destroyed) { return; }
      while (t && t !== host) {
        if (t.nodeType === 1 && t.classList && (t.classList.contains('dc-crib__sw') || t.classList.contains('dc-crib__opt'))) {
          card = t;
          break;
        }
        t = t.parentNode;
      }
      if (!card) { return; }
      input = card.querySelector('input');
      field = input ? input.getAttribute('data-field') : null;
      if (!field || !has(PICTURE_FIELDS, field) || input.disabled) { return; }
      key = renders + ':' + field + ':' + input.value + ':' + viewer.getView();
      if (key === hintKey) { return; }
      hintKey = key;
      next = withField(state, field, input.value, true);
      try {
        layers = next ? core.renderLayers(next) : null;
      } catch (err) {
        layers = null;
      }
      list = (layers && layers.views && layers.views[viewer.getView()]) || [];
      for (i = 0; i < list.length; i++) { urls.push(list[i].url); }
      if (urls.length) { viewer.prefetch(urls); }
    }

    /* The snippet's block around the builder ([data-dc-crib-block]), or null. */
    function blockOf() {
      var block = host.parentNode;
      while (block && block.nodeType === 1 && !block.hasAttribute('data-dc-crib-block')) { block = block.parentNode; }
      return (block && block.nodeType === 1) ? block : null;
    }

    /* The time span of a lead time text ("4-8 weeks", "4 to 8 weeks", "6 weeks") goes into
       <strong>: the first text node that holds it is split into plain text, the span and plain
       text. Nothing is parsed, the words stay the same. Done once per node. */
    function stressWeeks(node) {
      var list;
      var n;
      var text;
      var m;
      var parent;
      var kids;
      var i;
      if (!node || node.nodeType !== 1 || (isFn(node.querySelector) && node.querySelector('.dc-crib__weeks'))) { return false; }
      list = [node];
      while (list.length) {
        n = list.shift();
        if (n.nodeType === 3) {
          text = str(n.textContent);
          m = WEEKS.exec(text);
          if (!m) { continue; }
          parent = n.parentNode;
          if (m.index > 0) { parent.insertBefore(doc.createTextNode(text.slice(0, m.index)), n); }
          parent.insertBefore(el('strong', 'dc-crib__weeks', m[0]), n);
          if (m.index + m[0].length < text.length) { parent.insertBefore(doc.createTextNode(text.slice(m.index + m[0].length)), n); }
          parent.removeChild(n);
          return true;
        }
        if (n.nodeType === 1 && !/^(?:script|style|svg|noscript)$/i.test(str(n.tagName))) {
          kids = [];
          for (i = 0; i < n.childNodes.length; i++) { kids.push(n.childNodes[i]); }
          list = kids.concat(list);
        }
      }
      return false;
    }

    /* The lead time line the snippet printed next to the From price. */
    function stressPageLead() {
      var block = blockOf();
      var line = block ? block.querySelector('[data-dc-crib-lead]') : null;
      if (line) { stressWeeks(line); }
    }

    /* The clock next to the lead time in the Summary step, the same drawing as the one the
       snippet prints. Built with createElementNS and setAttribute. None where the page cannot
       draw it. */
    function clockIcon() {
      var svg;
      var shape;
      var attrs;
      var k;
      if (!isFn(doc.createElementNS)) { return null; }
      try {
        svg = doc.createElementNS(SVG_NS, 'svg');
        attrs = {
          'class': 'dc-crib-lead__icon', 'aria-hidden': 'true', focusable: 'false', width: '20', height: '20',
          viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': '2',
          'stroke-linecap': 'round', 'stroke-linejoin': 'round'
        };
        for (k in attrs) {
          if (has(attrs, k)) { svg.setAttribute(k, attrs[k]); }
        }
        shape = doc.createElementNS(SVG_NS, 'circle');
        shape.setAttribute('cx', '12');
        shape.setAttribute('cy', '12');
        shape.setAttribute('r', '9');
        svg.appendChild(shape);
        shape = doc.createElementNS(SVG_NS, 'path');
        shape.setAttribute('d', 'M12 7v5l3 2');
        svg.appendChild(shape);
        return svg;
      } catch (err) {
        return null;
      }
    }

    /* The lead time in the Summary step: the same callout as the line under the From price.
       first: at the top of the step (one column), else right above the button. */
    function leadNote(first) {
      var text = el('span', 'dc-crib-lead__text', leadTimeText);
      var note = put(el('p', 'dc-crib__note dc-crib__note--lead' + (first ? ' dc-crib__note--first' : '')), clockIcon(), text);
      stressWeeks(text);
      return note;
    }

    /* The "From" price next to the product title: the lowest total of a complete build, from
       the prices just read. Left as it is when no complete build can be bought. */
    function updateFrom() {
      var block = blockOf();
      var node;
      var cents;
      if (!block) { return; }
      node = block.querySelector('[data-dc-crib-from-value]');
      if (!node) { return; }
      try {
        cents = core.lowestTotal(rig, catalog);
      } catch (err) {
        return;
      }
      if (typeof cents === 'number' && cents > 0) { setText(node, money(cents)); }
    }

    /* ---------------------------------------------------------------- render: all */

    function render() {
      var active;
      var key = null;
      var check;
      var resolved;
      var list;
      var i;
      var shown;
      if (destroyed) { return; }
      renders++;
      active = doc.activeElement;
      if (active && host.contains(active)) { key = active.getAttribute('data-fk'); }

      check = core.validate(state);
      resolved = resolveNow();
      oneColumn = narrow();

      renderPicture(check, resolved);
      renderSteps(check, resolved);
      renderBar(check, resolved);

      if (live.status === 'loading') {
        setText(nodes.status, STR.loading);
      } else if (live.status === 'partial') {
        setText(nodes.status, STR.partial);
      } else {
        setText(nodes.status, '');
      }
      nodes.status.hidden = nodes.status.textContent === '';

      shown = notice;
      if (shown === '' && lastAdded && !added) {
        shown = fmt(STR.addedEarlier, { id: lastAdded.buildId });
      }
      setText(nodes.notice, shown);
      nodes.notice.hidden = shown === '';

      if (key) {
        list = host.querySelectorAll('[data-fk]');
        for (i = 0; i < list.length; i++) {
          if (list[i].getAttribute('data-fk') === key && !list[i].disabled) {
            try { list[i].focus({ preventScroll: true }); } catch (err) { list[i].focus(); }
            break;
          }
        }
      }
    }

    /* [label, value] for the total under the picture and in the phone bar. Before the first
       choice the running total is $0.00, so both show the From price instead (same row, same
       height: nothing moves when the first choice is made). */
    function totalFor(complete, resolved) {
      var sum = complete ? resolved.total : runningTotal(resolved);
      var from = null;
      if (!complete && sum <= 0) {
        try { from = core.lowestTotal(rig, catalog); } catch (err) { from = null; }
        if (typeof from === 'number' && from > 0) { return [STR.from, money(from)]; }
      }
      return [complete ? STR.totalBuild : STR.totalSoFar, money(sum)];
    }

    function runningTotal(resolved) {
      var sum = resolved.total;
      var i;
      for (i = 0; i < resolved.pending.length; i++) {
        if (resolved.pending[i].role === 'wing' && resolved.pending[i].price !== null) {
          sum += resolved.pending[i].price;
        }
      }
      return sum;
    }

    /* ---------------------------------------------------------------- render: steps */

    function renderSteps(check, resolved) {
      var bad = firstBadStep(check, resolved);
      var i;
      var step;
      var li;
      var h;
      var head;
      var body;
      var locked;
      var done;
      var choice;
      var text;

      clear(nodes.list);
      nodes.heads = [];
      for (i = 0; i < steps.length; i++) {
        step = steps[i];
        text = stepText(step);
        locked = bad !== -1 && i > bad && i !== open;
        done = !locked && i !== open && i <= furthest && step !== 'summary' &&
          stepErrors(step, check, resolved).length === 0;
        choice = done ? stepChoice(step) : '';

        li = el('li', 'dc-crib__step' + (i === open ? ' is-open' : '') + (done ? ' is-done' : '') + (locked ? ' is-locked' : ''));
        set(li, 'data-step', step);
        h = el('h3', 'dc-crib__step-title');
        head = el('button', 'dc-crib__step-head');
        head.type = 'button';
        head.id = uid + '-head-' + step;
        set(head, 'data-act', 'open');
        set(head, 'data-step', step);
        set(head, 'data-fk', 'head:' + step);
        set(head, 'aria-expanded', i === open ? 'true' : 'false');
        set(head, 'aria-controls', uid + '-body-' + step);
        if (i === open) { set(head, 'aria-current', 'step'); }
        if (locked) { head.disabled = true; }
        put(head,
          put(el('span', 'dc-crib__step-num'), el('span', 'dc-crib__sr', fmt(STR.stepCount, { n: i + 1, count: steps.length }) + ': '), set(el('span', '', i + 1), 'aria-hidden', 'true')),
          put(el('span', 'dc-crib__step-text'),
            el('span', 'dc-crib__step-name', stepLabel(step)),
            el('span', 'dc-crib__step-choice', done ? choice : (i === open ? '' : text.pending))),
          done ? el('span', 'dc-crib__step-edit', STR.edit) : null);
        put(h, head);
        nodes.heads.push(head);

        body = el('div', 'dc-crib__step-body');
        body.id = uid + '-body-' + step;
        set(body, 'role', 'region');
        set(body, 'aria-labelledby', head.id);
        if (i === open) {
          renderBody(body, step, i, check, resolved);
        } else {
          body.hidden = true;
        }
        put(li, h, body);
        nodes.list.appendChild(li);
      }
    }

    function renderAlert(body, step) {
      var box;
      var i;
      if (!alertFor || alertFor.step !== step || !alertFor.messages.length) { return; }
      box = alertBox();
      for (i = 0; i < alertFor.messages.length; i++) {
        put(box, el('p', 'dc-crib__alert-line', alertFor.messages[i]));
      }
      body.appendChild(box);
    }

    /* The message box can hold the focus and keeps it when the builder is drawn again. */
    function alertBox() {
      var box = el('div', 'dc-crib__alert');
      set(box, 'role', 'alert');
      set(box, 'tabindex', '-1');
      set(box, 'data-fk', 'alert');
      return box;
    }

    /* "Back to summary" only when the press really leads there: every step is answered. */
    function nextLabel() {
      if (!backToSummary()) { return STR.next; }
      return firstBadStep(core.validate(state), resolveNow()) === -1 ? STR.toSummary : STR.next;
    }

    function renderActions(body, index) {
      var row = el('div', 'dc-crib__actions');
      var next = el('button', 'dc-crib__btn dc-crib__btn--primary', nextLabel());
      var back;
      next.type = 'button';
      set(next, 'data-act', 'next');
      set(next, 'data-fk', 'next');
      put(row, next);
      if (index > 0) {
        back = el('button', 'dc-crib__btn dc-crib__btn--ghost', STR.back);
        back.type = 'button';
        set(back, 'data-act', 'back');
        set(back, 'data-fk', 'back');
        put(row, back);
      }
      body.appendChild(row);
    }

    function renderBody(body, step, index, check, resolved) {
      var text = stepText(step);
      put(body, el('p', 'dc-crib__hint', text.hint));
      if (has(DATA.steps, step) && DATA.steps[step].note) {
        put(body, el('p', 'dc-crib__fact', DATA.steps[step].note));
      }
      renderAlert(body, step);
      if (has(FIELD_GROUP, step)) {
        renderOptions(body, step);
        if (step === 'harness') { renderSizeChart(body); }
        renderActions(body, index);
      } else if (step === 'colors') {
        renderZones(body);
        renderActions(body, index);
      } else if (step === 'addons') {
        renderAddons(body);
        renderActions(body, index);
      } else if (step === 'summary') {
        renderSummary(body, index, check, resolved);
      }
    }

    function optionCard(kind, field, row, selected, slot) {
      var card = el('label', 'dc-crib__opt' + (kind === 'checkbox' ? ' dc-crib__opt--check' : '') +
        (selected ? ' is-selected' : '') + (row.available ? '' : ' is-disabled'));
      var input = doc.createElement('input');
      var textBox = el('span', 'dc-crib__opt-text');
      var img = picture(slot, row.image, '', 96, { role: field === 'addon' ? 'addon' : field, key: row.key, colour: null, guideImage: row.guideImage });
      var i;
      var facts;
      input.type = kind;
      input.className = 'dc-crib__opt-input';
      input.name = uid + '-' + field + (kind === 'checkbox' ? '-' + row.key : '');
      input.value = row.key;
      input.checked = !!selected;
      input.disabled = !row.available;
      set(input, 'data-field', field);
      set(input, 'data-fk', field + ':' + row.key);
      put(textBox, el('span', 'dc-crib__opt-name', row.label));
      if (row.facts && row.facts.length) {
        facts = el('span', 'dc-crib__opt-facts');
        for (i = 0; i < row.facts.length; i++) {
          put(facts, el('span', 'dc-crib__opt-fact', row.facts[i]));
        }
        put(textBox, facts);
      }
      if (row.available && row.price !== null) {
        put(textBox, el('span', 'dc-crib__opt-price', money(row.price)));
      } else {
        put(textBox, el('span', 'dc-crib__opt-off', STR.unavailable));
      }
      put(card, input, put(el('span', 'dc-crib__opt-pic'), img), textBox, set(el('span', 'dc-crib__opt-mark'), 'aria-hidden', 'true'));
      return card;
    }

    function renderOptions(body, step) {
      var rows = core.optionsFor(rig, step, catalog);
      var group = el('fieldset', 'dc-crib__group');
      var grid = el('div', 'dc-crib__opts');
      var i;
      put(group, el('legend', 'dc-crib__sr', stepText(step).legend));
      for (i = 0; i < rows.length; i++) {
        put(grid, optionCard('radio', step, rows[i], state[step] === rows[i].key, 'opt:' + step + ':' + rows[i].key));
      }
      put(group, grid);
      body.appendChild(group);
    }

    function renderSizeChart(body) {
      var chart = DATA.sizeChart;
      var wrap;
      var table;
      var thead;
      var tbody;
      var tr;
      var cell;
      var i;
      var j;
      if (!chart || !chart.rows || !chart.columns) { return; }
      /* The roles keep the table readable for assistive technology on small screens, where
         the rows are laid out as cards. */
      wrap = el('div', 'dc-crib__chart');
      table = set(el('table', 'dc-crib__chart-table'), 'role', 'table');
      put(table, el('caption', 'dc-crib__chart-title', chart.title));
      thead = set(el('thead'), 'role', 'rowgroup');
      tr = set(el('tr'), 'role', 'row');
      for (j = 0; j < chart.columns.length; j++) {
        cell = el('th', '', chart.columns[j].label);
        set(cell, 'scope', 'col');
        set(cell, 'role', 'columnheader');
        put(tr, cell);
      }
      put(thead, tr);
      tbody = set(el('tbody'), 'role', 'rowgroup');
      for (i = 0; i < chart.rows.length; i++) {
        tr = set(el('tr'), 'role', 'row');
        for (j = 0; j < chart.columns.length; j++) {
          cell = el(j === 0 ? 'th' : 'td', '', chart.rows[i][chart.columns[j].key]);
          if (j === 0) { set(cell, 'scope', 'row'); }
          set(cell, 'role', j === 0 ? 'rowheader' : 'cell');
          set(cell, 'data-label', chart.columns[j].label);
          put(tr, cell);
        }
        put(tbody, tr);
      }
      put(table, thead, tbody);
      put(wrap, table, el('p', 'dc-crib__chart-note', STR.sizeChartNote));
      body.appendChild(wrap);
    }

    function swatch(field, sw, selected) {
      var card = el('label', 'dc-crib__sw' + (selected ? ' is-selected' : '') + (sw.available ? '' : ' is-disabled'));
      var input = doc.createElement('input');
      var chip = el('span', 'dc-crib__sw-chip' + (sw.pattern ? ' dc-crib__sw-chip--pattern' : ''));
      input.type = 'radio';
      input.className = 'dc-crib__sw-input';
      input.name = uid + '-' + field;
      input.value = sw.key;
      input.checked = !!selected;
      input.disabled = !sw.available;
      set(input, 'data-field', field);
      set(input, 'data-fk', field + ':' + sw.key);
      set(chip, 'aria-hidden', 'true');
      chip.style.background = str(sw.css || sw.hex);
      put(card, input, chip, put(el('span', 'dc-crib__sw-text'),
        el('span', 'dc-crib__sw-name', sw.label),
        sw.available ? null : el('span', 'dc-crib__sw-off', STR.unavailable)));
      return card;
    }

    function zonePrice(zone) {
      var i;
      for (i = 0; i < zone.swatches.length; i++) {
        if (zone.swatches[i].key === zone.value && zone.swatches[i].price !== null) { return zone.swatches[i].price; }
      }
      for (i = 0; i < zone.swatches.length; i++) {
        if (zone.swatches[i].available && zone.swatches[i].price !== null) { return zone.swatches[i].price; }
      }
      return null;
    }

    function zoneOpen(zone) {
      var i;
      for (i = 0; i < zone.swatches.length; i++) {
        if (zone.swatches[i].available) { return true; }
      }
      return false;
    }

    function renderSwatches(parent, zone, field) {
      var grid = el('div', 'dc-crib__sws');
      var i;
      for (i = 0; i < zone.swatches.length; i++) {
        put(grid, swatch(field, zone.swatches[i], zone.value === zone.swatches[i].key));
      }
      parent.appendChild(grid);
    }

    function yesNo(value, label, checked, disabled) {
      var card = el('label', 'dc-crib__yn' + (checked ? ' is-selected' : '') + (disabled ? ' is-disabled' : ''));
      var input = doc.createElement('input');
      input.type = 'radio';
      input.className = 'dc-crib__yn-input';
      input.name = uid + '-weightPocketsAnswer';
      input.value = value;
      input.checked = !!checked;
      input.disabled = !!disabled;
      set(input, 'data-field', 'weightPocketsAnswer');
      set(input, 'data-fk', 'weightPocketsAnswer:' + value);
      put(card, input, el('span', 'dc-crib__yn-name', label));
      return card;
    }

    function renderZones(body) {
      var zones = core.colorZonesFor(state, catalog);
      var i;
      var zone;
      var box;
      var legend;
      var price;
      var answered;
      var wantsPockets;
      var canSell;
      var inner;
      var colourLabel;
      var wrong;
      var note;
      for (i = 0; i < zones.length; i++) {
        zone = zones[i];
        price = zonePrice(zone);
        canSell = zoneOpen(zone);
        wrong = (alertFor && alertFor.step === 'colors' && alertFor.fields && has(alertFor.fields, zone.field)) ?
          alertFor.fields[zone.field] : '';
        box = el('fieldset', 'dc-crib__zone' + (wrong !== '' ? ' is-error' : ''));
        set(box, 'data-zone', zone.zone);
        if (wrong !== '') {
          set(box, 'aria-describedby', uid + '-zone-error-' + zone.zone);
          set(box, 'tabindex', '-1');
          set(box, 'data-fk', 'zone:' + zone.zone);
        }
        legend = el('legend', 'dc-crib__zone-head');
        put(legend,
          el('span', 'dc-crib__zone-name', zone.optional ? zone.label : fmt(STR.zoneColor, { zone: zone.label })),
          zone.optional ? el('span', 'dc-crib__zone-tag', STR.optional) : null);
        put(box, legend);
        if (wrong !== '') {
          note = el('p', 'dc-crib__zone-error', wrong);
          note.id = uid + '-zone-error-' + zone.zone;
          put(box, note);
        }
        put(box, put(el('p', 'dc-crib__zone-meta'),
          zone.productLabel ? el('span', 'dc-crib__zone-product', zone.productLabel) : null,
          (price !== null && canSell) ? el('span', 'dc-crib__zone-price', money(price)) : el('span', 'dc-crib__opt-off', STR.unavailable)));
        if (zone.note) { put(box, el('p', 'dc-crib__zone-note', zone.note)); }
        if (zone.zone === 'wing' && zone.swatches.length < DATA.colorOrder.length) {
          put(box, el('p', 'dc-crib__zone-note', fmt(STR.wingColorNote, { count: zone.swatches.length })));
        }

        if (zone.optional) {
          answered = state.weightPockets !== undefined;
          wantsPockets = answered && state.weightPockets !== null;
          put(box, el('p', 'dc-crib__zone-ask', zone.question || ''));
          put(box, put(el('div', 'dc-crib__yns'),
            yesNo('yes', STR.yes, wantsPockets, !canSell),
            yesNo('no', STR.no, answered && !wantsPockets, false)));
          if (wantsPockets) {
            inner = el('fieldset', 'dc-crib__zone-inner');
            put(inner, el('legend', 'dc-crib__zone-sub', fmt(STR.zoneColor, { zone: zone.label })));
            renderSwatches(inner, zone, zone.field);
            put(box, inner);
          }
        } else {
          renderSwatches(box, zone, zone.field);
        }

        colourLabel = (typeof zone.value === 'string' && has(DATA.colors, zone.value)) ? DATA.colors[zone.value].label : '';
        if (colourLabel !== '') {
          put(box, el('p', 'dc-crib__zone-chosen', fmt(STR.chosen, { value: colourLabel })));
        }
        body.appendChild(box);
      }
    }

    function renderAddons(body) {
      var rows = core.optionsFor(rig, 'addons', catalog);
      var group = el('fieldset', 'dc-crib__group');
      var grid = el('div', 'dc-crib__opts');
      var i;
      put(group, el('legend', 'dc-crib__sr', stepText('addons').legend));
      for (i = 0; i < rows.length; i++) {
        put(grid, optionCard('checkbox', 'addon', rows[i], state.addons.indexOf(rows[i].key) !== -1, 'opt:addon:' + rows[i].key));
      }
      put(group, grid);
      body.appendChild(group);
    }

    function primaryAction(where, check, resolved) {
      var btn;
      var label = STR.add;
      var off = false;
      if (lastAdded) { label = STR.addAgain; }
      if (added) {
        /* same focus key as the button it replaces, so the focus moves on to the link */
        btn = el('a', 'dc-crib__btn dc-crib__btn--primary', STR.viewCart);
        btn.href = cartUrl();
        set(btn, 'data-fk', where + ':add');
        return btn;
      }
      if (busy) {
        label = STR.adding;
        off = true;
      } else if (live.status === 'loading' || live.status === 'idle') {
        label = STR.checking;
        off = true;
      } else if (!check.ok || resolved.missing.length) {
        off = true;
      }
      btn = el('button', 'dc-crib__btn dc-crib__btn--primary', label);
      btn.type = 'button';
      /* While the build is on its way the button stays focusable (clicks are ignored while
         busy), otherwise the focus would drop to the top of the page. */
      btn.disabled = off && !busy;
      set(btn, 'data-act', 'add');
      set(btn, 'data-fk', where + ':add');
      if (busy) {
        set(btn, 'aria-busy', 'true');
        set(btn, 'aria-disabled', 'true');
      }
      return btn;
    }

    function renderSummary(body, index, check, resolved) {
      var list = el('ul', 'dc-crib__lines');
      var i;
      var line;
      var row;
      var img;
      var box;
      var row2;
      var back;
      var again;
      var blockers = [];
      var fixes = [];
      var seen = {};
      var msg;
      var fix;
      var leadFirst = leadTimeText !== '' && oneColumn === true;

      /* One column (phones): the lead time first, where it shows as the step opens. Further
         down it would sit under the bar at the bottom of the screen, whose own "Add build to
         cart" can be tapped without scrolling to it. Two columns: right above the button. */
      if (leadFirst) { put(body, leadNote(true)); }
      put(body, el('p', 'dc-crib__sr', STR.summaryLines));
      for (i = 0; i < resolved.lines.length; i++) {
        line = resolved.lines[i];
        row = el('li', 'dc-crib__line' + (line.available ? '' : ' is-off'));
        img = picture('line:' + line.role + ':' + (line.addon || ''), line.image, '', 64,
          { role: line.role, key: line.addon || line.sku, colour: line.colour, guideImage: guideFor(line.role, line) });
        put(row,
          put(el('span', 'dc-crib__line-pic'), img),
          put(el('span', 'dc-crib__line-text'),
            el('span', 'dc-crib__line-role', line.roleLabel),
            el('span', 'dc-crib__line-name', line.shopperLabel),
            el('span', 'dc-crib__line-sku', fmt(STR.partNumber, { sku: line.sku })),
            line.available ? null : el('span', 'dc-crib__opt-off', STR.unavailable)),
          el('span', 'dc-crib__line-price', money(line.price)));
        list.appendChild(row);
      }
      put(body, list);
      put(body, put(el('p', 'dc-crib__sum'),
        el('span', 'dc-crib__sum-label', STR.summaryTotal),
        el('strong', 'dc-crib__sum-value', money(resolved.total))));

      if (finalSaleText !== '') { put(body, el('p', 'dc-crib__note dc-crib__note--final', finalSaleText)); }
      if (showCashback) { put(body, el('p', 'dc-crib__note dc-crib__note--cash', STR.cashbackNote)); }
      if (live.status === 'partial') { put(body, el('p', 'dc-crib__note', STR.partial)); }

      for (i = 0; i < check.errors.length; i++) {
        if (!seen[check.errors[i].message]) {
          seen[check.errors[i].message] = true;
          blockers.push(check.errors[i].message);
        }
        if (steps.indexOf(check.errors[i].step) !== -1 && fixes.indexOf(check.errors[i].step) === -1) {
          fixes.push(check.errors[i].step);
        }
      }
      for (i = 0; i < resolved.missing.length; i++) {
        msg = fmt(STR.errors.partUnavailable, { name: resolved.missing[i].shopperLabel });
        if (!seen[msg]) {
          seen[msg] = true;
          blockers.push(msg);
        }
        fix = ROLE_STEP[resolved.missing[i].role];
        if (steps.indexOf(fix) !== -1 && fixes.indexOf(fix) === -1) { fixes.push(fix); }
      }
      if (addError !== '' || blockers.length) {
        box = alertBox();
        if (addError !== '') {
          put(box, el('p', 'dc-crib__alert-line', addError));
        } else {
          put(box, el('p', 'dc-crib__alert-line dc-crib__alert-line--lead', STR.errors.blocked));
        }
        for (i = 0; i < blockers.length; i++) {
          put(box, el('p', 'dc-crib__alert-line', blockers[i]));
        }
        for (i = 0; i < fixes.length; i++) {
          fix = el('button', 'dc-crib__link', fmt(STR.editStep, { step: stepLabel(fixes[i]) }));
          fix.type = 'button';
          set(fix, 'data-act', 'open');
          set(fix, 'data-step', fixes[i]);
          set(fix, 'data-fk', 'fix:' + fixes[i]);
          put(box, fix);
        }
        put(body, box);
      }

      if (added) {
        box = el('div', 'dc-crib__done');
        set(box, 'role', 'status');
        put(box,
          el('p', 'dc-crib__done-title', STR.addedTitle),
          el('p', 'dc-crib__done-text', fmt(STR.addedText, { id: added.buildId, count: added.count })));
        put(body, box);
      }

      if (lastAdded && !added) {
        put(body, el('p', 'dc-crib__note dc-crib__note--earlier', fmt(STR.addedEarlier, { id: lastAdded.buildId })));
      }

      /* two columns: the delivery time right above the button (the final sale words stay under
         the total) */
      if (leadTimeText !== '' && !leadFirst) { put(body, leadNote(false)); }
      row2 = el('div', 'dc-crib__actions');
      put(row2, primaryAction('sum', check, resolved));
      if (added) {
        again = el('button', 'dc-crib__btn dc-crib__btn--ghost', STR.restart);
        again.type = 'button';
        set(again, 'data-act', 'restart');
        set(again, 'data-fk', 'restart');
        put(row2, again);
      } else if (index > 0) {
        back = el('button', 'dc-crib__btn dc-crib__btn--ghost', STR.back);
        back.type = 'button';
        back.disabled = busy;
        set(back, 'data-act', 'back');
        set(back, 'data-fk', 'back');
        put(row2, back);
      }
      put(body, row2);
    }

    /* ---------------------------------------------------------------- render: bottom bar */

    function renderBar(check, resolved) {
      var complete = check.ok && !resolved.missing.length;
      var btn;
      var shown = totalFor(complete, resolved);
      setText(nodes.barLabel, shown[0]);
      setText(nodes.barValue, shown[1]);
      clear(nodes.barAction);
      if (steps[open] === 'summary') {
        btn = primaryAction('bar', check, resolved);
      } else {
        btn = el('button', 'dc-crib__btn dc-crib__btn--primary', nextLabel());
        btn.type = 'button';
        set(btn, 'data-act', 'next');
        set(btn, 'data-fk', 'bar:next');
      }
      put(nodes.barAction, btn);
    }

    /* ---------------------------------------------------------------- events */

    function onChange(evt) {
      var t = evt.target;
      var field;
      var before;
      if (!t || !isFn(t.getAttribute) || busy) { return; }
      field = t.getAttribute('data-field');
      if (!field) { return; }
      before = dock ? pictureKey() : '';
      if (applyField(field, t.value, t.checked)) {
        changed();
        notice = (field === 'harness' || field === 'wing') ? keptColourNotice() : '';
        /* a choice below the larger dock picture: it folds back so the options show */
        foldDock(false);
        render();
        if (dock && pictureKey() !== before) { pulseDock(); }
      }
    }

    /* A new wing or harness keeps the colours that were chosen before. The part behind a kept
       colour changes with it (shoulder pads follow the harness), and that part may not be sold
       in that colour right now. The shopper is told at the moment of the change, not three
       steps later. */
    function keptColourNotice() {
      var missing = resolveNow().missing;
      var out = '';
      var i;
      for (i = 0; i < missing.length; i++) {
        if (ROLE_STEP[missing[i].role] === 'colors') {
          out += (out ? ' ' : '') + fmt(STR.errors.partUnavailable, { name: missing[i].shopperLabel });
        }
      }
      return out;
    }

    function closestAct(node) {
      while (node && node !== host) {
        if (node.nodeType === 1 && node.getAttribute('data-act')) { return node; }
        node = node.parentNode;
      }
      return null;
    }

    function onClick(evt) {
      var t = closestAct(evt.target);
      var act;
      var index;
      /* any tap in the steps folds the larger dock picture back */
      foldDock(false);
      if (!t || t.disabled) { return; }
      act = t.getAttribute('data-act');
      if (busy) { return; }
      if (act === 'open') {
        index = steps.indexOf(t.getAttribute('data-step'));
        if (index !== -1) { goTo(index, false); }
      } else if (act === 'next') {
        nextStep();
      } else if (act === 'back') {
        goTo(open - 1, true);
      } else if (act === 'add') {
        addToCart();
      } else if (act === 'restart') {
        restart();
      }
    }

    function restart() {
      state = core.newState(rig);
      open = 0;
      furthest = 0;
      notice = '';
      changed();
      lastAdded = null;
      render();
      focusStep(0);
    }

    /* ---------------------------------------------------------------- cart */

    function cartUrl() {
      var r = win.theme && win.theme.routes && win.theme.routes.cart;
      if (typeof r === 'string' && r.charAt(0) === '/') { return r; }
      return routesRoot() + 'cart';
    }

    function fire(name, detail) {
      var evt;
      try {
        evt = new win.CustomEvent(name, { bubbles: true, detail: detail || {} });
      } catch (err) {
        try {
          evt = doc.createEvent('CustomEvent');
          evt.initCustomEvent(name, true, false, detail || {});
        } catch (err2) {
          return;
        }
      }
      doc.dispatchEvent(evt);
    }

    function drawerNode() {
      return doc.querySelector('cart-drawer') || doc.getElementById('cart-drawer');
    }

    function drawerShows(drawer, buildId) {
      var openNow = drawer.getAttribute('aria-hidden') === 'false' || drawer.hasAttribute('open');
      return openNow && str(drawer.textContent).indexOf(buildId) !== -1;
    }

    /* Uses the theme's own cart drawer: its cart-items refresh (or the refresh event the theme
       listens for), then the open event. If the drawer does not show the new build in time the
       shopper is taken to the cart page. */
    function openThemeCart(buildId) {
      var settings = win.theme && win.theme.settings;
      var drawer = drawerNode();
      var waits = [];
      var refreshed = false;
      var items;
      var i;
      var r;
      var started = Date.now();

      function leave() {
        if (!destroyed) { win.location.href = cartUrl(); }
      }
      function watch() {
        var d = drawerNode();
        if (d && drawerShows(d, buildId)) { return; }
        if (Date.now() - started > drawerWait) {
          leave();
          return;
        }
        later(watch, 200);
      }
      function show() {
        fire('dispatch:cart-drawer:open', { source: 'dc-crib' });
        later(watch, 200);
      }

      if (!drawer) { leave(); return; }
      if (settings && (settings.afterAtc === 'page' || (settings.cartType && settings.cartType !== 'drawer'))) {
        leave();
        return;
      }
      items = drawer.querySelectorAll('cart-items');
      for (i = 0; i < items.length; i++) {
        if (isFn(items[i].refresh)) {
          try {
            r = items[i].refresh();
            refreshed = true;
            if (r && isFn(r.then)) { waits.push(r); }
          } catch (err) { /* the event below is the second path */ }
        }
      }
      if (!refreshed) { fire('dispatch:cart-drawer:refresh', { source: 'dc-crib' }); }
      if (waits.length) {
        Promise.all(waits).then(show, show);
      } else {
        later(show, 400);
      }
    }

    function afterAdded(payload, response, info) {
      var skipTheme = false;
      if (isFn(opts.onAdded)) {
        skipTheme = true;
        try { opts.onAdded(payload, response, info); } catch (err) { warn('onAdded failed: ' + err); }
      }
      if (opts.openCart === false || (skipTheme && opts.openCart !== true)) { return; }
      fire('cart:updated', { source: 'dc-crib', buildId: info.buildId });
      openThemeCart(info.buildId);
    }

    function cartMessage(ans) {
      var d = ans && ans.data;
      var extra = '';
      if (d && typeof d.description === 'string' && d.description !== '') {
        extra = d.description;
      } else if (d && typeof d.message === 'string' && d.message !== '' && d.message !== 'Cart Error') {
        extra = d.message;
      }
      return STR.errors.addFailed + (extra !== '' ? ' ' + extra : '');
    }

    /* ---- the cart after an add that failed or never answered ---- */

    function jsonHeaders(withBody) {
      var h = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
      if (withBody) { h['Content-Type'] = 'application/json'; }
      return h;
    }

    /* The lines of the cart, or null when the cart could not be read. */
    function readCart() {
      return inTime(Promise.resolve().then(function () {
        return fetchImpl(routesRoot() + 'cart.js', { method: 'GET', credentials: 'same-origin', headers: jsonHeaders(false) });
      }).then(readAnswer)).then(function (ans) {
        var items = ans && ans.data ? ans.data.items : null;
        if (!ans.ok || !items || typeof items.length !== 'number') { return null; }
        return items;
      }, function () {
        return null;
      });
    }

    /* Cart lines that carry the id of one attempt. Nothing else is ever looked at. */
    function linesOf(items, buildId) {
      var P = core.PROPS;
      var out = [];
      var i;
      var props;
      for (i = 0; i < items.length; i++) {
        props = items[i] ? items[i].properties : null;
        if (props && typeof props === 'object' && (props[P.buildId] === buildId || props[P.partOf] === buildId)) {
          out.push(items[i]);
        }
      }
      return out;
    }

    function removeLines(lines) {
      var updates = {};
      var i;
      for (i = 0; i < lines.length; i++) {
        if (typeof lines[i].key !== 'string' || lines[i].key === '') { return Promise.resolve(false); }
        updates[lines[i].key] = 0;
      }
      return inTime(Promise.resolve().then(function () {
        return fetchImpl(routesRoot() + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: jsonHeaders(true),
          body: JSON.stringify({ updates: updates })
        });
      }).then(readAnswer)).then(function (ans) {
        return !!(ans.ok && ans.data && !(typeof ans.data.status === 'number' && ans.data.status >= 400));
      }, function () {
        return false;
      });
    }

    /* Looks for the lines of one attempt in the cart.
         all      every line is there: the add went through, only its answer was lost
         none     nothing arrived
         cleared  a part of the build arrived and was taken out again
         unknown  the cart could not be read or changed, the attempt stays open */
    function settle(attempt) {
      return readCart().then(function (items) {
        var lines;
        if (!items) { return { found: 'unknown', lines: [] }; }
        lines = linesOf(items, attempt.buildId);
        if (!lines.length) { return { found: 'none', lines: [] }; }
        if (lines.length >= attempt.count) { return { found: 'all', lines: lines }; }
        return removeLines(lines).then(function (ok) {
          return { found: ok ? 'cleared' : 'unknown', lines: [] };
        });
      });
    }

    function succeed(attempt, response) {
      busy = false;
      unsettled = null;
      lastAdded = null;
      added = { buildId: attempt.buildId, count: attempt.count, total: attempt.resolved.total };
      addError = '';
      render();
      afterAdded(attempt.payload, response, { buildId: attempt.buildId, state: attempt.snapshot, resolved: attempt.resolved });
    }

    /* An add that did not end well. The button comes back only after the cart was looked at, so
       a second click can never put the same build in the cart twice.
         how.refresh  the store refused the build (sold out, variant gone): read prices and stock again
         how.unsure   no answer arrived at all, so the cart is looked at once more before the next add */
    function failed(attempt, message, how) {
      settle(attempt).then(function (result) {
        if (destroyed) { return; }
        if (result.found === 'all') {
          succeed(attempt, { items: result.lines });
          return;
        }
        busy = false;
        unsettled = (result.found === 'unknown' || (how.unsure && result.found === 'none')) ? attempt : null;
        addError = message;
        if (how.refresh) {
          live.status = 'idle';
          liveProducts = {};
          clearCache();
        }
        render();
        focusAlert();
        if (how.refresh) { loadLive(); }
      });
    }

    function stop(message) {
      busy = false;
      addError = message;
      render();
      focusAlert();
    }

    function send() {
      var check = core.validate(state);
      var resolved = resolveNow();
      var bad = firstBadStep(check, resolved);
      var cartData = DATA.cart || {};
      var attempt;
      var payload;
      var buildId;
      var cancel = null;
      var init;

      if (bad !== -1) {
        busy = false;
        if (steps[bad] !== 'summary') {
          open = bad;
          alertFor = alertOf(steps[bad], check, resolved);
        }
        addError = STR.errors.changed;
        render();
        focusAlert();
        return;
      }
      /* An assembly charge that is switched on must be read before the build is priced: a
         product that could not be read is not the same as a product that is not for sale. */
      if (assemblyHandle !== '' && live.failed.indexOf(assemblyHandle) !== -1) {
        stop(STR.errors.refresh);
        return;
      }
      buildId = core.newBuildId();
      try {
        payload = core.cartPayload(state, resolved, buildId, {
          omitLink: cartData.omitLink === true,
          omitSheet: cartData.omitSheet === true
        });
      } catch (err) {
        if (!err || err.code !== 'CRIB_UNAVAILABLE') { warn('The build could not be prepared: ' + (err && err.message)); }
        stop((err && err.code === 'CRIB_UNAVAILABLE') ? STR.errors.changed : STR.errors.addFailed);
        return;
      }
      attempt = {
        buildId: buildId,
        count: payload.items.length,
        payload: payload,
        resolved: resolved,
        snapshot: copyState(state),
        config: core.configString(state)
      };
      init = {
        method: 'POST',
        credentials: 'same-origin',
        headers: jsonHeaders(true),
        body: JSON.stringify(payload)
      };
      try {
        if (isFn(win.AbortController)) {
          cancel = new win.AbortController();
          init.signal = cancel.signal;
        }
      } catch (err2) { cancel = null; }

      inTime(Promise.resolve().then(function () {
        return fetchImpl(routesRoot() + 'cart/add.js', init);
      }).then(readAnswer), ADD_TIMEOUT, function () {
        if (cancel) { cancel.abort(); }
      }).then(function (ans) {
        var code;
        if (destroyed) { return; }
        if (!ans.ok || !ans.data || (typeof ans.data.status === 'number' && ans.data.status >= 400)) {
          code = ans.status || (ans.data && typeof ans.data.status === 'number' ? ans.data.status : 0);
          failed(attempt, cartMessage(ans), { refresh: code === 422 || code === 404, unsure: false });
          return;
        }
        succeed(attempt, ans.data);
      }, function () {
        if (destroyed) { return; }
        failed(attempt, STR.errors.network, { refresh: false, unsure: true });
      });
    }

    function clearCache() {
      var store;
      var i;
      if (!useCache) { return; }
      try {
        store = storage();
        for (i = 0; store && i < handles.length; i++) { store.removeItem(cacheKey(handles[i])); }
      } catch (err) { /* nothing to clear */ }
    }

    /* What the shopper has confirmed on the Summary step: the choices and the total. */
    function confirmed() {
      return core.configString(state) + '|' + resolveNow().total;
    }

    /* Parts that could not be read live are read once more first, so the build is priced from
       current values whenever the storefront answers. When that read changes the build or its
       total (an add-on sold out, a price moved) nothing is sent: the Summary step shows the new
       build and the shopper presses the button again. */
    function readThenSend() {
      var before;
      if (live.status === 'partial' && live.failed.length) {
        before = confirmed();
        loadLive(live.failed).then(function () {
          if (destroyed) { return; }
          if (confirmed() !== before) {
            stop(STR.errors.changed);
            return;
          }
          busy = true;
          send();
        });
        return;
      }
      send();
    }

    function addToCart() {
      var attempt = unsettled;
      if (busy || added || !fetchImpl) { return; }
      if (live.status === 'loading' || live.status === 'idle') { return; }
      busy = true;
      addError = '';
      alertFor = null;
      render();
      if (!attempt) {
        readThenSend();
        return;
      }
      /* The last add never answered. The cart is looked at before anything new is sent. */
      settle(attempt).then(function (result) {
        if (destroyed) { return; }
        if (result.found === 'unknown') {
          stop(STR.errors.network);
          return;
        }
        unsettled = null;
        if (result.found === 'all') {
          if (attempt.config === core.configString(state)) {
            succeed(attempt, { items: result.lines });
            return;
          }
          /* that build is in the cart, and the shopper has changed the build since */
          lastAdded = { buildId: attempt.buildId, count: attempt.count, total: attempt.resolved.total };
          busy = false;
          render();
          return;
        }
        readThenSend();
      });
    }

    /* ---------------------------------------------------------------- start */

    function start() {
      var first;
      var index;
      catalog = buildCatalog();
      if (opts.state && typeof opts.state === 'object') {
        first = copyState(state);
        for (index in opts.state) {
          if (has(opts.state, index) && index !== 'rig') { first[index] = opts.state[index]; }
        }
        state = copyState(core.normalize(first));
      }
      build();
      ctl.viewer = viewer;
      /* loadLive can finish at once (warm cache, no fetch), so it runs before the first paint
         and the first paint already knows whether live values are still on their way. */
      loadLive();
      if (opts.step && steps.indexOf(opts.step) !== -1) {
        furthest = steps.indexOf(opts.step);
        goTo(furthest, false);
      } else {
        render();
      }
      stressPageLead();
      ready = true;
      /* phones: the dock at the top, shown once the observer says the big picture is gone */
      ensureDock();
      /* the first paint gave the picture its view buttons and total: measure it once more */
      if (viewer && mediaOf()) { queueSticky(); }
    }

    ctl.el = host;
    ctl.rig = rig;
    ctl.version = VERSION;
    ctl.viewer = null;
    ctl.getState = function () { return copyState(state); };
    ctl.setState = function (partial) {
      var k;
      for (k in partial) {
        if (has(partial, k) && k !== 'rig') { state[k] = partial[k]; }
      }
      state = copyState(core.normalize(state));
      changed();
      render();
      return ctl;
    };
    ctl.goTo = function (step) {
      var index = (typeof step === 'number') ? step : steps.indexOf(step);
      if (index !== -1) {
        furthest = Math.max(furthest, index);
        goTo(index, false);
      }
      return ctl;
    };
    ctl.refresh = function () {
      liveProducts = {};
      clearCache();
      return loadLive();
    };
    ctl.destroy = function () {
      var i;
      destroyed = true;
      for (i = 0; i < timers.length; i++) { win.clearTimeout(timers[i]); }
      timers = [];
      stopSticky();
      removeDock();
      host.removeEventListener('change', onChange);
      host.removeEventListener('click', onClick);
      for (i = 0; i < listeners.length; i++) {
        if (isFn(listeners[i].target.removeEventListener)) {
          listeners[i].target.removeEventListener(listeners[i].type, listeners[i].fn, listeners[i].capture);
        }
      }
      listeners = [];
      if (observer) {
        try { observer.disconnect(); } catch (err) { /* nothing to stop */ }
        observer = null;
      }
      /* The picture the snippet printed stays with its last layers, one of our own goes with
         the builder. */
      if (viewer) {
        try { viewer.destroy(); } catch (err2) { /* the builder still goes */ }
        viewer = null;
      }
      ctl.viewer = null;
      clear(host);
      host.classList.remove('dc-crib--ready');
      if (host.__dcCrib === ctl) { host.__dcCrib = null; }
    };

    start();
    return ctl;
  }

  /* ------------------------------------------------------------------ mounting */

  function defaults() {
    var cfg = (root && root.DCCribBuilderConfig && typeof root.DCCribBuilderConfig === 'object') ? root.DCCribBuilderConfig : {};
    return cfg;
  }

  function merged(options) {
    var out = {};
    var base = defaults();
    var k;
    for (k in base) {
      if (has(base, k)) { out[k] = base[k]; }
    }
    for (k in (options || {})) {
      if (has(options, k)) { out[k] = options[k]; }
    }
    return out;
  }

  function showWrapper(host, visible) {
    var node = host;
    host.hidden = !visible;
    while (node && node.parentNode && node.parentNode.nodeType === 1) {
      node = node.parentNode;
      if (node.classList && node.classList.contains('dc-crib-section')) {
        node.hidden = !visible;
        break;
      }
    }
  }

  /* The rig is known but the builder cannot start (data that does not parse, a script that
     failed). The template has the native buy buttons switched off, so the page says why there
     is nothing to press. Without a rig the section stays hidden, as before. */
  function showFallback(host, opts) {
    var named = trim((opts && opts.rig) || host.getAttribute('data-rig')).toLowerCase();
    var doc = host.ownerDocument;
    var note;
    if (RIG_KEYS.indexOf(named) === -1 || !doc || !isFn(doc.createElement)) {
      showWrapper(host, false);
      return;
    }
    while (host.firstChild) { host.removeChild(host.firstChild); }
    note = doc.createElement('p');
    note.className = 'dc-crib__fallback dc-crib__fallback--now';
    note.setAttribute('role', 'status');
    note.textContent = STR.fallback;
    host.appendChild(note);
    if (host.classList) { host.classList.add('dc-crib'); }
    showWrapper(host, true);
  }

  /* True while the node is part of its page. A page that cannot tell counts as yes. */
  function connected(node) {
    var doc = node && node.ownerDocument;
    var top = doc && doc.documentElement;
    if (!node || !top || !isFn(top.contains)) { return true; }
    return top.contains(node);
  }

  /* Builders started by mount(), so that the ones whose element has left the page can be
     destroyed (a theme editor re-render replaces the whole product section). */
  var mounted = [];

  function dropGone() {
    var keep = [];
    var c;
    var i;
    for (i = 0; i < mounted.length; i++) {
      c = mounted[i];
      if (!c || !c.el || c.el.__dcCrib !== c) { continue; }
      if (connected(c.el)) {
        keep.push(c);
      } else {
        c.destroy();
      }
    }
    mounted = keep;
  }

  /* Every builder inside scope (and scope itself) is destroyed. */
  function destroyIn(scope) {
    var list = [];
    var i;
    if (!scope || scope.nodeType !== 1) { return; }
    if (isFn(scope.hasAttribute) && scope.hasAttribute('data-dc-crib')) { list.push(scope); }
    if (isFn(scope.querySelectorAll)) {
      list = list.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-dc-crib]')));
    }
    for (i = 0; i < list.length; i++) {
      if (list[i].__dcCrib && isFn(list[i].__dcCrib.destroy)) { list[i].__dcCrib.destroy(); }
    }
    dropGone();
  }

  function mount(host, options) {
    var opts = merged(options);
    var core = opts.core || (root && root.DCCrib);
    var rig;
    var ctl;
    if (!host || host.nodeType !== 1) { return null; }
    if (host.__dcCrib && isFn(host.__dcCrib.destroy)) { host.__dcCrib.destroy(); }
    if (!core || !core.DATA || !isFn(core.stepsFor)) {
      warn('The core (DCCrib) or its data is missing. The builder was not started.');
      showFallback(host, opts);
      return null;
    }
    rig = trim(opts.rig || host.getAttribute('data-rig')).toLowerCase();
    if (core.RIGS.indexOf(rig) === -1) {
      rig = urlParam(host.getAttribute('data-rig-param') || RIG_PARAM).toLowerCase();
    }
    if (core.RIGS.indexOf(rig) === -1 || !core.stepsFor(rig).length) {
      showWrapper(host, false);
      return null;
    }
    showWrapper(host, true);
    try {
      ctl = createController(host, opts, core, rig);
    } catch (err) {
      warn('The builder could not start: ' + err);
      if (host.classList) { host.classList.remove('dc-crib--ready'); }
      showFallback(host, { rig: rig });
      return null;
    }
    host.__dcCrib = ctl;
    mounted.push(ctl);
    return ctl;
  }

  function mountAll(scope) {
    var doc = root && root.document;
    var list;
    var out = [];
    var i;
    if (!doc) { return out; }
    /* builders of a section that was replaced first let go of the page */
    dropGone();
    list = (scope && isFn(scope.querySelectorAll) ? scope : doc).querySelectorAll('[data-dc-crib]');
    for (i = 0; i < list.length; i++) {
      if (list[i].__dcCrib || list[i].hasAttribute('data-dc-crib-manual')) { continue; }
      out.push(mount(list[i], {}));
    }
    return out;
  }

  function autoMount() {
    var doc = root && root.document;
    if (!doc || defaults().autoMount === false || !isFn(doc.querySelectorAll)) { return; }
    try {
      mountAll();
      if (api.listening || !isFn(doc.addEventListener)) { return; }
      api.listening = true;
      if (doc.readyState === 'loading') {
        doc.addEventListener('DOMContentLoaded', function () { mountAll(); });
      }
      doc.addEventListener('shopify:section:load', function (evt) {
        mountAll(evt && evt.target);
      });
      /* The theme editor takes a section away (every block or setting edit re-renders the
         product section): its builders let go of the window, their observer and picture. */
      doc.addEventListener('shopify:section:unload', function (evt) {
        destroyIn(evt && evt.target);
      });
    } catch (err) {
      warn('Automatic start failed: ' + err);
    }
  }

  var api = {
    VERSION: VERSION,
    STRINGS: STR,
    ROLE_STEP: ROLE_STEP,
    listening: false,
    mount: mount,
    mountAll: mountAll,
    autoMount: autoMount,
    _internal: {
      fmt: fmt,
      safeImageUrl: safeImageUrl,
      sizedImage: sizedImage,
      slimProduct: slimProduct,
      readAnswer: readAnswer
    }
  };

  return api;
});
